import { VColorPicker, VMenu, VCol, VRow, VContainer, VIcon, VAvatar, VTextField, VTooltip, VPagination, VCardText, VCard, VImg, VListItemAvatar, VListItemTitle, VListItemSubtitle, VListItemContent, VListItem, VSpacer, VProgressCircular, VListItemGroup, VList, VDivider, VChip, VSimpleCheckbox, VListItemAction, VSelect, VAutocomplete, VBtn, VCardTitle, VCardActions, VDialog, VToolbarTitle, VToolbar, VExpandTransition, VBreadcrumbsItem, VBreadcrumbs, VListItemIcon, VBadge, VFileInput, ClickOutside, VSubheader, VNavigationDrawer, VDatePicker, VTimePicker, VAlert, VDataTable, VTab, VTabs, VTabItem, VTabsItems, VRadio, VRadioGroup, VForm, VSlideXTransition, VSlider, VTreeview, VCheckbox, VProgressLinear, VSlideXReverseTransition, VTextarea, VStepperStep, VStepperContent, VStepperItems, VStepper, VStepperHeader } from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { debounce, throttle, isEqual, isEmpty, cloneDeep, merge, groupBy, pickBy } from 'lodash';
import mdiIcons from '@mdi/svg/meta.json';
import { initials, isNullOrUndefined, isNullUndefinedOrEmptyString, utcVal, TimezonedDateTime, dateISOStringRegex, HHMMSSRegex, HHMMRegex, isNullUndefinedEmptyStringOrEmptyArray, getObjectValueByPath, setObjectValueByPath, validate, isRequired, isValidEmail, isValidUrl, downloadBlob, getDDMCoords, formatString, applyRules, isTrueOrTrueString, charMax, isGreatherOrEqualThan, isLessOrEqualThan } from '@tsyl/radon';
import { mask } from 'vue-the-mask';
import isPromise from 'is-promise';
import { parse, isValid, add } from 'date-fns';
import Sortable from 'sortablejs';
import { Fragment } from 'vue-fragment';
import { toStringHDMS } from 'ol/coordinate';
import Coordinates from 'coordinate-parser';
import { toLonLat, fromLonLat } from 'ol/proj';
import Inputmask from 'inputmask';

var DataTableFilter$2 = {
  clearFiltersButton: 'Clear Filters',
  search: 'Search',
  saveSelectedFiltersBtn: 'Save selected filters',
  saveSelectedFiltersCard: 'Save selected filters',
  savedFilters: 'Saved filters',
  name: 'Name',
  cancel: 'cancel',
  confirm: 'confirm'
};

var DataTable$1 = {
  chooseColumns: 'Choose Columns',
  noData: 'No Data',
  seeMore: 'See %{msg} more',
  allItemsAreSelected: 'All %{msg} items are selected.',
  clearSelection: 'Clear selection',
  allItemsOnThisPageAreSelected: 'All %{msg} items on this page are selected.',
  selectAll: 'Select all',
  items: 'items',
  itemsPerPage: 'Items per page',
  totalItems: 'Total Items'
};

var ColorIconPicker$1 = {
  preview: 'Preview:',
  noIconSelected: 'No icon selected',
  color: 'Color',
  icon: 'Icon'
};

var ColorPicker$1 = {
  color: 'Color'
};

var IconPicker$1 = {
  icon: 'Icon'
};

var ImagePicker$1 = {
  icon: 'Icon'
};

var MainNavigation$1 = {
  about: 'About %{msg}',
  notifications: 'Notifications'
};

var CustomerMerge$1 = {
  cancel: 'cancel',
  merge: 'merge',
  back: 'back',
  confirm: 'confirm'
};

var PersonMerge$1 = {
  confirm: 'CONFIRM',
  summary: 'Summary',
  back: 'Back',
  next: 'Next',
  cancel: 'Cancel',
  finish: 'Finish'
};

var LayerList$1 = {
  opacityOf: 'Opacity of %{msg}',
  couldntLoadLayer: "Couldn't load Layer",
  search: 'Search...'
};

var LayerFinder$1 = {
  serviceSelection: 'Service selection',
  layerSelection: 'Layer selection',
  addMapService: 'Add Map Service',
  search: 'Search...',
  cancel: 'Cancel',
  next: 'Next',
  finish: 'Finish',
  serviceType: 'Service type',
  serviceUrl: 'Service URL',
  authenticated: 'Authenticated',
  arcGisPortal: 'ArcGis Portal',
  username: 'Username',
  password: 'Password'
};

var SectionComments$1 = {
  comments: '{section} comments',
  noCommentsAdded: 'No comments added.',
  addCommentBtn: 'Add Comment',
  addCommentTitle: 'Add Comment',
  discard: 'Discard',
  save: 'Save'
};

var FeaturesFilter$1 = {
  value: 'Value',
  field: 'Field',
  fieldValue: 'Field Value',
  date: 'Date',
  unique: 'Unique',
  and: 'and',
  condition: 'condition',
  addExpression: 'Add expression',
  addASet: 'Add a set',
  uniqueValue: 'Unique Value'
};

var Snackbar$1 = {
  close: 'Close'
};

var en_US = {
  zapan: {
    DataTableFilter: DataTableFilter$2,
    DataTable: DataTable$1,
    ColorIconPicker: ColorIconPicker$1,
    ColorPicker: ColorPicker$1,
    IconPicker: IconPicker$1,
    ImagePicker: ImagePicker$1,
    MainNavigation: MainNavigation$1,
    CustomerMerge: CustomerMerge$1,
    PersonMerge: PersonMerge$1,
    LayerList: LayerList$1,
    LayerFinder: LayerFinder$1,
    SectionComments: SectionComments$1,
    FeaturesFilter: FeaturesFilter$1,
    Snackbar: Snackbar$1
  }
};

var DataTableFilter$1 = {
  clearFiltersButton: 'Limpiar Filtros',
  search: 'Buscar',
  saveSelectedFiltersBtn: 'Guardar los filtros seleccionados',
  saveSelectedFiltersCard: 'Guardar los filtros seleccionados',
  savedFilters: 'Filtros guardados',
  name: 'Nombre',
  cancel: 'cancelar',
  confirm: 'confirmar'
};

var DataTable = {
  chooseColumns: 'Elegir columnas',
  noData: 'Sin Datos',
  seeMore: 'Ver %{msg} más',
  allItemsAreSelected: 'Todos los %{msg} objetos estan seleccionados.',
  clearSelection: 'Limpiar la selección',
  alltemsOnThisPageAreSelected: 'Todos los %{msg} objetos en esta página estan seleccionados.',
  selectAll: 'Seleccionar todos los',
  items: 'objetos',
  itemsPerPage: 'Objetos por página',
  totalItems: 'Objetos Totales'
};

var ColorIconPicker = {
  preview: 'Vista previa:',
  noIconSelected: 'No se ha seleccionado ningún icono',
  color: 'Color',
  icon: 'Icono'
};

var ColorPicker = {
  color: 'Color'
};

var IconPicker = {
  icon: 'Icono'
};

var ImagePicker = {
  icon: 'Icono'
};

var MainNavigation = {
  about: 'Sobre %{msg}',
  notifications: 'Notificaciones'
};

var CustomerMerge = {
  cancel: 'cancelar',
  merge: 'combinar',
  back: 'atrás',
  confirm: 'confirmar'
};

var PersonMerge = {
  confirm: 'CONFIRMAR',
  summary: 'Resumen',
  back: 'Atrás',
  next: 'Siguiente',
  cancel: 'Cancelar',
  finish: 'Finalizar'
};

var LayerList = {
  opacityOf: 'Opacidad de %{msg}',
  couldntLoadLayer: 'No se pudo cargar la capa',
  search: 'Buscar...'
};

var LayerFinder = {
  serviceSelection: 'Selección de servicio',
  layerSelection: 'Selección de capa',
  addMapService: 'Añadir servicio de mapa',
  search: 'Buscar...',
  cancel: 'Cancelar',
  next: 'Siguiente',
  finish: 'Finalizar',
  serviceType: 'Tipo de servicio',
  serviceUrl: 'URL del servicio',
  authenticated: 'Autenticado',
  arcGisPortal: 'Portal de ArcGis',
  username: 'Usuario',
  password: 'Contraseña'
};

var SectionComments = {
  comments: 'Comentarios {section}',
  noCommentsAdded: 'No se han añadido comentarios.',
  addCommentBtn: 'Añadir comentario',
  addCommentTitle: 'Añadir comentario',
  discard: 'Descartar',
  save: 'Guardar'
};

var FeaturesFilter = {
  value: 'Valor',
  field: 'Campo',
  fieldValue: 'Valor del campo',
  date: 'Fecha',
  unique: 'Único',
  and: 'y',
  condition: 'condición',
  addExpression: 'Añadir expresión',
  addASet: 'Añadir conjunto',
  uniqueValue: 'Valor Único'
};

var Snackbar = {
  close: 'Cerrar'
};

var es_ES = {
  zapan: {
    DataTableFilter: DataTableFilter$1,
    DataTable,
    ColorIconPicker,
    ColorPicker,
    IconPicker,
    ImagePicker,
    MainNavigation,
    CustomerMerge,
    PersonMerge,
    LayerList,
    LayerFinder,
    SectionComments,
    FeaturesFilter,
    Snackbar
  }
};

/* eslint-disable camelcase */
var lang = {
  en_US,
  es_ES
};

Vue.config.productionTip = false;
Vue.config.devtools = false;

function getLocali18n() {
  if (!window.__ZAPAN_I18N) {
    Vue.use(VueI18n);
    const localI18n = new VueI18n({
      locale: window.__ZAPAN_I18N_LOCALE || 'en_US',
      fallbackLocale: 'en_US',
      messages: lang
    });
    window.__ZAPAN_I18N = localI18n;
  }

  return window.__ZAPAN_I18N;
}

var i18n = (componentName => {
  const prefix = `zapan.${componentName}.`;
  return {
    methods: {
      t(key, param1, param2) {
        return this.buildi18nFunction('t', key, param1, param2);
      },

      tc(key, param1, param2) {
        return this.buildi18nFunction('tc', key, param1, param2);
      },

      buildi18nFunction(functionName, key, param1, param2, param3, param4) {
        const completeKey = prefix + key;
        let i18nInstance;
        let functionNameInstance = functionName; // Check if parent project has i18n and has lang for this key.

        if (this && this.$i18n && this.$te && this.$te(completeKey)) {
          i18nInstance = this;
          functionNameInstance = '$' + functionName;
        } else {
          i18nInstance = getLocali18n();
        }

        if (param4) {
          return i18nInstance[functionNameInstance](completeKey, param1, param2, param3, param4);
        } else if (param3) {
          return i18nInstance[functionNameInstance](completeKey, param1, param2, param3);
        } else if (param2) {
          return i18nInstance[functionNameInstance](completeKey, param1, param2);
        } else {
          return i18nInstance[functionNameInstance](completeKey, param1);
        }
      }

    }
  };
});

var script$1f = {
  components: {
    VColorPicker: VColorPicker,
    VMenu: VMenu,
    VCol: VCol,
    VRow: VRow,
    VContainer: VContainer
  },
  mixins: [i18n('ColorPicker')],
  props: {
    /**
     * The value selected
     */
    value: {
      type: String,
      default: '#D57976',
      required: false
    }
  },
  data: () => ({
    premadeColors: ['#D57976', '#DD6C92', '#AE6EC3', '#8F78C8', '#7C87C6', '#7AB4F1', '#73C2F2', '#78CEDF', '#6DB4AC', '#93C58A', '#B7D38A', '#DFE684', '#F8D667', '#F3B961', '#EE906E', '#9D8981', '#95A4AD'],
    selectedColor: {
      hex: '#D57976'
    }
  }),

  created() {
    this.selectedColor.hex = this.value;
    if (this.premadeColors.indexOf(this.value) === -1) this.premadeColors.push(this.value);
  },

  methods: {
    setColor(color) {
      this.selectedColor.hex = color;
      /**
       * (v-model) Emit selected color
       * @property {string} color the selected color
       */

      this.$emit('input', color);
    },

    setCustomColor(selectedColor) {
      this.selectedColor.hex = selectedColor.hex;
      this.$emit('input', this.selectedColor.hex);
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('p', {
    staticClass: "caption mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.t('color')) + "\n      ")]), _vm._v(" "), _vm._l(_vm.premadeColors, function (color) {
    return _c('div', {
      key: color,
      staticClass: "square",
      class: {
        active: _vm.selectedColor.hex === color
      },
      style: {
        'background-color': color
      },
      on: {
        "click": function ($event) {
          return _vm.setColor(color);
        }
      }
    });
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('div', _vm._g({
          staticClass: "square square--bordered"
        }, on), [_c('svg', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z"
          }
        })])])];
      }
    }])
  }, [_vm._v(" "), _c('v-color-picker', {
    on: {
      "update:color": _vm.setCustomColor
    },
    model: {
      value: _vm.selectedColor,
      callback: function ($$v) {
        _vm.selectedColor = $$v;
      },
      expression: "selectedColor"
    }
  })], 1)], 2)], 1)], 1);
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1f = function (inject) {
  if (!inject) return;
  inject("data-v-608ffd10_0", {
    source: ".square[data-v-608ffd10]{width:1.5em;height:1.5em;cursor:pointer;border-radius:3px;display:inline-block;margin-right:.5em;position:relative}.square--bordered[data-v-608ffd10]{border:1px solid #393939}.square--bordered svg[data-v-608ffd10]{position:absolute;color:#393939;left:1px}.square.active[data-v-608ffd10]::before{position:absolute;top:-3px;left:2px;font-size:20px;color:#fff;font-family:\"Material Design Icons\";content:\"\\f012c\"}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1f = "data-v-608ffd10";
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, createInjector, undefined, undefined);

var __vue_component__$1E = __vue_component__$1D;

var icomoonIcons = [{
  name: 'droplet'
}, {
  name: 'camera'
}, {
  name: 'headphones'
}];

var bookmarkIcons = [{
  id: '690787DD-F7B0-4D32-A668-32657D3A3AE8',
  name: 'bookmark',
  codepoint: 'F00C0',
  aliases: ['turned-in'],
  tags: [],
  author: 'Google',
  version: '1.5.54'
}, {
  id: '379B9D93-434B-46E7-9ABC-CAFAB694B209',
  name: 'map-marker',
  codepoint: 'F034E',
  aliases: ['location', 'address-marker', 'location-on', 'place', 'room'],
  tags: ['Navigation', 'Geographic Information System'],
  author: 'Google',
  version: '1.5.54'
}, {
  id: '5659F8EC-377D-41D2-AB3A-52DC40815DC7',
  name: 'square',
  codepoint: 'F0764',
  aliases: [],
  tags: ['Shape'],
  author: 'Austin Andrews',
  version: '1.9.32'
}, {
  id: '59803983-F6CE-4D40-B83C-36D42C9464A9',
  name: 'circle',
  codepoint: 'F0765',
  aliases: ['lens'],
  tags: ['Shape'],
  author: 'Austin Andrews',
  version: '1.9.32'
}, {
  id: '78EC62FE-EC63-407F-BCF3-92C441398DDA',
  name: 'triangle',
  codepoint: 'F0536',
  aliases: [],
  tags: ['Shape'],
  author: 'Simran',
  version: '1.5.54'
}];

const sets = {
  mdi: {
    prefix: 'mdi',
    icons: mdiIcons
  },
  icomoon: {
    prefix: 'icon',
    icons: icomoonIcons
  },
  bookmark: {
    prefix: 'mdi',
    icons: bookmarkIcons
  }
};
/**
   * Color and icon picker
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/pickers)
   * @displayName ColorIconPicker
   * @author egrande dcrespo drodriguez
   * @since 0.1.0
   */

var script$1e = {
  components: {
    VIcon: VIcon,
    VAvatar: VAvatar,
    VCol: VCol,
    VRow: VRow,
    VColorPicker: VColorPicker,
    VMenu: VMenu,
    VTextField: VTextField,
    VTooltip: VTooltip,
    VPagination: VPagination,
    VContainer: VContainer,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [i18n('ColorIconPicker')],
  props: {
    /**
     * (v-model) Icon preselected. See example for object model.
     */
    value: {
      type: Object,
      default: () => ({})
    },

    /**
     * Icon set. `mdi`, `icomoon` or `bookmark`
     */
    iconSet: {
      type: String,
      default: 'mdi',
      required: false
    },

    /**
     * show icon preview
     */
    preview: {
      type: Boolean,
      default: true,
      required: false
    },

    /**
     * Set icon like Icon or filled like an Avatar
     */
    likeIcon: {
      type: Boolean,
      default: false,
      required: false
    },

    /**
     * Show search input box
     */
    searchBox: {
      type: Boolean,
      default: true,
      required: false
    },

    /**
     * Show pagination
     */
    pagination: {
      type: Boolean,
      default: true,
      required: false
    },

    /**
     * Default colors list
     */
    premadeColors: {
      type: Array,
      default: () => ['#D57976', '#DD6C92', '#AE6EC3', '#8F78C8', '#7C87C6', '#7AB4F1', '#73C2F2', '#78CEDF', '#6DB4AC', '#93C58A', '#B7D38A', '#DFE684', '#F8D667', '#F3B961', '#EE906E', '#9D8981', '#95A4AD', '#545454']
    }
  },
  data: () => ({
    page: 1,
    searching: false,
    search: '',
    selectedIcon: null,
    selectedColor: {
      hex: null,
      rgb: null
    }
  }),

  created() {
    this.icons = sets[this.iconSet].icons;
    this.selectedIcon = this.value.icon;
    this.selectedColor = this.value.color;
  },

  watch: {
    iconSet() {
      this.icons = sets[this.iconSet].icons;
      this.page = 1;
    }

  },
  computed: {
    filteredIcons() {
      if (!this.search) {
        return this.icons.slice((this.page - 1) * 30, this.page * 30).map(i => `${sets[this.iconSet].prefix}-${i.name}`);
      }

      return this.icons.filter(i => i.name.includes(this.search)).slice((this.page - 1) * 30, this.page * 30).map(i => `${sets[this.iconSet].prefix}-${i.name}`);
    },

    pageNumber: {
      get() {
        if (!this.search) {
          return Math.ceil(this.icons.length / 30);
        }

        return Math.ceil(this.icons.filter(i => i.name.includes(this.search)).length / 30);
      },

      cache: false
    },

    selectedColorIconSvg() {
      const snakeToCamel = str => str.toLowerCase().replace(/([-_][a-z])/g, group => group.toUpperCase().replace('-', '').replace('_', ''));

      const iconName = snakeToCamel(this.selectedIcon);

      const iconSvgCode = require('@mdi/js')[iconName];

      const svg = `<svg xmlns="http://www.w3.org/2000/svg" id="${this.selectedIcon}" version="1.1" width="100" height="100" viewBox="0 0 24 24">` + `<path d="${iconSvgCode}" fill="${this.selectedColor.rgb}" /></svg>`;
      return svg;
    }

  },
  methods: {
    emitChanges() {
      /**
       * Update color. See example for object model.
       * @property {object} data
      */
      this.$emit('input', {
        icon: this.selectedIcon,
        color: {
          hex: this.selectedColor.hex,
          rgb: this.selectedColor.rgb || this.hexToRgb(this.selectedColor.hex)
        },
        svg: this.selectedColorIconSvg
      });
    },

    setIcon(icon) {
      this.selectedIcon = icon;
      this.emitChanges();
    },

    setColor(color) {
      this.selectedColor.hex = color;
      this.selectedColor.rgb = this.hexToRgb(color);
      this.emitChanges();
    },

    setColorFromPicker(colorObject) {
      this.selectedColor.hex = colorObject.hex;
      this.selectedColor.rgb = `rgb(${colorObject.rgba.r}, ${colorObject.rgba.g}, ${colorObject.rgba.b})`;
      this.emitChanges();
    },

    hexToRgb(hex) {
      const bigint = parseInt(hex.split('#')[1], 16);
      const r = bigint >> 16 & 255;
      const g = bigint >> 8 & 255;
      const b = bigint & 255;
      return `rgb(${r}, ${g}, ${b})`;
    },

    doSearch: debounce(function (val) {
      this.search = val;
    }, 1000)
  }
};

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', [_vm.preview ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('p', {
    staticClass: "body-1 mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.t("preview")) + "\n        "), _vm.selectedIcon && !_vm.likeIcon ? _c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "color": _vm.selectedColor.hex,
      "size": "32"
    }
  }, [_vm.iconSet ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedIcon) + "\n          ")]) : _vm._e()], 1) : _vm.likeIcon ? _c('v-avatar', {
    staticClass: "ml-2",
    attrs: {
      "size": "32"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.selectedColor.hex
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedIcon) + "\n          ")])], 1) : !_vm.selectedIcon ? _c('span', [_vm._v("\n          " + _vm._s(_vm.t("noIconSelected")))]) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('p', {
    staticClass: "caption mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.t("color")) + "\n      ")]), _vm._v(" "), _vm._l(_vm.premadeColors, function (color) {
    return _c('div', {
      key: color,
      staticClass: "square",
      class: {
        active: _vm.selectedColor.hex === color
      },
      style: {
        'background-color': color
      },
      on: {
        "click": function ($event) {
          return _vm.setColor(color);
        }
      }
    });
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('div', _vm._g({
          staticClass: "square square--bordered"
        }, on), [_c('svg', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill": "currentColor",
            "d": "M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z"
          }
        })])])];
      }
    }])
  }, [_vm._v(" "), _c('v-color-picker', {
    staticClass: "no-alpha",
    attrs: {
      "value": _vm.selectedColor
    },
    on: {
      "input": _vm.setColorFromPicker
    }
  })], 1)], 2)], 1), _vm._v(" "), _vm.iconSet ? _c('v-row', [_c('v-col', [_c('p', {
    staticClass: "caption mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.t("icon")) + "\n      ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "border-top": "3px solid #1976d2"
    }
  }, [_c('v-card-text', [_vm.searchBox ? _c('v-text-field', {
    attrs: {
      "filled": "",
      "dense": "",
      "append-icon": "mdi-magnify",
      "rounded": "",
      "clearable": "",
      "hide-details": "",
      "placeholder": "Search icons..."
    },
    on: {
      "input": _vm.doSearch
    }
  }) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, _vm._l(_vm.filteredIcons, function (icon) {
    return _c('v-col', {
      key: icon,
      staticClass: "px-1 d-flex justify-center"
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          return [_c('v-icon', _vm._g({
            on: {
              "click": function ($event) {
                return _vm.setIcon(icon);
              }
            }
          }, on), [_vm._v("\n                      " + _vm._s(icon) + "\n                    ")])];
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(icon))])])], 1);
  }), 1), _vm._v(" "), _vm.pagination ? _c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('v-pagination', {
    attrs: {
      "color": "accent",
      "length": _vm.pageNumber,
      "total-visible": "5"
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1e = function (inject) {
  if (!inject) return;
  inject("data-v-44dd9ef6_0", {
    source: ".square[data-v-44dd9ef6]{width:1.5em;height:1.5em;cursor:pointer;border-radius:3px;display:inline-block;margin-right:.5em;position:relative}.square--bordered[data-v-44dd9ef6]{border:1px solid #393939}.square--bordered svg[data-v-44dd9ef6]{position:absolute;color:#393939;left:1px}.square.active[data-v-44dd9ef6]::before{position:absolute;top:-3px;left:2px;font-size:20px;color:#fff;font-family:\"Material Design Icons\";content:\"\\f012c\"}.no-alpha[data-v-44dd9ef6]  .v-color-picker__controls .v-color-picker__preview .v-color-picker__sliders .v-color-picker__alpha{display:none}.no-alpha[data-v-44dd9ef6]  .v-color-picker__controls .v-color-picker__edit .v-color-picker__input:last-child{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1e = "data-v-44dd9ef6";
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, createInjector, undefined, undefined);

var __vue_component__$1C = __vue_component__$1B;

/**
 * images picker
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/pickers)
 * @displayName ImagePicker
 * @author egrande
 * @since 0.3.0
 */

var script$1d = {
  components: {
    VTextField: VTextField,
    VAvatar: VAvatar,
    VImg: VImg,
    VTooltip: VTooltip,
    VCol: VCol,
    VRow: VRow,
    VPagination: VPagination,
    VContainer: VContainer,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [i18n('IconPicker')],
  props: {
    /**
     * Selected value
     */
    value: {
      type: Object,
      default: () => ({}),
      required: false
    },

    /**
     * List of images <br>
     * <code>
     * { name: 'imageName', path: 'path' },
     * </code>
     */
    images: {
      type: Array,
      required: true
    },

    /**
     * Image width in list
     */
    imageWidth: {
      type: String,
      default: 'auto'
    },

    /**
     * Image height in list
     */
    imageHeight: {
      type: String,
      default: 'auto'
    },

    /**
     * Enable rectangular thumbnails
     */
    rect: {
      type: Boolean,
      default: false
    },

    /**
     * pagination size
     */
    pageSize: {
      type: Number,
      default: 30
    }
  },
  data: () => ({
    page: 1,
    search: ''
  }),
  methods: {
    doSearch: debounce(function (val) {
      this.search = val;
    }, 1000)
  },
  computed: {
    filteredImages() {
      if (!this.search) {
        return this.images.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
      }

      return this.images.filter(i => i.name.toLowerCase().includes(this.search.toLowerCase())).slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    },

    pageNumber() {
      if (!this.search) {
        return Math.ceil(this.images.length / this.pageSize);
      }

      return Math.ceil(this.images.filter(i => i.name.toLowerCase().includes(this.search.toLowerCase())).length / this.pageSize);
    }

  }
};

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', [_c('v-row', [_c('v-col', [_c('p', {
    staticClass: "caption mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.t('icon')) + "\n      ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "border-top": "3px solid #1976d2"
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "filled": "",
      "dense": "",
      "append-icon": "mdi-magnify",
      "rounded": "",
      "clearable": "",
      "hide-details": "",
      "placeholder": "Search icons..."
    },
    on: {
      "input": _vm.doSearch
    }
  }), _vm._v(" "), _c('v-container', {
    ref: "imageContainer",
    staticClass: "pb-0"
  }, [_c('v-row', _vm._l(_vm.filteredImages, function (image) {
    return _c('v-col', {
      key: image.name,
      staticClass: "flex-grow-0 cosas"
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          return [!_vm.rect ? _c('v-avatar', _vm._g({
            staticClass: "zapan-picker-image",
            class: {
              'zapan-picker-image--focus': _vm.value.name === image.name
            },
            attrs: {
              "size": _vm.imageWidth,
              "tabindex": "0"
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('input', image);
              }
            }
          }, on), [_c('img', {
            style: "width: " + _vm.imageWidth + "px; cursor: pointer;",
            attrs: {
              "src": image.path,
              "alt": image.name
            }
          })]) : _c('div', [_c('v-img', _vm._g({
            staticClass: "zapan-picker-image",
            class: {
              'zapan-picker-image--focus': _vm.value.name === image.name
            },
            attrs: {
              "height": _vm.imageHeight,
              "width": _vm.imageWidth,
              "src": image.path,
              "alt": image.name,
              "tabindex": "0"
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('input', image);
              }
            }
          }, on))], 1)];
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(image.name))])])], 1);
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('v-pagination', {
    attrs: {
      "color": "accent",
      "length": _vm.pageNumber,
      "total-visible": "5"
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1d = function (inject) {
  if (!inject) return;
  inject("data-v-068ebdc2_0", {
    source: ".zapan-picker-image--focus[data-v-068ebdc2],.zapan-picker-image[data-v-068ebdc2]:focus{box-shadow:0 0 5px 5px var(--v-primary-base,#a21e25);outline:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1d = "data-v-068ebdc2";
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, createInjector, undefined, undefined);

var __vue_component__$1A = __vue_component__$1z;

/**
   * Material design icons picker
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/pickers)
   * @displayName IconPicker
   * @author egrande
   * @since 0.3.0
   */

var script$1c = {
  components: {
    VTextField: VTextField,
    VIcon: VIcon,
    VTooltip: VTooltip,
    VCol: VCol,
    VRow: VRow,
    VPagination: VPagination,
    VContainer: VContainer,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [i18n('IconPicker')],
  props: {
    /**
     * The selected value
     */
    value: {
      type: String,
      default: 'mdi-account',
      required: false
    },

    /**
     * Page size
     */
    pageSize: {
      type: Number,
      default: 36
    }
  },
  data: () => ({
    page: 1,
    search: ''
  }),
  methods: {
    doSearch: debounce(function (val) {
      this.search = val;
    }, 1000)
  },
  computed: {
    filteredIcons() {
      if (!this.search) {
        return mdiIcons.slice((this.page - 1) * this.pageSize, this.page * this.pageSize).map(i => `mdi-${i.name}`);
      }

      return mdiIcons.filter(i => i.name.toLowerCase().includes(this.search.toLowerCase())).slice((this.page - 1) * this.pageSize, this.page * this.pageSize).map(i => `mdi-${i.name}`);
    },

    pageNumber() {
      if (!this.search) {
        return Math.ceil(mdiIcons.length / this.pageSize);
      }

      return Math.ceil(mdiIcons.filter(i => i.name.toLowerCase().includes(this.search.toLowerCase())).length / this.pageSize);
    }

  }
};

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$1c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', [_c('v-row', [_c('v-col', [_c('p', {
    staticClass: "caption mb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.t('icon')) + "\n      ")]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "border-top": "3px solid #1976d2"
    }
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "filled": "",
      "dense": "",
      "append-icon": "mdi-magnify",
      "rounded": "",
      "clearable": "",
      "hide-details": "",
      "placeholder": "Search icons..."
    },
    on: {
      "input": _vm.doSearch
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, _vm._l(_vm.filteredIcons, function (icon) {
    return _c('v-col', {
      key: icon,
      staticClass: "px-1 d-flex justify-center"
    }, [_c('v-tooltip', {
      attrs: {
        "right": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          return [_c('v-icon', _vm._g({
            attrs: {
              "color": _vm.value === icon ? 'accent' : ''
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('input', icon);
              }
            }
          }, on), [_vm._v("\n                      " + _vm._s(icon) + "\n                    ")])];
        }
      }], null, true)
    }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(icon))])])], 1);
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pb-0"
  }, [_c('v-pagination', {
    attrs: {
      "color": "accent",
      "length": _vm.pageNumber,
      "total-visible": "5"
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1c = undefined;
/* scoped */

const __vue_scope_id__$1c = "data-v-361ef51a";
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

var __vue_component__$1y = __vue_component__$1x;

var script$1b = {
  components: {
    VIcon: VIcon,
    VListItemAvatar: VListItemAvatar,
    VListItemTitle: VListItemTitle,
    VListItemSubtitle: VListItemSubtitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  methods: {
    initials
  }
};

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-list-item', {
    attrs: {
      "value": _vm.index
    }
  }, [_c('v-list-item-avatar', [_c('v-icon', {
    class: [_vm.item.iconClass]
  }, [_vm._v("\n      " + _vm._s(_vm.item.icon || _vm.initials(_vm.item.name)) + "\n    ")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "textContent": _vm._s(_vm.item.name)
    }
  }), _vm._v(" "), _c('v-list-item-subtitle', {
    domProps: {
      "textContent": _vm._s(_vm.item.subtitle)
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1b = undefined;
/* scoped */

const __vue_scope_id__$1b = "data-v-c7665130";
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

/**
   * Vertical item list with a search field and auto request with scroll
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/searchable-list)
   * @displayName SearchableList
   * @author dcrespo
   * @since 0.4.0
   */

var script$1a = {
  components: {
    DefaultItem: __vue_component__$1w,
    VSpacer: VSpacer,
    VRow: VRow,
    VTextField: VTextField,
    VContainer: VContainer,
    VListItem: VListItem,
    VProgressCircular: VProgressCircular,
    VListItemGroup: VListItemGroup,
    VList: VList,
    VDivider: VDivider,
    VCard: VCard
  },
  props: {
    /**
     * (v-model) clicked element
     */
    value: {
      type: Object,
      default: null
    },

    /**
     * Key property for items.
     */
    itemKey: {
      type: [Number, String],
      default: null
    },

    /**
     * List of items. <br>
     * You can use these values to show the default layout or use any with the element slot<br>
     * `{ id: 1, name: 'name', icon: 'mdi-icon', subtitle: 'subtitle' }`
     */
    items: {
      type: Array,
      default: null
    },

    /**
     * Component title
     */
    title: {
      type: String,
      default: 'List'
    },

    /**
     * Show a loading animation at the end of the list
     */
    loading: {
      type: Boolean,
      default: false
    },

    /**
     * Async function. Parameters: `page`, `search`. Is called when the scroll reaches the bottom<br>
     * items alternative.
     */
    list: {
      type: Function,
      default: null
    },

    /**
     * Placeholder for search field
     */
    placeholder: {
      type: String,
      default: 'Search...'
    },

    /**
     * Any change of this prop exec doReset() method
     */
    reset: {
      type: [Number, String, Object, Array, Boolean],
      default: null
    }
  },

  data() {
    return {
      selectedItem: null,
      search: '',
      // For scroll loading \/
      scrollPercent: 0,
      page: 1,
      total: 0,
      localLoading: false,
      localItems: []
    };
  },

  computed: {
    isLoading() {
      return this.loading || this.localLoading;
    },

    itemsList() {
      return this.items || this.localItems;
    }

  },

  created() {
    const that = this;
    this.onScroll = throttle(event => {
      const element = event.target;

      if (element) {
        const totalHeight = element.scrollHeight;
        const actualScroll = element.scrollTop + element.clientHeight;
        that.scrollPercent = actualScroll / totalHeight;
        that.$emit('scroll', {
          event,
          percent: that.scrollPercent
        });
      }
    }, 100);
    this.loadList();
  },

  mounted() {
    var _this$$refs$list;

    (_this$$refs$list = this.$refs.list) === null || _this$$refs$list === void 0 ? void 0 : _this$$refs$list.$el.addEventListener('scroll', this.onScroll);
  },

  destroyed() {
    var _this$$refs$list2;

    (_this$$refs$list2 = this.$refs.list) === null || _this$$refs$list2 === void 0 ? void 0 : _this$$refs$list2.$el.removeEventListener('scroll', this.onScroll);
  },

  watch: {
    selectedItem(value) {
      /**
       * For v-model, update the selected item.
       * @property {object} item - item selected
       */
      this.$emit('input', this.itemsList[value]);
    },

    value(val) {
      if (this.itemKey && !isNullOrUndefined(val)) {
        this.selectedItem = this.itemsList.findIndex(a => a[this.itemKey] === val[this.itemKey]);
      }
    },

    scrollPercent(value) {
      if (value > 0.75 && !this.localLoading && this.localItems.length < this.total) {
        this.loadList();
      }
    },

    reset() {
      this.doReset();
    }

  },
  methods: {
    onSearch(value) {
      /**
       * Search value
       * @property {string} value - search field value
       */
      this.$emit('search', value);
    },

    /**
     * Clear search and reset table pagination.
     * @public
     */
    async doReset() {
      this.page = 1;
      let selectedKey = null;

      if (this.itemKey) {
        const item = this.itemsList[this.selectedItem];

        if (item) {
          selectedKey = item[this.itemKey];
        }
      }

      this.localItems = [];
      await this.loadList();

      if (selectedKey) {
        this.selectedItem = this.itemsList.findIndex(a => a[this.itemKey] === selectedKey);
      }
    },

    async loadList() {
      if (this.list) {
        this.localLoading = true;
        const [items, total] = await this.list(this.page, this.search);
        this.localItems.push(...items);
        this.total = total;
        this.page++;
        this.localLoading = false; // keep request if no scroll created

        this.$nextTick(() => {
          var _this$$refs$list3;

          const element = (_this$$refs$list3 = this.$refs.list) === null || _this$$refs$list3 === void 0 ? void 0 : _this$$refs$list3.$el;

          if (this.localItems.length < this.total && element && element.scrollHeight === element.clientHeight) {
            this.loadList();
          }
        });
      }
    }

  }
};

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "searchable-list d-flex flex-column",
    attrs: {
      "outlined": "",
      "flat": ""
    }
  }, [_c('v-container', {
    staticClass: "searchable-list__header"
  }, [_c('v-row', [_c('h2', {
    staticClass: "searchable-list__header__title ml-3"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("action")], 2), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-5",
    attrs: {
      "clearable": "",
      "dense": "",
      "solo": "",
      "outlined": "",
      "flat": "",
      "rounded": "",
      "label": _vm.placeholder
    },
    on: {
      "input": _vm.onSearch,
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.doReset.apply(null, arguments);
      },
      "click:clear": function ($event) {
        _vm.$nextTick(function () {
          return _vm.$nextTick(function () {
            return _vm.doReset();
          });
        });
      }
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    ref: "list",
    staticClass: "searchable-list__content"
  }, [_c('v-list-item-group', {
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v;
      },
      expression: "selectedItem"
    }
  }, [_vm._l(_vm.itemsList, function (item, index) {
    return [_vm.$scopedSlots.element ? _c('v-list-item', {
      key: index,
      attrs: {
        "value": index
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('click', item);
        }
      }
    }, [_vm._t("element", null, {
      "item": item
    })], 2) : _c('default-item', {
      key: index,
      attrs: {
        "item": item,
        "index": index
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('click', item);
        }
      }
    })];
  }), _vm._v(" "), _vm.isLoading ? _c('v-list-item', {
    staticClass: "d-flex justify-center",
    attrs: {
      "disabled": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._t("footer")], 2);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1a = function (inject) {
  if (!inject) return;
  inject("data-v-fa64877c_0", {
    source: ".searchable-list{height:100%}.searchable-list .searchable-list__header{background-color:#ebebeb;flex-grow:unset}.searchable-list .searchable-list__header .searchable-list__header__title{align-items:center;font-size:16pt;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.searchable-list .searchable-list__content{padding-top:0;height:100%;overflow-y:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, createInjector, undefined, undefined);

var __vue_component__$1v = __vue_component__$1u;

//
//
//
//
//
//
//
//
//
//
//
//

/**
 * vuetify v-card with top border
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/bordered-card)
 * @displayName BorderedCard
 * @author egrande
 * @since 0.2.0
 */

var script$19 = {
  components: {
    VCardText: VCardText,
    VCard: VCard
  },
  props: {
    /**
     * Denotes the target route of the link.
     */
    to: {
      type: String,
      required: false,
      default: null
    },

    /**
     * Designates the component as anchor and applies the href attribute.
     */
    href: {
      type: String,
      required: false,
      default: null
    }
  }
};

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "v-card--border",
    attrs: {
      "to": _vm.to,
      "href": _vm.href
    }
  }, [_vm._t("title"), _vm._v(" "), _c('v-card-text', [_vm._t("default")], 2)], 2);
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$19 = function (inject) {
  if (!inject) return;
  inject("data-v-d20c73bc_0", {
    source: ".v-card--border[data-v-d20c73bc]{border-top:3px solid var(--v-accent-base,#82b1ff)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$19 = "data-v-d20c73bc";
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, createInjector, undefined, undefined);

var __vue_component__$1t = __vue_component__$1s;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$18 = {
  components: {
    VChip: VChip,
    VCol: VCol
  },
  props: {
    filterWithValues: {
      type: Array,
      required: true
    },
    refs: {
      type: Object,
      required: true
    }
  },
  computed: {
    flatValues() {
      const items = [];

      for (const {
        filter,
        value
      } of this.filterWithValues) {
        if (this.refs[filter.field]) {
          let formattedVal;

          if (filter.type === 'range') {
            formattedVal = value.join(' - ');
          } else if (filter.type === 'daterange') {
            let format = 'yyyy-MM-dd';

            if (filter.attrs && filter.attrs.format) {
              format = filter.attrs.format;
            }

            const formattedSrings = [this.refs[filter.field][0].$refs.component.$children[0].dateObj.format(format), this.refs[filter.field][0].$refs.component.$children[0].dateObjRange.format(format)];
            formattedVal = formattedSrings.join(' ~ ');
          } else if (filter.type === 'date') {
            try {
              let format = 'yyyy-MM-dd';

              if (filter.attrs && filter.attrs.format) {
                format = filter.attrs.format;
              }

              formattedVal = this.refs[filter.field][0].$refs.component.$children[0].dateObj.format(format);
            } catch (ex) {
              // eslint-disable-next-line no-console
              console.error(ex);
            }
          } else if (Array.isArray(value)) {
            for (const valueUniq of value) {
              items.push({
                filter,
                value: valueUniq
              });
            }
          } else {
            formattedVal = value;
          }

          if (formattedVal) {
            items.push({
              filter,
              value: formattedVal
            });
          }
        }
      }

      return items;
    }

  }
};

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-col', {
    staticClass: "list-of-chips"
  }, [_vm._l(_vm.flatValues, function (item) {
    return _vm._t('chip.' + item.filter.field, function () {
      return [_c('v-chip', {
        staticClass: "ma-1",
        attrs: {
          "close": "",
          "small": ""
        },
        on: {
          "click:close": function ($event) {
            return _vm.$emit('remove', item);
          }
        }
      }, [_vm._v("\n      " + _vm._s(item.filter.label) + ": " + _vm._s(item.value[item.filter.itemtext || 'name'] || item.value) + "\n    ")])];
    }, {
      "close": function () {
        _vm.$emit('remove', item);
      },
      "filter": item.filter,
      "value": item.value
    });
  })], 2);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$18 = function (inject) {
  if (!inject) return;
  inject("data-v-59b02832_0", {
    source: ".list-of-chips[data-v-59b02832]{max-height:64px;overflow-y:auto;padding-top:0;padding-bottom:0;white-space:normal}.list-of-chips[data-v-59b02832]::-webkit-scrollbar-track{background-color:#f5f5f5}.list-of-chips[data-v-59b02832]::-webkit-scrollbar{width:4px;height:4px;background-color:#f5f5f5}.list-of-chips[data-v-59b02832]::-webkit-scrollbar-thumb{background-color:#b6b6b6}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$18 = "data-v-59b02832";
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, createInjector, undefined, undefined);

var InputsMixin = {
  props: {
    inputAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    defaultAttrs() {
      const defaultAttrs = {
        prependIcon: 'mdi-filter-variant',
        outlined: true,
        hideDetails: true
      };
      return { ...defaultAttrs,
        ...this.inputAttrs
      };
    }

  }
};

var script$17 = {
  components: {
    VTextField: VTextField,
    VCol: VCol,
    VRow: VRow,
    VContainer: VContainer,
    VMenu: VMenu
  },
  mixins: [InputsMixin],
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: null
    }
  },

  data() {
    return {
      defaultAttrsRange: {},
      value1: null,
      value2: null,
      menuopen: false
    };
  },

  watch: {
    menuopen(newval, oldval) {
      if (!newval && oldval) {
        this.enter();
      }
    },

    value(newval) {
      if (newval) {
        this.value1 = newval[0];
        this.value2 = newval[1];
      } else {
        this.value1 = null;
        this.value2 = null;
      }
    }

  },

  created() {
    this.defaultAttrsRange = { ...this.defaultAttrs,
      prependIcon: '',
      dense: true
    };
  },

  computed: {
    cvalue1: {
      get() {
        return this.value1;
      },

      set(val) {
        if (this.isNumeric) {
          this.value1 = parseFloat(val);
        } else {
          this.value1 = val;
        }
      }

    },
    cvalue2: {
      get() {
        return this.value2;
      },

      set(val) {
        if (this.isNumeric) {
          this.value2 = parseFloat(val);
        } else {
          this.value2 = val;
        }
      }

    },

    isNumeric() {
      return !!this.filter.numeric;
    },

    computedValue() {
      if (Array.isArray(this.value)) {
        return `${this.value[0] || ''} - ${this.value[1] || ''}`;
      }

      return '';
    }

  },
  methods: {
    input() {
      if (this.value1 || this.value2) {
        this.$emit('input', [this.value1, this.value2]);
      } else {
        this.$emit('input', null);
      }
    },

    enter() {
      if (!isNullUndefinedOrEmptyString(this.value1) && !isNullUndefinedOrEmptyString(this.value2)) {
        this.$emit('enter');
      }
    }

  }
};

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "value": _vm.computedValue,
            "label": _vm.filter.label,
            "readonly": ""
          }
        }, 'v-text-field', Object.assign({}, _vm.defaultAttrs, _vm.filter.attrs), false), on))];
      }
    }]),
    model: {
      value: _vm.menuopen,
      callback: function ($$v) {
        _vm.menuopen = $$v;
      },
      expression: "menuopen"
    }
  }, [_vm._v(" "), _c('v-container', {
    staticClass: "range-container"
  }, [_c('v-row', [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "type": _vm.isNumeric ? 'number' : 'text'
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.enter.apply(null, arguments);
      },
      "input": _vm.input
    },
    model: {
      value: _vm.cvalue1,
      callback: function ($$v) {
        _vm.cvalue1 = $$v;
      },
      expression: "cvalue1"
    }
  }, 'v-text-field', Object.assign({}, _vm.defaultAttrsRange, _vm.filter.attrs1), false))], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("\n        -\n      ")]), _vm._v(" "), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "type": _vm.isNumeric ? 'number' : 'text'
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.enter.apply(null, arguments);
      },
      "input": _vm.input
    },
    model: {
      value: _vm.cvalue2,
      callback: function ($$v) {
        _vm.cvalue2 = $$v;
      },
      expression: "cvalue2"
    }
  }, 'v-text-field', Object.assign({}, _vm.defaultAttrsRange, _vm.filter.attrs2), false))], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$17 = function (inject) {
  if (!inject) return;
  inject("data-v-379c7e25_0", {
    source: ".range-container[data-v-379c7e25]{background:#fff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$17 = "data-v-379c7e25";
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, createInjector, undefined, undefined);

var script$16 = {
  components: {
    VTextField: VTextField
  },
  mixins: [InputsMixin],
  directives: {
    mask: (el, binding) => {
      if (!binding.value) return;
      mask(el, binding);
    }
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    isNumeric() {
      return !!this.filter.numeric;
    }

  }
};

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', _vm._b({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.filter.mask,
      expression: "filter.mask"
    }],
    attrs: {
      "label": _vm.filter.label,
      "value": _vm.value,
      "type": _vm.isNumeric ? 'number' : 'text'
    },
    on: {
      "input": function ($event) {
        _vm.$emit('input', _vm.isNumeric ? parseInt($event) : $event);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.$emit('enter');
      }
    }
  }, 'v-text-field', Object.assign({}, _vm.defaultAttrs, _vm.filter.attrs), false));
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$16 = undefined;
/* scoped */

const __vue_scope_id__$16 = "data-v-f75b8c50";
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

var script$15 = {
  mixins: [InputsMixin],
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Array],
      default: ''
    }
  },

  data() {
    return {
      pickervalue: ''
    };
  },

  watch: {
    value: {
      handler(val) {
        if (!val) {
          if (this.filter.type === 'daterange') {
            this.$emit('input', []);
            this.pickervalue = [];
          } else {
            this.pickervalue = null;
          }
        } else {
          this.pickervalue = val;
        }
      },

      immediate: true
    }
  },
  computed: {
    range() {
      return this.filter.type === 'daterange';
    },

    defaultFormatAttr() {
      return {
        format: 'yyyy-MM-dd'
      };
    }

  },
  methods: {
    inputEvent(event) {
      if (this.range) {
        if (Array.isArray(event) && event[0] && event[1]) {
          this.$emit('input', event);
        }
      } else {
        this.$emit('input', event);
      }
    }

  }
};

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('DatePicker', _vm._b({
    ref: "datepicker",
    attrs: {
      "range": _vm.range,
      "label": _vm.filter.label
    },
    on: {
      "input": _vm.inputEvent
    },
    model: {
      value: _vm.pickervalue,
      callback: function ($$v) {
        _vm.pickervalue = $$v;
      },
      expression: "pickervalue"
    }
  }, 'DatePicker', Object.assign({}, _vm.defaultAttrs, _vm.defaultFormatAttr, _vm.filter.attrs), false));
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$15 = undefined;
/* scoped */

const __vue_scope_id__$15 = "data-v-f35a7b3c";
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

var SelectMultipleMixin = {
  computed: {
    itemsWithDivider() {
      if (this.showSelectAll) {
        return [{
          divider: true
        }, ...this.items];
      } else {
        return this.items;
      }
    },

    selectAllText() {
      if (typeof this.filter.selectall === 'string') {
        return this.filter.selectall;
      } else {
        return 'Select All';
      }
    },

    isAllSelected() {
      return !!(this.value && this.items && Array.isArray(this.value) && this.value.length === this.items.length);
    },

    showSelectAll() {
      return this.filter.selectall && this.items.length > 1;
    },

    toomanyitems() {
      return this.filter.multiple && Array.isArray(this.value) && this.value.length > 10;
    }

  }
};

var script$14 = {
  components: {
    VSimpleCheckbox: VSimpleCheckbox,
    VListItemAction: VListItemAction,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem,
    VSelect: VSelect
  },
  mixins: [InputsMixin, SelectMultipleMixin],
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: [Object, Array],
      default: null
    }
  },

  data() {
    return {
      items: [],
      loading: false
    };
  },

  computed: {
    itemtext() {
      return this.filter.itemtext || 'name';
    }

  },

  async created() {
    this.reloadValues();
  },

  methods: {
    selectAll() {
      if (this.isAllSelected) {
        this.$emit('input', []);
      } else {
        this.$emit('input', this.items);
      }
    },

    async reloadValues(force = false) {
      this.loading = true;

      if (typeof this.filter.values === 'function') {
        this.items = await this.filter.values();
      } else if (isPromise(this.filter.values)) {
        this.items = await this.filter.values;
      } else {
        this.items = this.filter.values;
      }

      if (Array.isArray(this.value)) {
        const effectiveValues = this.value.filter(v => this.items.some(i => isEqual(i, v)));
        this.$emit('input', effectiveValues);
      } else {
        if (!this.items.some(i => isEqual(i, this.value))) {
          this.$emit('input', null);
        }
      }

      this.loading = false;
    }

  }
};

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', _vm._b({
    class: {
      toomanyitems: _vm.toomanyitems
    },
    attrs: {
      "items": _vm.itemsWithDivider,
      "item-text": _vm.itemtext,
      "value": _vm.value,
      "multiple": _vm.filter.multiple,
      "label": _vm.filter.label,
      "loading": _vm.loading,
      "return-object": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([_vm.$scopedSlots.item ? {
      key: "item",
      fn: function (ref) {
        var parent = ref.parent;
        var item = ref.item;
        var on = ref.on;
        var attrs = ref.attrs;
        return [_vm._t("item", null, {
          "parent": parent,
          "item": item,
          "on": on,
          "attrs": attrs
        })];
      }
    } : null, _vm.showSelectAll ? {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          class: {
            'primary--text': _vm.isAllSelected,
            'v-list-item--active': _vm.isAllSelected
          },
          on: {
            "click": _vm.selectAll
          }
        }, [_c('v-list-item-action', [_c('v-simple-checkbox', {
          attrs: {
            "value": _vm.isAllSelected,
            "ripple": false
          },
          on: {
            "input": _vm.selectAll
          }
        })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n          " + _vm._s(_vm.selectAllText) + "\n        ")])], 1)], 1)];
      },
      proxy: true
    } : null], null, true)
  }, 'v-select', Object.assign({}, _vm.defaultAttrs, _vm.filter.attrs), false));
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$14 = undefined;
/* scoped */

const __vue_scope_id__$14 = "data-v-15049314";
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

var script$13 = {
  components: {
    VSimpleCheckbox: VSimpleCheckbox,
    VListItemAction: VListItemAction,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem,
    VAutocomplete: VAutocomplete
  },
  mixins: [InputsMixin, SelectMultipleMixin],
  props: {
    filter: {
      type: Object,
      required: true
    },
    value: {
      type: [Object, Array],
      default: null
    }
  },
  computed: {
    noFilter() {
      if (this.filter.noFilter !== undefined) {
        return this.filter.noFilter;
      }

      return !!this.filter.search;
    },

    itemtext() {
      return this.filter.itemtext || 'name';
    },

    itemKey() {
      return this.filter.fieldkey || 'id';
    }

  },
  watch: {
    value(val) {
      if (!val && this.filter.search) {
        this.autocompleteSearch(this.searchAux);
      }

      if (val && Array.isArray(val)) {
        for (const v of val) {
          if (!this.items.some(i => i[this.itemKey] === v[this.itemKey])) {
            this.items.push(v);
          }
        }
      } else if (val) {
        if (!this.items.some(i => i[this.itemKey] === val[this.itemKey])) {
          this.items.push(val);
        }
      }
    },

    searchAux(newVal, oldVal) {
      if (!this.filter.values && (newVal === null || newVal === void 0 ? void 0 : newVal.length) > 0 && (newVal === null || newVal === void 0 ? void 0 : newVal.length) > (oldVal === null || oldVal === void 0 ? void 0 : oldVal.length)) {
        this.fakeloading = true;
      }
    },

    loading(val) {
      if (!val) this.fakeloading = false;
    }

  },

  data() {
    return {
      items: [],
      cachedValues: null,
      cacheItems: [],
      searchAux: '',
      loading: false,
      fakeloading: false,
      autocompleteSearch: null
    };
  },

  created() {
    this.reloadValues();
    const that = this;
    this.autocompleteSearch = debounce(async searchTxt => {
      if (searchTxt === null || searchTxt === '') {
        this.reloadValues();
      } else {
        const searchSelected = that.filter.selectedvalue === searchTxt && !that.filter.multiple;

        if (!searchSelected && that.filter.search && searchTxt && !that.loading) {
          that.loading = true;
          const items = await that.filter.search(searchTxt);

          if (items && Array.isArray(items)) {
            if (that.filter.multiple && !that.noFilter) {
              that.items = [...items, ...that.cacheItems];
            } else {
              that.items = items;
            }
          }
        }

        that.loading = false;
        that.fakeloading = false;
      }
    }, this.filter.debounce || 1000);
  },

  methods: {
    async reloadValues(force = false) {
      if (this.filter.values) {
        if (this.cachedValues && !force) {
          this.items = this.cachedValues;
        } else {
          if (typeof this.filter.values === 'function') {
            this.loading = true;
            this.items = await this.filter.values();
            this.loading = false;
          } else if (Array.isArray(this.filter.values)) {
            this.items = [...this.filter.values];
          }

          this.cachedValues = [...this.items];
        }
      }
    },

    change(selected) {
      if (this.filter.multiple) {
        for (const item of selected) {
          const cacheItem = this.items.find(i => i[this.itemtext] === item);

          if (cacheItem && (!this.itemKey || !this.cacheItems.some(ci => ci[this.itemKey] === cacheItem[this.itemKey]))) {
            this.cacheItems.push(cacheItem);
          }
        }
      } else {
        this.cacheItems = this.items;
      }

      this.$emit('input', selected);
    },

    selectAll() {
      if (this.isAllSelected) {
        this.change([]);
      } else {
        this.change(this.items);
      }
    }

  }
};

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-autocomplete', _vm._b({
    class: {
      toomanyitems: _vm.toomanyitems
    },
    attrs: {
      "value": _vm.value,
      "label": _vm.filter.label,
      "items": _vm.itemsWithDivider,
      "item-text": _vm.itemtext,
      "multiple": _vm.filter.multiple,
      "search-input": _vm.searchAux,
      "loading": _vm.loading || _vm.fakeloading,
      "no-filter": _vm.noFilter,
      "return-object": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchAux = $event;
      },
      "update:search-input": [function ($event) {
        _vm.searchAux = $event;
      }, _vm.autocompleteSearch],
      "change": _vm.change
    },
    scopedSlots: _vm._u([_vm.$scopedSlots.selection ? {
      key: "selection",
      fn: function (ref) {
        var parent = ref.parent;
        var index = ref.index;
        var disabled = ref.disabled;
        var item = ref.item;
        var selected = ref.selected;
        return [_vm._t("selection", null, {
          "selected": selected,
          "item": item,
          "disabled": disabled,
          "parent": parent,
          "index": index
        })];
      }
    } : null, _vm.$scopedSlots.item ? {
      key: "item",
      fn: function (ref) {
        var parent = ref.parent;
        var item = ref.item;
        var on = ref.on;
        var attrs = ref.attrs;
        return [_vm._t("item", null, {
          "parent": parent,
          "item": item,
          "on": on,
          "attrs": attrs
        })];
      }
    } : null, _vm.showSelectAll ? {
      key: "prepend-item",
      fn: function () {
        return [_c('v-list-item', {
          class: {
            'primary--text': _vm.isAllSelected,
            'v-list-item--active': _vm.isAllSelected
          },
          on: {
            "click": _vm.selectAll
          }
        }, [_c('v-list-item-action', [_c('v-simple-checkbox', {
          attrs: {
            "value": _vm.isAllSelected,
            "ripple": false
          },
          on: {
            "input": _vm.selectAll
          }
        })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n          " + _vm._s(_vm.selectAllText) + "\n        ")])], 1)], 1)];
      },
      proxy: true
    } : null], null, true)
  }, 'v-autocomplete', Object.assign({}, _vm.defaultAttrs, _vm.filter.attrs), false));
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$13 = undefined;
/* scoped */

const __vue_scope_id__$13 = "data-v-5d7e9583";
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

const componentType = {
  combo: __vue_component__$1n,
  daterange: __vue_component__$1o,
  date: __vue_component__$1o,
  autocomplete: __vue_component__$1m,
  textfield: __vue_component__$1p,
  range: __vue_component__$1q
};
var script$12 = {
  components: {
    FilterAutocomplete: __vue_component__$1m,
    FilterSelect: __vue_component__$1n,
    FilterDate: __vue_component__$1o,
    FilterTextField: __vue_component__$1p,
    FilterRange: __vue_component__$1q,
    VCol: VCol
  },
  props: {
    cols: {
      type: Number,
      default: null
    },
    filter: {
      type: Object,
      required: true
    },
    inputAttrs: {
      type: Object,
      default: () => ({})
    },
    values: {
      type: Object,
      required: true
    }
  },
  computed: {
    value() {
      return this.values[this.filter.field];
    },

    component() {
      return componentType[this.filter.type.toLowerCase()];
    }

  },
  methods: {
    input(event) {
      this.$emit('input', event);

      if (this.filter.dependency) {
        if (Array.isArray(this.filter.dependency)) {
          this.$emit('reloadValues', this.filter.dependency);
        } else {
          this.$emit('reloadValues', [this.filter.dependency]);
        }
      }
    }

  }
};

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-col', {
    attrs: {
      "cols": _vm.cols
    }
  }, [_c(_vm.component, {
    ref: "component",
    tag: "component",
    attrs: {
      "value": _vm.value,
      "filter": _vm.filter,
      "input-attrs": _vm.inputAttrs
    },
    on: {
      "input": _vm.input,
      "enter": function ($event) {
        return _vm.$emit('enter');
      }
    },
    scopedSlots: _vm._u([_vm.$scopedSlots['item.' + _vm.filter.field] ? {
      key: "item",
      fn: function (ref) {
        var parent = ref.parent;
        var item = ref.item;
        var on = ref.on;
        var attrs = ref.attrs;
        return [_vm.$scopedSlots['item.' + _vm.filter.field] ? _vm._t('item.' + _vm.filter.field, null, {
          "parent": parent,
          "item": item,
          "on": on,
          "attrs": attrs
        }) : _vm._e()];
      }
    } : null, _vm.$scopedSlots['selection.' + _vm.filter.field] ? {
      key: "selection",
      fn: function (ref) {
        var parent = ref.parent;
        var index = ref.index;
        var disabled = ref.disabled;
        var item = ref.item;
        var selected = ref.selected;
        return [_vm.$scopedSlots['selection.' + _vm.filter.field] ? _vm._t('selection.' + _vm.filter.field, null, {
          "selected": selected,
          "item": item,
          "disabled": disabled,
          "parent": parent,
          "index": index
        }) : _vm._e()];
      }
    } : null], null, true)
  })], 1);
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$12 = undefined;
/* scoped */

const __vue_scope_id__$12 = "data-v-509dd818";
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

var script$11 = {
  components: {
    VDivider: VDivider,
    VBtn: VBtn,
    VIcon: VIcon,
    VListItemContent: VListItemContent,
    VListItemAction: VListItemAction,
    VSelect: VSelect,
    VCardTitle: VCardTitle,
    VTextField: VTextField,
    VCardText: VCardText,
    VSpacer: VSpacer,
    VCardActions: VCardActions,
    VCard: VCard,
    VDialog: VDialog,
    VCol: VCol
  },
  mixins: [InputsMixin, i18n('DataTableFilter')],
  props: {
    storageKey: {
      type: String,
      required: true
    },
    activeFilters: {
      type: Object,
      required: true
    },
    cols: {
      type: Number,
      default: null
    },
    saveSelected: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      dialog: false,
      value: null,
      name: '',
      errors: [],
      renamedialog: false,
      itemrename: null,
      savedFilters: []
    };
  },

  computed: {
    needSave() {
      return this.value && !isEmpty(this.activeFilters) && !isEqual(this.value, this.activeFilters);
    },

    hasFilters() {
      return !isEmpty(this.activeFilters);
    },

    componentProps() {
      return { ...this.defaultAttrs,
        prependIcon: 'mdi-filter-plus'
      };
    }

  },
  watch: {
    savedFilters(val) {
      localStorage.setItem(this.storageKey, JSON.stringify(val));
    },

    value(val) {
      if (this.saveSelected) {
        localStorage.setItem(this.storageKey + 'selected', JSON.stringify(val));
      }
    },

    activeFilters(val) {
      if (isEmpty(val)) this.value = null;
    }

  },

  mounted() {
    const stringSaved = localStorage.getItem(this.storageKey);

    try {
      if (stringSaved) {
        this.savedFilters = JSON.parse(stringSaved);
      }
    } catch (ex) {
      console.warn(ex);
    }

    const valueSaved = localStorage.getItem(this.storageKey + 'selected');

    try {
      if (valueSaved && this.saveSelected) {
        this.value = JSON.parse(valueSaved);
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.selectFilter(this.value);
          });
        });
      }
    } catch (ex) {
      console.warn(ex);
    }
  },

  methods: {
    selectFilter(filter) {
      if (filter) {
        this.$emit('select', filter);
      }

      this.value = filter;
    },

    remove(data) {
      const index = this.savedFilters.findIndex(i => isEqual(i.data, data));
      this.$delete(this.savedFilters, index);

      if (isEqual(data, this.value)) {
        this.value = null;
      }
    },

    update() {
      const cloned = cloneDeep(this.activeFilters);
      const index = this.savedFilters.findIndex(i => isEqual(i.data, this.value));

      if (index !== -1) {
        this.savedFilters[index].data = cloned;
        this.savedFilters = [...this.savedFilters];
      }

      this.value = cloned;
    },

    rename(item) {
      this.name = item.name;
      this.itemrename = this.savedFilters.find(i => isEqual(i.data, item.data));
      this.renamedialog = true;
    },

    cancel() {
      this.dialog = false;
      this.name = '';
      this.renamedialog = false;
      this.itemrename = null;
      this.errors = [];
    },

    save() {
      if (this.name) {
        const saved = this.savedFilters.find(i => isEqual(i.data, this.activeFilters));

        if (saved) {
          this.errors = ['There is already a filter saved with the same content'];
        } else {
          const savedFilter = {
            name: this.name,
            data: cloneDeep(this.activeFilters)
          };
          this.savedFilters.push(savedFilter);
          this.value = savedFilter.data;
          this.cancel();
        }
      } else {
        this.errors = ['cosas'];
      }
    },

    saveRename() {
      this.$set(this.itemrename, 'name', this.name);
      this.savedFilters = [...this.savedFilters];
      this.cancel();
    },

    clear() {
      this.value = null;
    }

  }
};

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-col', {
    staticClass: "d-flex align-center",
    attrs: {
      "cols": _vm.cols
    }
  }, [_c('v-select', _vm._b({
    class: {
      needSave: _vm.needSave,
      'selecteditem': !!_vm.value
    },
    attrs: {
      "value": _vm.value,
      "label": _vm.t('savedFilters'),
      "items": _vm.savedFilters,
      "item-text": "name",
      "item-value": "data",
      "menu-props": {
        closeOnContentClick: true
      }
    },
    on: {
      "input": _vm.selectFilter
    },
    scopedSlots: _vm._u([{
      key: "append-item",
      fn: function () {
        return [_c('v-divider', {
          staticClass: "mb-2"
        }), _vm._v(" "), _c('v-btn', {
          attrs: {
            "text": "",
            "block": "",
            "disabled": !_vm.hasFilters
          },
          on: {
            "click": function ($event) {
              _vm.dialog = true;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.t('saveSelectedFiltersBtn')) + "\n      ")])];
      },
      proxy: true
    }, {
      key: "prepend-inner",
      fn: function () {
        return [_vm.needSave ? _c('v-btn', {
          staticClass: "mt-n2",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.update.apply(null, arguments);
            }
          }
        }, [_c('v-icon', [_vm._v("\n          mdi-content-save-outline\n        ")])], 1) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('v-list-item-content', [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), _c('v-list-item-action', {
          staticClass: "d-flex flex-row"
        }, [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.rename(item);
            }
          }
        }, [_c('v-icon', [_vm._v("\n            mdi-format-letter-case-upper\n          ")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.remove(item.data);
            }
          }
        }, [_c('v-icon', [_vm._v("\n            mdi-close\n          ")])], 1)], 1)];
      }
    }])
  }, 'v-select', _vm.componentProps, false)), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "450px"
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.t('saveSelectedFiltersCard')) + "\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "my-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.t('name'),
      "hide-details": false,
      "prepend-icon": null,
      "autofocus": "",
      "error-messages": _vm.errors
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }, 'v-text-field', _vm.defaultAttrs, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "large": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('confirm')) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "450px"
    },
    model: {
      value: _vm.renamedialog,
      callback: function ($$v) {
        _vm.renamedialog = $$v;
      },
      expression: "renamedialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.t('saveSelectedFiltersCard')) + "\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "my-3"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "label": _vm.t('name'),
      "prepend-icon": null,
      "autofocus": ""
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.save.apply(null, arguments);
      }
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }, 'v-text-field', _vm.defaultAttrs, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outlined": "",
      "large": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveRename
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('confirm')) + "\n        ")])], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$11 = [];
/* style */

const __vue_inject_styles__$11 = function (inject) {
  if (!inject) return;
  inject("data-v-a0708ed6_0", {
    source: ".needSave[data-v-a0708ed6]  .v-label{left:-40px!important;transition:none!important}.selecteditem[data-v-a0708ed6]  .v-label{transition:none!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$11 = "data-v-a0708ed6";
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, createInjector, undefined, undefined);

const buildTsylFilter = (filter, value) => {
  let usedValue = value;

  if (filter.fieldkey && Object.prototype.hasOwnProperty.call(value, filter.fieldkey)) {
    usedValue = value[filter.fieldkey];
  } else if (filter.type === 'date' || filter.type === 'daterange') {
    usedValue = value.substr(0, 10);
  }

  const tsylFilter = {
    PropertyName: filter.tsylfield || filter.field,
    FilterType: filter.tsyltype,
    Value: usedValue
  };
  return tsylFilter;
};
/**
 * A filters components for use with [DataTable](#/DataTables?id=datatable),
 * but you can use independently.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/data-table-filter)
 * @displayName DataTableFilter
 * @author dcrespo
 * @since 0.5.0
*/


var script$10 = {
  mixins: [i18n('DataTableFilter')],
  components: {
    ListOfChips: __vue_component__$1r,
    FilterColWrapper: __vue_component__$1l,
    SavedFiltersSelector: __vue_component__$1k,
    VIcon: VIcon,
    VToolbarTitle: VToolbarTitle,
    VRow: VRow,
    VBtn: VBtn,
    VTooltip: VTooltip,
    VToolbar: VToolbar,
    VCol: VCol,
    VExpandTransition: VExpandTransition
  },
  props: {
    /**
     *
     */
    value: {
      type: Object,
      default: () => {}
    },

    /**
     * Component title
     */
    title: {
      type: String,
      default: null
    },

    /**
     * (sync) Open or close filters
     */
    open: {
      type: Boolean,
      default: false
    },

    /**
     * none: Every change launch `@change` and `@fields` events
     *
     * textfield: Every change launch event except text-fields.
     * Can press enter or search button to launch events.
     *
     * all: Events only launchs with search button click.
     * @values none, textfield, all
     */
    onDemand: {
      type: String,
      default: 'none'
    },

    /**
     * Search button props. x-large by default.
     */
    buttonsProps: {
      type: Object,

      default() {
        return {};
      }

    },

    /**
     * An array of filters settings object.
     * Check [filter object description](#filter-props) for more info.
     */
    filters: {
      type: Array,
      required: true
    },

    /**
     * mdi icon to the left of the title
     */
    icon: {
      type: String,
      default: null
    },

    /**
     * Hide chevron button
     */
    hideArrow: {
      type: Boolean,
      default: false
    },

    /**
     * Hide clear filters button
     */
    hideClear: {
      type: Boolean,
      default: false
    },

    /**
     * Change col value for every filter. Can be a number or an object with
     * different [breakpoints](https://vuetifyjs.com/en/features/breakpoints/]), like:
     *
     * <code>
     * { xl: 3, lg: 3, md: 4, sm: 4, xs: 6 }
     * </code>
     */
    columns: {
      type: [Number, Object],
      default: null
    },

    /**
     * Set input attrs default to all filters. Can be overridden with
     * filter.attrs for each filter individually.
     * You can use vuetify attrs
     */
    inputAttrs: {
      type: Object,
      default: () => ({})
    },

    /**
     * Cache selected filters. If you change page and back
     * your selected filters will be restored. Use an unique key string.
     * Cache will be saved in localstorage.
     */
    cacheKey: {
      type: String,
      default: null
    },

    /**
     * Allow save filters values. Shows a combobox with saved filters and
     * a button to add more. Use an unique key string.
     */
    saveFilters: {
      type: String,
      default: null
    }
  },
  watch: {
    open: {
      handler(newVal) {
        if (newVal !== this.expand) {
          this.expand = newVal;
        }
      },

      immediate: true
    },
    value: {
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal) && !isEqual(newVal, this.tempActiveFilters)) {
          this.tempActiveFilters = newVal;
          this.applyAll();
        }
      },

      immediate: true
    },

    activeFilters(val, oldval) {
      if (!isEmpty(oldval) && isEmpty(val) && this.$refs.savedFiltersSelector) {
        this.$refs.savedFiltersSelector.clear();
      }
    },

    filters() {
      this.clearFilters();
    }

  },
  computed: {
    hasTextField() {
      return this.filters.some(f => f.type === 'textfield');
    },

    compButtonsProps() {
      return {
        'x-large': true,
        ...this.buttonsProps
      };
    },

    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },

    cols() {
      if (this.columns) {
        if (typeof this.columns === 'number') {
          return this.columns;
        }

        if (this.columns[this.breakpoint]) {
          return this.columns[this.breakpoint];
        }
      }

      const l = this.filters.length;

      switch (this.breakpoint) {
        case 'sm':
          return l > 1 ? 6 : null;

        case 'md':
          return l > 2 || l === 1 ? 4 : null;

        case 'lg':
          return l > 3 || l === 1 ? 3 : null;

        case 'xl':
          return l > 6 || l === 1 ? 2 : null;

        case 'xs':
        default:
          return 12;
      }
    },

    filterWithValues() {
      const result = [];

      if (this.activeFilters) {
        for (const filterField of Object.keys(this.activeFilters)) {
          const filter = this.getFilterByField(filterField);
          const value = this.activeFilters[filterField];
          if (filter) result.push({
            filter,
            value
          });
        }
      }

      return result;
    }

  },

  data() {
    return {
      expand: false,
      startupFinish: false,
      tempActiveFilters: {},
      activeFilters: {} // The new filters

    };
  },

  mounted() {
    if (this.cacheKey) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.restoreCache();
          this.startupFinish = true;
        });
      });
    } else {
      this.startupFinish = true; // Force an empty event

      this.applyAll();
    }
  },

  methods: {
    isTextFieldOnDemand(filter) {
      return filter.type === 'textfield' || filter.type === 'range';
    },

    getFilterByField(field) {
      return this.filters.find(f => f.field === field);
    },

    inputFilter(inputValue, filter) {
      if (Array.isArray(inputValue) && inputValue.length || !Array.isArray(inputValue) && inputValue) {
        this.$set(this.tempActiveFilters, filter.field, inputValue);
      } else {
        this.$delete(this.tempActiveFilters, filter.field);
      }

      if (this.startupFinish && !(this.onDemand === 'all' || this.onDemand === 'textfield' && this.isTextFieldOnDemand(filter))) {
        this.applyAll();
      }
    },

    applyAll() {
      this.activeFilters = cloneDeep(this.tempActiveFilters);
      this.emit();
    },

    emit() {
      const emitibleObject = {};

      for (const {
        filter,
        value
      } of this.filterWithValues) {
        if (filter) {
          let emitibleValues;

          if (filter.fieldkey) {
            if (Array.isArray(value)) {
              emitibleValues = value.map(v => v[filter.fieldkey]);
            } else {
              emitibleValues = value[filter.fieldkey];
            }
          } else {
            emitibleValues = value;
          }

          emitibleObject[filter.field] = emitibleValues;
        }
      }
      /**
         * Return object key-value with `field` filter's value as key.
         * @property {object} fields key-value filters
         */


      this.$emit('fields', emitibleObject);
      /**
      * Return object key-value with `field` filter's value as key and all object selected as value.
      * @property {object} fields key-value filters
      */

      this.$emit('input', this.activeFilters);
      if (this.cacheKey) this.saveCache();
      this.tsylfilters();
    },

    tsylfilters() {
      if (this.$listeners.tsylfilters) {
        const filters = [];

        for (const {
          filter,
          value
        } of this.filterWithValues) {
          if (filter && filter.tsyltype) {
            if (Array.isArray(value)) {
              for (const v of value) {
                if (value) {
                  const tsylfilter = buildTsylFilter(filter, v);
                  filters.push(JSON.stringify(tsylfilter));
                }
              }
            } else if (value) {
              const tsylfilter = buildTsylFilter(filter, value);
              filters.push(JSON.stringify(tsylfilter));
            }
          }
        }
        /**
        * Return an array with json filters to use directly with tsyl-core filters.
        * @property {array} filters
        */


        this.$emit('tsylfilters', filters);
      }
    },

    remove({
      filter,
      value
    }) {
      if (Array.isArray(this.activeFilters[filter.field]) && filter.type !== 'range' && filter.type !== 'daterange') {
        if (filter.fieldkey) {
          this.activeFilters[filter.field] = this.activeFilters[filter.field].filter(x => x[filter.fieldkey] !== value[filter.fieldkey]);
        } else {
          this.activeFilters[filter.field] = this.activeFilters[filter.field].filter(x => x !== value);
        }

        if (this.activeFilters[filter.field].length === 0) {
          this.$delete(this.activeFilters, filter.field);
        }
      } else {
        this.$delete(this.activeFilters, filter.field);
      }

      this.reloadDependenciesValues(filter);
      this.tempActiveFilters = cloneDeep(this.activeFilters);
      this.emit();
    },

    /**
     * Clear all filters
     * @public
     */
    clearFilters() {
      this.activeFilters = {};
      this.tempActiveFilters = {};
      this.emit();
      this.reloadDependenciesValues(this.filters);
      /**
         * Emited when user clicks in clear filters button.<br>
         * since `0.6.32`
         */

      this.$emit('clear');
    },

    clickOpen() {
      this.expand = !this.expand;
      /**
       * Launch when chevron button is clicked
       * @property {boolean}
       */

      this.$emit('update:open', this.expand);
    },

    /**
     * Save cache with custom key (if null will be used cacheKey prop)
     * @public
     */
    saveCache(keyParam) {
      const key = keyParam || this.cacheKey;

      if (key) {
        localStorage.setItem(key, JSON.stringify(this.activeFilters));
      } else {
        console.warn("[Zapan Warn]: Can't save cache. There is not key.");
      }
    },

    /**
     * Restore cache with custom key (if null will be used cacheKey prop)
     * @public
     */
    restoreCache(keyParam) {
      const key = keyParam || this.cacheKey;

      if (key) {
        const cache = localStorage.getItem(key);

        if (cache) {
          try {
            const cacheObj = JSON.parse(cache);
            this.activeFilters = cacheObj;
            this.tempActiveFilters = cacheObj;
            this.$nextTick(() => {
              this.applyAll();
            });
          } catch (ex) {
            console.error(ex);
          }
        }
      } else {
        console.warn("[Zapan Warn]: Can't restore cache. There is not key.");
      }
    },

    /**
     * Reloads filters that depend on the filters passed by parameter
     * @public
     * @param  {...string} filtersNames
     */
    reloadDependenciesValues(...filters) {
      const allDependencies = filters.filter(f => f.dependency).map(f => f.dependency).flat();
      this.reloadValues(...allDependencies);
    },

    /**
     * Reload filter values.
     * Allow multiple filters at same time.
     * @public
     * @param {...string} filter filter field. Allow multiple.
     */
    reloadValues(...filters) {
      for (const filter of filters) {
        for (const componentWrapper of this.$refs[filter] || []) {
          if (componentWrapper.$refs.component.reloadValues) {
            componentWrapper.$refs.component.reloadValues(true);
          } else {
            console.error('[Zapan warn]: Only reload values for combo or antocomplete filters');
          }
        }
      }
    },

    selectSavedFilter(filter) {
      const cloned = cloneDeep(filter);
      this.tempActiveFilters = cloned;
      this.applyAll();
    }

  }
};

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "filters-wrapper"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-toolbar', {
    staticClass: "bordered-bar",
    attrs: {
      "flat": ""
    }
  }, [_vm.title ? _c('v-toolbar-title', {
    staticClass: "body-1 mr-3 overflow-visible"
  }, [_vm.icon ? _c('v-icon', [_vm._v("\n            " + _vm._s(_vm.icon) + "\n          ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('ListOfChips', {
    attrs: {
      "filter-with-values": _vm.filterWithValues,
      "refs": _vm.$refs
    },
    on: {
      "remove": _vm.remove
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    })], null, true)
  }, [_vm._e()], 2)], 1), _vm._v(" "), !_vm.hideClear ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('clearFiltersButton')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [!_vm.hideArrow ? _c('v-btn', _vm._g({
          attrs: {
            "icon": "",
            "data-testid": "openclosebtn"
          },
          on: {
            "click": _vm.clickOpen
          }
        }, on), [_c('v-icon', {
          class: {
            iconopen: _vm.expand
          }
        }, [_vm._v("\n                " + _vm._s('mdi-chevron-down') + "\n              ")])], 1) : _vm._e()];
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show/Hide Filters")])]), _vm._v(" "), _vm._t("default")], 2)], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expand,
      expression: "expand"
    }],
    attrs: {
      "data-testid": "expandableRow"
    }
  }, [_c('v-col', [_c('v-row', [_vm._l(_vm.filters, function (filter) {
    return _c('FilterColWrapper', {
      key: filter.field,
      ref: filter.field,
      refInFor: true,
      attrs: {
        "cols": _vm.cols,
        "filter": filter,
        "input-attrs": _vm.inputAttrs,
        "values": _vm.tempActiveFilters,
        "data-testid": 'col-' + filter.field
      },
      on: {
        "input": function ($event) {
          return _vm.inputFilter($event, filter);
        },
        "enter": _vm.applyAll,
        "reloadValues": function ($event) {
          return _vm.reloadValues.apply(void 0, $event);
        }
      },
      scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
        return {
          key: name,
          fn: function (data) {
            return [_vm._t(name, null, null, data)];
          }
        };
      })], null, true)
    }, [_vm._v(" "), _vm._e(), _vm._v(" "), _vm._e()], 2);
  }), _vm._v(" "), _vm.saveFilters ? _c('SavedFiltersSelector', {
    ref: "savedFiltersSelector",
    attrs: {
      "cols": _vm.cols,
      "active-filters": _vm.activeFilters,
      "input-attrs": _vm.inputAttrs,
      "storage-key": _vm.saveFilters,
      "save-selected": !!_vm.cacheKey
    },
    on: {
      "select": _vm.selectSavedFilter
    }
  }) : _vm._e()], 2)], 1), _vm._v(" "), _vm.onDemand === 'all' || _vm.onDemand === 'textfield' && _vm.hasTextField ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "searchbutton",
    on: {
      "click": _vm.applyAll
    }
  }, 'v-btn', _vm.compButtonsProps, false), [_vm._t("search", function () {
    return [_vm._v("\n            " + _vm._s(_vm.t('search')) + "\n          ")];
  })], 2)], 1) : _vm._e()], 1)], 1)], 1);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$10 = function (inject) {
  if (!inject) return;
  inject("data-v-1647c9ed_0", {
    source: ".iconopen[data-v-1647c9ed]{transform:rotate(-180deg)}.searchbutton[data-v-1647c9ed]{margin-top:14px;margin-left:14px}.bordered-bar[data-v-1647c9ed]  .v-toolbar__content{padding:0!important}.bordered-bar[data-v-1647c9ed]{background-color:transparent!important}.filters-wrapper[data-v-1647c9ed]  .toomanyitems .v-select__selections{display:flex;overflow:hidden;white-space:nowrap;position:absolute;width:calc(100% - 22px);flex-direction:row;flex-wrap:nowrap}.filters-wrapper[data-v-1647c9ed]  .toomanyitems .v-select__selections .v-select__selection{display:inline-block;overflow:visible}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$10 = "data-v-1647c9ed";
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, createInjector, undefined, undefined);

var DataTableFilter = __vue_component__$1j;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Layout with big headers, content and buttons.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/content-box)
 * @displayName ContentBox
 * @author dcrespo
 * @since 0.2.0
 */

var script$$ = {
  components: {
    VIcon: VIcon,
    VBreadcrumbsItem: VBreadcrumbsItem,
    VBreadcrumbs: VBreadcrumbs,
    VSpacer: VSpacer,
    VBtn: VBtn,
    VListItemIcon: VListItemIcon,
    VListItemTitle: VListItemTitle,
    VListItem: VListItem,
    VList: VList,
    VMenu: VMenu,
    VToolbar: VToolbar,
    VRow: VRow,
    VToolbarTitle: VToolbarTitle,
    VAvatar: VAvatar,
    VBadge: VBadge,
    VCol: VCol,
    VContainer: VContainer
  },
  props: {
    /**
     * The buttons at the top<br>
     * <code>
     * {<br>
     * &nbsp;items: [], // <a href="https://vuetifyjs.com/en/api/v-breadcrumbs/#props-items">
     * vuetify breadcrumbs</a> items <br>
     * &nbsp;buttons:[<br>
     * &nbsp;&nbsp;{<br>
     * &nbsp;&nbsp;&nbsp;text: 'some text',<br>
     * &nbsp;&nbsp;&nbsp;color: '#FFFF00',<br>
     * &nbsp;&nbsp;&nbsp;justText: true, // <a href="https://vuetifyjs.com/en/api/v-btn/#props-text">v-btn text prop</a> <br>
     * &nbsp;&nbsp;&nbsp;outlined: true<br>
     * &nbsp;&nbsp;}<br>
     * &nbsp;]<br>
     * }
     * </code>
     */
    breadcrumbs: {
      type: Object,
      required: false,
      default: () => null
    },

    /**
     * Title section <br>
     * <code>
     * {<br>
     * &nbsp;text: 'title', <br>
     * &nbsp;buttons:[<br>
     * &nbsp;&nbsp;{<br>
     * &nbsp;&nbsp;&nbsp;text: 'some text',<br>
     * &nbsp;&nbsp;&nbsp;color: '#FFFF00',<br>
     * &nbsp;&nbsp;&nbsp;justText: true, // <a href="https://vuetifyjs.com/en/api/v-btn/#props-text">v-btn text prop</a> <br>
     * &nbsp;&nbsp;&nbsp;outlined: true<br>
     * &nbsp;&nbsp;}<br>
     * &nbsp;]<br>
     * }
     * </code>
     */
    title: {
      type: Object,
      required: false,
      default: () => null
    },

    /**
     * Header data<br>
     * <code>
     * {<br>
     * &nbsp;icon: 'mdi-icon',<br>
     * &nbsp;title: 'Some Title',<br>
     * &nbsp;iconColor: '#0000FF',<br>
     * &nbsp;subtitle: 'some subtitle'<br>
      }
     * </code>
     */
    header: {
      type: Object,
      required: false,
      default: () => null
    },

    /**
     * The buttons at the bottom<br>
     * <code>
     * {<br>
     * &nbsp;buttons:[<br>
     * &nbsp;&nbsp;{<br>
     * &nbsp;&nbsp;&nbsp;text: 'some text',<br>
     * &nbsp;&nbsp;&nbsp;color: '#FFFF00',<br>
     * &nbsp;&nbsp;&nbsp;justText: true, // <a href="https://vuetifyjs.com/en/api/v-btn/#props-text">v-btn text prop</a> <br>
     * &nbsp;&nbsp;&nbsp;outlined: true<br>
     * &nbsp;&nbsp;}<br>
     * &nbsp;]<br>
     * }
     * </code>
     */
    actions: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    contentStyle() {
      // let height
      // if (this.header && this.actions) height = 'calc(100vh - 128px - 27vh)'
      // else if (this.header && !this.actions) height = 'calc(100vh - 64px - 27vh)'
      // else if (!this.header && this.actions) height = 'calc(100vh - 128px)'
      // else height = 'calc(100vh - 64px)'
      return {
        // height,
        'overflow-y': 'auto'
      };
    },

    mainContainerStyle: {
      get() {
        return {
          height: 'calc(100vh - 64px)',
          'overflow-y': this.actions ? 'hidden' : 'auto',
          display: 'flex',
          'flex-flow': 'column'
        };
      },

      cache: false
    }
  }
};

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-container', {
    staticClass: "main-container pa-0",
    style: _vm.mainContainerStyle,
    attrs: {
      "fluid": ""
    }
  }, [_vm.breadcrumbs ? _c('v-row', {
    staticClass: "flex-grow-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "p-0 bordered-bar",
    attrs: {
      "flat": ""
    }
  }, [_c('v-breadcrumbs', {
    staticClass: "pl-0",
    attrs: {
      "items": _vm.breadcrumbs.items,
      "nuxt": ""
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function () {
        return [_c('v-icon', [_vm._v("mdi-chevron-right")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('v-breadcrumbs-item', {
          attrs: {
            "nuxt": "",
            "exact": "",
            "exact-active-class": "primary--text",
            "to": item.href,
            "disabled": item.disabled
          }
        }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])];
      }
    }], null, false, 3080782387)
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l(_vm.breadcrumbs.buttons, function (button) {
    return _c('div', {
      key: button.text
    }, [button.menu ? _c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (ref) {
          var on = ref.on;
          var attrs = ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "ml-3",
            attrs: {
              "color": button.color || 'primary',
              "outlined": button.outlined,
              "text": button.justText
            }
          }, 'v-btn', attrs, false), on), [_vm._v("\n              " + _vm._s(button.text) + "\n            ")])];
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', _vm._l(button.options, function (item, index) {
      return _c('v-list-item', {
        key: index,
        on: {
          "click": function ($event) {
            return _vm.$emit('breadcrumbs-button-click', item.text);
          }
        }
      }, [item.icon ? _c('v-list-item-icon', [_c('v-icon', {
        attrs: {
          "color": item.color || 'primary'
        },
        domProps: {
          "textContent": _vm._s(item.icon)
        }
      })], 1) : _vm._e(), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1);
    }), 1)], 1) : _c('v-btn', {
      staticClass: "ml-3",
      attrs: {
        "color": button.color || 'primary',
        "outlined": button.outlined,
        "text": button.justText
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('breadcrumbs-button-click', button.text);
        }
      }
    }, [_vm._v("\n          " + _vm._s(button.text) + "\n        ")])], 1);
  })], 2)], 1) : _vm._e(), _vm._v(" "), _vm.title ? _c('v-row', {
    staticClass: "flex-grow-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "p-0 bordered-bar",
    attrs: {
      "color": "grey lighten-4",
      "flat": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.title.text) + "\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l(_vm.title.buttons, function (button) {
    return _c('v-btn', {
      key: button.text,
      staticClass: "ml-3",
      attrs: {
        "color": button.color || 'primary',
        "outlined": button.outlined,
        "text": button.justText
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('title-button-click', button.text);
        }
      }
    }, [_vm._v("\n        " + _vm._s(button.text) + "\n      ")]);
  })], 2)], 1) : _vm._e(), _vm._v(" "), _vm.header ? _c('v-row', {
    staticClass: "grey lighten-5 flex-grow-0",
    staticStyle: {
      "height": "27vh"
    },
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-container', {
    staticClass: "text-center"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-6"
  }, [_vm.header.badgeIcon ? _c('v-badge', {
    attrs: {
      "color": _vm.header.badgeColor,
      "icon": _vm.header.badgeIcon,
      "bordered": "",
      "overlap": "",
      "offset-x": "15",
      "offset-y": "10"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": _vm.header.iconColor
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.header.icon) + "\n                ")])], 1)], 1) : _c('v-avatar', {
    attrs: {
      "color": _vm.header.iconColor
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.header.icon) + "\n              ")])], 1)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pa-0"
  }, [_c('h1', {
    staticClass: "display-1 grey--text text--darken-3"
  }, [_vm._v("\n              " + _vm._s(_vm.header.title) + "\n            ")])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "py-1"
  }, [_c('h4', {
    staticClass: "caption grey--text text--darken-2"
  }, [_vm._v("\n              " + _vm._s(_vm.header.subtitle) + "\n            ")])])], 1), _vm._v(" "), _vm.header.buttons ? _c('v-row', [_c('v-col', _vm._l(_vm.header.buttons, function (button) {
    return _c('v-btn', {
      key: button.text,
      staticClass: "ml-3",
      attrs: {
        "color": button.color || 'primary',
        "outlined": button.outlined,
        "text": button.justText,
        "disabled": button.disabled
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('header-button-click', button.text);
        }
      }
    }, [_vm._v("\n              " + _vm._s(button.text) + "\n            ")]);
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "pa-1"
  }, [_vm._t("header-extend")], 2)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    style: _vm.contentStyle,
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-0"
  }, [_vm._t("content")], 2)], 1), _vm._v(" "), _vm.actions ? _c('v-row', {
    staticClass: "flex-grow-0",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-spacer'), _vm._v(" "), _vm._l(_vm.actions.buttons, function (button) {
    return _c('v-btn', {
      key: button.text,
      staticClass: "ml-3",
      attrs: {
        "color": button.color || 'primary',
        "outlined": button.outlined,
        "text": button.justText
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('actions-button-click', button.text);
        }
      }
    }, [_vm._v("\n          " + _vm._s(button.text) + "\n        ")]);
  })], 2)], 1)], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$$ = undefined;
/* scoped */

const __vue_scope_id__$$ = undefined;
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

var __vue_component__$1i = __vue_component__$1h;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$_ = {
  components: {
    VToolbarTitle: VToolbarTitle,
    VIcon: VIcon,
    VBreadcrumbsItem: VBreadcrumbsItem,
    VBreadcrumbs: VBreadcrumbs,
    VSpacer: VSpacer,
    VBtn: VBtn,
    VToolbar: VToolbar
  },
  props: {
    title: {
      type: String,
      required: false,
      default: null
    },
    buttons: {
      type: Array,
      required: false,
      default: () => []
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => []
    },
    color: {
      type: String,
      default: 'white'
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-toolbar', {
    staticClass: "p-0 bordered-bar",
    attrs: {
      "color": _vm.color,
      "dark": _vm.dark,
      "flat": ""
    }
  }, [_vm.title ? _c('v-toolbar-title', {
    staticClass: "body-1 accent--text"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.breadcrumbs ? _c('v-breadcrumbs', {
    staticClass: "pl-0",
    attrs: {
      "items": _vm.breadcrumbs,
      "nuxt": ""
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function () {
        return [_c('v-icon', [_vm._v("mdi-chevron-right")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        return [_c('v-breadcrumbs-item', {
          attrs: {
            "nuxt": "",
            "to": item.href,
            "disabled": item.disabled
          }
        }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")])];
      }
    }], null, false, 3401500544)
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._l(_vm.buttons, function (btn, $index) {
    return _c('v-btn', {
      key: btn,
      staticClass: "ml-2",
      attrs: {
        "color": $index === 0 && _vm.buttons.length > 1 ? 'black' : 'accent',
        "outlined": $index === 0 && _vm.buttons.length > 1
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('btn-clicked', $index);
        }
      }
    }, [_vm._v("\n    " + _vm._s(btn) + "\n  ")]);
  })], 2);
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = "data-v-da664b04";
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

var __vue_component__$1g = __vue_component__$1f;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Fix SSR for this component

global.File = typeof window === 'undefined' ? Object : window.File;
global.FileList = typeof window === 'undefined' ? Object : window.FileList;
/**
 * Drap and drop area to upload files.
 *
 * [Check in Playground](https://sandbox.technosylva.com/file-drag-drop/)
 * @displayName FileDragAndDrop
 * @author dcrespo
 * @since 0.5.1
 */

var script$Z = {
  components: {
    VChip: VChip,
    VFileInput: VFileInput
  },
  props: {
    /**
     * (v-model) file (or array of files, if multiple: true) selected.
     */
    value: {
      type: [File, Array],
      default: null
    },

    /**
     * Text inside drop area. Alternatively you can use default slot
     */
    label: {
      type: String,
      default: 'Choose a file or drag it here.'
    },

    /**
     * Area color. Hex or vuetify color
     */
    color: {
      type: String,
      default: ''
    },

    /**
     * vuetify dark prop. Set text white.
     */
    dark: {
      type: Boolean,
      default: false
    },

    /**
     * text below drop area
     */
    hint: {
      type: String,
      default: ''
    },

    /**
     * Permit upload multiple files. value must be an array.
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * [html accept attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/accept)
     */
    accept: {
      type: String,
      default: null
    },

    /**
     * Allow upload a complete directory using directory and webkitdirectory native params.
     * Always returns an array, like multiple prop.
     * [more info](https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory)
     */
    directory: {
      type: Boolean,
      default: false
    },

    /**
     * Drop area height
     */
    height: {
      type: [Number, String],
      default: null
    },

    /**
     * Hide drop area dotted border
     */
    noBorder: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      file: null,
      hover: false,
      resetIndex: 0,
      errormsgs: []
    };
  },

  computed: {
    valueAsArray() {
      if (!this.value) {
        return [];
      }

      if (this.multipleComp) {
        return this.value;
      }

      return [this.value];
    },

    wrapperStyle() {
      const style = {};

      if (this.height) {
        if (isNaN(this.height)) style['min-height'] = this.height;else style['min-height'] = `${this.height}px`;
        if (this.color.startsWith('#')) style.background = this.color;
      }

      return style;
    },

    colorClass() {
      if (this.color.startsWith('#')) {
        return '';
      }

      return this.color;
    },

    multipleComp() {
      return this.multiple || this.directory;
    }

  },
  methods: {
    dragOver() {
      this.hover = true;
    },

    dragLeave() {
      this.hover = false;
    },

    async addDropFile(event) {
      this.dragLeave();
      let allFiles = [];

      if (event.dataTransfer.items && event.dataTransfer.items.length) {
        const items = []; // Need generate before because
        // after await event.dataTransfer will clear.

        for (const file of event.dataTransfer.items) {
          const item = file.webkitGetAsEntry();
          items.push(item);
        }

        for (const item of items) {
          const files = await this.flatFolderTree(item);
          allFiles.push(...files);
        }
      } else {
        allFiles = Array.from(event.dataTransfer.files);
      }

      if (allFiles.length > 1 && !this.multipleComp) {
        this.errormsgs.push('No multiple files allowed');
      } else {
        this.checkAndAddFiles(allFiles);
      }
    },

    async flatFolderTree(item) {
      const array = [];

      if (item.isFile) {
        const file = await new Promise(resolve => {
          item.file(function (file) {
            resolve(file);
          });
        });
        array.push(file);
      } else if (item.isDirectory) {
        const dirContent = await new Promise(resolve => {
          const dirReader = item.createReader();
          dirReader.readEntries(function (entries) {
            resolve(entries);
          });
        });

        for (const entry of dirContent) {
          const resultFiles = await this.flatFolderTree(entry, array);
          array.push(...resultFiles);
        }
      }

      return array;
    },

    changeFiles(files) {
      if (this.multipleComp && files && files.length) {
        this.checkAndAddFiles(files);
      } else if (!this.multipleComp && files) {
        this.checkAndAddFiles([files]);
      }
    },

    checkAndAddFiles(files) {
      if (files) {
        this.errormsgs = [];
        let evaluatedFiles = [];

        for (const file of files) {
          const errorMessage = this.getErrorMessage(file);

          if (errorMessage) {
            this.errormsgs.push(errorMessage);
          } else {
            evaluatedFiles.push(file);
          }
        }

        if (this.multipleComp && Array.isArray(this.value) && this.value.length) {
          evaluatedFiles = [...this.value, ...evaluatedFiles];
        } else if (!this.multipleComp) {
          evaluatedFiles = evaluatedFiles[0];
        }
        /**
         * (v-model) emit file or files selected
         * @property (array, File) file or files selected
         */


        this.$emit('input', evaluatedFiles);
        this.$refs.fileinput.clearableCallback();
      }
    },

    getErrorMessage(file) {
      if (this.accept) {
        const acceptList = this.accept.replace(/\s/g, '').replace('*', '.*').split(',');

        for (const accept of acceptList) {
          const regex = new RegExp(accept);

          if (regex.test(file.type)) {
            return null;
          }
        }

        return `${file.name}: invalid filetype`;
      }

      return null;
    },

    click(event) {
      this.$refs.fileinput.$refs.input.click(event);
    },

    removeFile(index) {
      if (index === 0 && !this.multipleComp) {
        this.$emit('input', null);
        this.resetInput();
      } else {
        const files = [...this.value];
        files.splice(index, 1);
        this.$emit('input', files);
      }

      this.errormsgs = [];
    },

    resetInput() {
      this.resetIndex++;
    }

  }
};

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "file-drag-drop"
  }, [_c('div', {
    staticClass: "file-drag-drop-wrapper",
    class: [{
      'theme--dark': _vm.dark,
      hover: _vm.hover,
      'no-border': _vm.noBorder
    }, _vm.colorClass],
    style: _vm.wrapperStyle,
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.addDropFile.apply(null, arguments);
      },
      "dragover": function ($event) {
        $event.preventDefault();
        return _vm.dragOver.apply(null, arguments);
      },
      "dragleave": _vm.dragLeave,
      "click": _vm.click
    }
  }, [_c('div', {
    staticClass: "label-wrapper px-12"
  }, [!_vm.$slots.default ? _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")]) : _vm._t("default"), _vm._v(" "), _vm.valueAsArray.length ? _c('p', {
    staticClass: "file-list"
  }, _vm._l(_vm.valueAsArray, function (fileInList, index) {
    return _c('v-chip', {
      key: index,
      staticClass: "ma-2",
      attrs: {
        "close": ""
      },
      on: {
        "click:close": function ($event) {
          return _vm.removeFile(index);
        }
      }
    }, [_vm._v("\n          " + _vm._s(fileInList.name) + "\n        ")]);
  }), 1) : _vm._e()], 2), _vm._v(" "), _c('v-file-input', _vm._b({
    key: _vm.resetIndex,
    ref: "fileinput",
    staticClass: "d-none",
    attrs: {
      "directory": _vm.directory,
      "webkitdirectory": _vm.directory,
      "multiple": _vm.multipleComp,
      "accept": _vm.accept
    },
    on: {
      "change": _vm.changeFiles
    }
  }, 'v-file-input', _vm.$attrs, false))], 1), _vm._v(" "), _vm.hint || _vm.errormsgs.length ? _c('div', {
    staticClass: "file-drag-drop__details mt-1"
  }, [_c('div', {
    staticClass: "v-messages theme--light"
  }, [_c('div', {
    staticClass: "v-messages__wrapper"
  }, [_vm.errormsgs.length ? _c('div', {
    staticClass: "v-messages__message error--text"
  }, _vm._l(_vm.errormsgs, function (msg, index) {
    return _c('p', {
      key: index,
      staticClass: "mb-1"
    }, [_vm._v("\n            " + _vm._s(msg) + "\n          ")]);
  }), 0) : _c('div', {
    staticClass: "v-messages__message"
  }, [_vm._v("\n          " + _vm._s(_vm.hint) + "\n        ")])])])]) : _vm._e()]);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$Z = function (inject) {
  if (!inject) return;
  inject("data-v-5d438f22_0", {
    source: ".file-drag-drop-wrapper[data-v-5d438f22]{min-height:165px;min-width:50px;padding:15px;border-radius:4px;cursor:pointer;position:relative;display:flex;justify-content:center;align-items:center}.file-drag-drop-wrapper[data-v-5d438f22]:not(.no-border){border:1px solid #999}.file-drag-drop-wrapper[data-v-5d438f22]:not(.no-border)::before{content:\" \";position:absolute;top:4px;left:4px;right:4px;bottom:4px;border:1px solid #999;border-radius:6px;border-style:dashed}.file-drag-drop-wrapper.hover[data-v-5d438f22]::after,.file-drag-drop-wrapper[data-v-5d438f22]:hover::after{content:\" \";position:absolute;top:0;left:0;right:0;bottom:0;background-color:#00000020;pointer-events:none;border-radius:4px}.file-drag-drop-wrapper .label-wrapper[data-v-5d438f22]{text-align:center}.file-drag-drop-wrapper.theme--dark[data-v-5d438f22]{border-color:#eee!important}.file-drag-drop-wrapper.theme--dark .label-wrapper[data-v-5d438f22]{color:#fff}.file-drag-drop-wrapper.theme--dark[data-v-5d438f22]::before{border-color:#eee!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Z = "data-v-5d438f22";
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, createInjector, undefined, undefined);

var __vue_component__$1e = __vue_component__$1d;

var script$Y = {
  components: {
    VIcon: VIcon,
    VBtn: VBtn,
    VCardTitle: VCardTitle,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [i18n('MainNavigation')],
  props: {
    appName: {
      type: String,
      default: null
    }
  }
};

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "about-card"
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-space-between about-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('about', {
    msg: _vm.appName
  })))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', [_vm._v("\n        mdi-close\n      ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_vm._t("default")], 2)], 1);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Y = function (inject) {
  if (!inject) return;
  inject("data-v-d0c3b058_0", {
    source: ".about-title[data-v-d0c3b058]{background-color:#fafafa}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Y = "data-v-d0c3b058";
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, createInjector, undefined, undefined);

var script$X = {
  directives: {
    ClickOutside: ClickOutside
  },
  components: {
    VIcon: VIcon,
    VBtn: VBtn,
    VBadge: VBadge,
    VCardTitle: VCardTitle,
    VCardText: VCardText,
    VCard: VCard,
    VTooltip: VTooltip,
    VListItem: VListItem
  },
  mixins: [i18n('MainNavigation')],
  props: {
    notifications: {
      type: Number,
      default: 0
    },
    notificationText: {
      type: String,
      default: null
    }
  },
  watch: {
    show(val) {
      if (val) {
        setTimeout(() => {
          this.canclose = true;
        }, 100);
      } else {
        this.canclose = false;
      }
    }

  },

  data() {
    return {
      show: false,
      canclose: false
    };
  },

  methods: {
    clickoutside() {
      if (this.canclose) {
        this.show = false;
      }
    },

    close() {
      this.show = false;
    }

  }
};

/* script */
const __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-list-item', {
    staticClass: "notification-list-item",
    class: {
      hide: _vm.notifications === 0
    }
  }, [_c('v-tooltip', {
    attrs: {
      "content-class": "notification-tooltip",
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        return [_c('div', {
          staticClass: "notification-buttons-wrapper",
          on: {
            "click": function ($event) {
              _vm.show = !_vm.show;
            }
          }
        }, [_vm.$slots.notification ? _c('div', {
          staticClass: "notification-btn"
        }, [_vm._t("notification")], 2) : _c('v-btn', {
          staticClass: "notification-btn",
          attrs: {
            "color": "amber",
            "light": ""
          }
        }, [_c('v-icon', {
          staticClass: "mr-1 ml-n1"
        }, [_vm._v("\n            mdi-bell\n          ")]), _vm._v("\n          " + _vm._s(_vm.notificationText) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "notification-icon",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("\n            mdi-bell\n          ")])], 1), _vm._v(" "), _c('v-badge', {
          staticClass: "notification-badge",
          attrs: {
            "overlap": "",
            "bordered": "",
            "content": _vm.notifications,
            "value": _vm.notifications,
            "color": "amber"
          }
        })], 1)];
      }
    }], null, true),
    model: {
      value: _vm.show,
      callback: function ($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_vm._v(" "), _c('v-card', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickoutside,
      expression: "clickoutside"
    }],
    staticClass: "card-notifications",
    class: 'notifications-n-' + _vm.notifications,
    attrs: {
      "light": ""
    }
  }, [_c('v-card-title', {
    staticClass: "headline justify-space-between py-1"
  }, [_c('h6', {
    staticClass: "text-h6"
  }, [_vm._v("\n          " + _vm._s(_vm.t('notifications')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_vm._t("default", null, {
    "close": _vm.close
  })], 2)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$X = [];
/* style */

const __vue_inject_styles__$X = function (inject) {
  if (!inject) return;
  inject("data-v-aeba601a_0", {
    source: ".notification-list-item[data-v-aeba601a]{padding-left:5px;padding-right:7px;transition:height ease .2s;overflow:hidden;min-height:0;height:48px}.notification-list-item.hide[data-v-aeba601a]{height:0}.notification-badge[data-v-aeba601a]{cursor:pointer;left:-6px}.notification-badge[data-v-aeba601a]  .v-badge__badge{color:#000}.notification-btn[data-v-aeba601a]{width:100%;font-weight:400;text-transform:none;overflow:hidden;letter-spacing:0}.notification-btn[data-v-aeba601a] .v-btn__content{width:100%;white-space:normal}.v-badge[data-v-aeba601a]  .v-badge__badge{bottom:calc(100% - 0px)!important}.theme--dark.v-badge .v-badge__badge[data-v-aeba601a]::after{border-color:#363636}.notification-buttons-wrapper[data-v-aeba601a]{width:100%;text-align:center}.notification-tooltip[data-v-aeba601a]{padding:0!important;transform:translateX(-7px);pointer-events:auto}.notification-tooltip.menuable__content__active[data-v-aeba601a]{opacity:1!important}.card-notifications[data-v-aeba601a]{min-width:300px}.card-notifications[data-v-aeba601a]:before{content:\"\";display:block;width:0;height:0;position:absolute;border-top:8px solid transparent;border-bottom:8px solid transparent;border-right:8px solid #fff;left:-8px;top:65px}.card-notifications[data-v-aeba601a] .v-card__title{background:#fafafa}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$X = "data-v-aeba601a";
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, createInjector, undefined, undefined);

var mainNavigationMixin = {
  methods: {
    initials
  }
};

var script$W = {
  components: {
    VIcon: VIcon,
    VBadge: VBadge,
    VListItemIcon: VListItemIcon,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VBtn: VBtn,
    VListItemAction: VListItemAction,
    VListItem: VListItem,
    VTooltip: VTooltip
  },
  mixins: [mainNavigationMixin],
  props: {
    nuxt: {
      type: Boolean,
      default: null
    },
    item: {
      type: Object,
      required: true
    },
    exact: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    events() {
      const events = {};

      if (this.item.click) {
        events.click = this.item.click;
      }

      return events;
    },

    isExact() {
      if (this.item.exact !== undefined) {
        return this.item.exact;
      }

      return this.exact;
    },

    menuInitials() {
      return this.initials(this.item.name);
    }

  }
};

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-tooltip', {
    attrs: {
      "right": "",
      "open-delay": "800",
      "close-delay": "200",
      "disabled": !_vm.mini,
      "transition": "slide-x-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('v-list-item', _vm._g(_vm._b({
          attrs: {
            "nuxt": _vm.nuxt,
            "link": !!(_vm.item.to || _vm.item.click),
            "to": _vm.item.to,
            "href": _vm.item.external,
            "target": _vm.item.external ? '_blank' : null,
            "exact": _vm.isExact
          }
        }, 'v-list-item', attrs, false), Object.assign({}, on, _vm.events)), [_c('v-list-item-icon', {
          staticClass: "my-3 mr-4",
          class: {
            noicon: !_vm.item.icon
          }
        }, [_vm.item.icon ? _c('v-icon', [_vm._v("\n          " + _vm._s(_vm.item.icon) + "\n        ")]) : _vm.item.iconString ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.item.iconString))])]) : _c('span', {
          staticClass: "txticon"
        }, [_vm._v(_vm._s(_vm.menuInitials))]), _vm._v(" "), _vm.item.badge && _vm.item.badge.value ? _c('v-badge', {
          staticClass: "menu-notification-badge",
          attrs: {
            "bottom": "",
            "overlap": "",
            "bordered": "",
            "content": _vm.item.badge.value,
            "value": _vm.item.badge.value,
            "color": _vm.item.badge.color
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_c('span', {
          staticClass: "subtitle-2"
        }, [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n          ")])])], 1), _vm._v(" "), _vm.item.badge || _vm.item.childs ? _c('v-list-item-action', [_vm.item.badge ? _c('v-badge', {
          staticClass: "menu-notification-badge",
          attrs: {
            "content": _vm.item.badge.value,
            "value": _vm.item.badge.value,
            "color": _vm.item.badge.color,
            "overlap": ""
          }
        }) : _vm._e(), _vm._v(" "), _vm.collapsable ? _c('v-btn', {
          staticClass: "zapan-buttoncollapsable",
          class: {
            collapsed: _vm.collapse
          },
          attrs: {
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.$emit('collapse');
            }
          }
        }, [_c('v-icon', [_vm._v("\n            mdi-chevron-up\n          ")])], 1) : _vm._e()], 1) : _vm._e()], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.item.name))])]);
};

var __vue_staticRenderFns__$W = [];
/* style */

const __vue_inject_styles__$W = function (inject) {
  if (!inject) return;
  inject("data-v-e17accf8_0", {
    source: ".menu-notification-badge[data-v-e17accf8]  .v-badge__badge{color:#000}.txticon[data-v-e17accf8]{width:24px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$W = "data-v-e17accf8";
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, createInjector, undefined, undefined);

var script$V = {
  components: {
    MenuItem: __vue_component__$1a,
    VDivider: VDivider,
    VIcon: VIcon,
    VAvatar: VAvatar,
    VImg: VImg,
    VListItemAvatar: VListItemAvatar,
    VBadge: VBadge,
    VListItemTitle: VListItemTitle,
    VListItemSubtitle: VListItemSubtitle,
    VListItemContent: VListItemContent,
    VBtn: VBtn,
    VTooltip: VTooltip,
    VListItemAction: VListItemAction,
    VListItem: VListItem,
    VList: VList
  },
  mixins: [mainNavigationMixin],
  props: {
    nuxt: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    exact: {
      type: Boolean,
      default: false
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rolicon() {
      if (this.user.role && this.user.role.icon) {
        return this.user.role.icon;
      } else {
        return false;
      }
    },

    rolcolor() {
      if (this.user.role && this.user.role.color) {
        return this.user.role.color;
      } else {
        return undefined;
      }
    },

    avatarTxt() {
      if (this.user.avatar) {
        return null;
      }

      return this.initials(this.user.name);
    },

    avatarColor() {
      return this.user.color || 'grey darken-2';
    },

    maxHeight() {
      var _this$user$menu;

      return (((_this$user$menu = this.user.menu) === null || _this$user$menu === void 0 ? void 0 : _this$user$menu.length) || 0) * 48 + 8;
    }

  },

  data() {
    return {
      usermenu: false
    };
  }

};

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-list', {
    staticClass: "pa-0",
    class: {
      mini: _vm.mini
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-list-item', [_c('v-badge', {
    attrs: {
      "value": !!_vm.rolicon,
      "color": _vm.rolcolor,
      "overlap": "",
      "avatar": "",
      "left": "",
      "offset-x": 27,
      "offset-y": 23
    },
    scopedSlots: _vm._u([{
      key: "badge",
      fn: function () {
        return [_c('v-avatar', [_c('v-icon', [_vm._v(_vm._s(_vm.rolicon))])], 1)];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-list-item-avatar', {
    attrs: {
      "dark": "",
      "color": _vm.avatarColor
    },
    on: {
      "click": function ($event) {
        _vm.usermenu = !_vm.usermenu;
      }
    }
  }, [_vm.user.avatar ? _c('v-img', {
    attrs: {
      "src": _vm.user.avatar
    }
  }) : _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.avatarTxt))])], 1)], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n        " + _vm._s(_vm.user.name) + "\n      ")]), _vm._v(" "), _vm.user.role ? _c('v-list-item-subtitle', [_vm._v("\n        " + _vm._s(_vm.user.role.name || _vm.user.role) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "openbutton",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              _vm.usermenu = !_vm.usermenu;
            }
          }
        }, on), [_c('v-icon', {
          class: {
            open: _vm.usermenu
          },
          attrs: {
            "color": "grey lighten-1"
          }
        }, [_vm._v("\n              mdi-chevron-up\n            ")])], 1)];
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Show/Hide Profile")])])], 1)], 1), _vm._v(" "), _vm.user.menu ? _c('div', {
    staticClass: "navigation-user-menu",
    class: {
      close: !_vm.usermenu
    },
    style: {
      'max-height': _vm.maxHeight + 'px'
    }
  }, [_c('v-divider'), _vm._v(" "), _vm._l(_vm.user.menu, function (item, index) {
    return _c('MenuItem', {
      key: index,
      attrs: {
        "item": item,
        "nuxt": _vm.nuxt,
        "exact": _vm.exact,
        "mini": _vm.mini
      }
    });
  })], 2) : _vm._e()], 1);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$V = function (inject) {
  if (!inject) return;
  inject("data-v-213489c9_0", {
    source: ".navigation-user-menu[data-v-213489c9]{margin-bottom:8px;transition:max-height ease .3s,margin-bottom ease .3s}.navigation-user-menu.close[data-v-213489c9]{margin-bottom:0;max-height:0!important}.openbutton .v-icon[data-v-213489c9]{transition:transform ease .3s}.openbutton .v-icon.open[data-v-213489c9]{transform:rotate(180deg)}.mini[data-v-213489c9]  .v-badge__badge{transform:translate(-24px) scale(.9)}.mini[data-v-213489c9]  .v-badge__badge .v-icon{transform:translate(5px)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$V = "data-v-213489c9";
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, createInjector, undefined, undefined);

/**
 * Navigation drawer for apps, with notifications, user menu,
 * mini version, etc.
 *
 * [Check in Playground](https://sandbox.technosylva.com/main-navigation/)
 * @displayName MainNavigation
 * @author dcrespo
 * @since 0.5.3
 */

var script$U = {
  components: {
    MenuItem: __vue_component__$1a,
    UserMenu: __vue_component__$19,
    Notification: __vue_component__$1b,
    ChangelogDialog: __vue_component__$1c,
    VImg: VImg,
    VListItemAvatar: VListItemAvatar,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem,
    VDivider: VDivider,
    VList: VList,
    VIcon: VIcon,
    VBtn: VBtn,
    VSubheader: VSubheader,
    VDialog: VDialog,
    VNavigationDrawer: VNavigationDrawer
  },
  mixins: [mainNavigationMixin],
  props: {
    /**
     * active [vuetify nuxt prop](https://vuetifyjs.com/en/api/v-list-item/#props-nuxt)
     */
    nuxt: {
      type: Boolean,
      default: false
    },

    /**
     * An array of [menu objects](#main-navigation-menu).
     */
    menu: {
      type: Array,
      required: true
    },

    /**
     * Title for menu. Usually its the web or app name.
     */
    title: {
      type: String,
      required: true
    },

    /**
     * Link to app logo to the left of the title.
     */
    img: {
      type: String,
      default: null
    },

    /**
     * (sync) show or hide menu
     */
    drawer: {
      type: Boolean,
      default: true
    },

    /**
     * (sync) active or disable mini mode, showing only icons.
     */
    mini: {
      type: Boolean,
      default: false
    },

    /**
     * User data and its menú. Use [user object](#main-navigation-user-object) data
     */
    user: {
      type: Object,
      default: null
    },

    /**
     * Link to home used when title is clicked
     */
    home: {
      type: String,
      default: null
    },

    /**
     * number of pending notifications
     */
    notifications: {
      type: Number,
      default: 0
    },

    /**
     * Text for notifications, if it is null only appears an icon.
     * Alternatively you can use the notification slot.
     */
    notificationText: {
      type: String,
      default: null
    },

    /**
     * Aplies exact prop to all links.
     * Can be override per link in [menu object](#main-navigation-menu).
     */
    exact: {
      type: Boolean,
      default: false
    },

    /**
     * Show the version of the app at menu footer.
     */
    version: {
      type: String,
      default: null
    },

    /**
     * Show the enviroment of the app at menu footer.
     */
    enviroment: {
      type: String,
      default: null
    },

    /**
     * Used in changelog popup title
     */
    appName: {
      type: String,
      default: null
    },

    /**
     * Array of string permissions.
     * to show the menu
     * @since 0.6.36
     */
    permissions: {
      type: [Array, Function],
      default: null
    },

    /**
     * Make sections collapsable.
     * @since 0.7.37
     */
    collapsable: {
      type: Boolean,
      default: false
    },

    /**
     * URL with version information.
     * @since 0.7.62
     */
    versionURL: {
      type: String,
      default: null
    }
  },
  computed: {
    isMobile() {
      const bpname = this.$vuetify.breakpoint.name;
      return bpname === 'xs' || bpname === 'sm';
    },

    menuPermissions() {
      if (this.permissions) {
        const newMenu = [];

        for (const menuO of this.menu) {
          const menu = cloneDeep(menuO);
          let permited = true;

          if (menu.permissions) {
            permited = this.checkPermissions(menu.permissions);
          }

          if (permited) {
            if (menu.childs) {
              const childs = menu.childs;
              menu.childs = [];

              for (const child of childs) {
                let permited = true;

                if (child.permissions) {
                  permited = this.checkPermissions(child.permissions);
                }

                if (permited) {
                  menu.childs.push(child);
                }
              }

              if (menu.childs.length === 0) {
                permited = false;
              }
            }

            if (permited) {
              newMenu.push(menu);
            }
          }
        }

        return newMenu;
      } else {
        return this.menu;
      }
    }

  },

  data() {
    return {
      versiondialog: false,
      collapsed: []
    };
  },

  mounted() {
    this.$nextTick(() => {
      if (this.isMobile) {
        /**
         * sync mini prop.
         * It is only called once at mounted if device is mobile
         * with true vale.
         * @property {boolean} value `true`
         */
        this.$emit('update:mini', true);
      }
    });
  },

  watch: {
    menu: {
      handler() {
        this.buildCollapsedList();
      },

      immediate: true,
      deep: true
    },

    collapsable() {
      this.buildCollapsedList();
    }

  },
  methods: {
    checkPermissions(permissions) {
      if (!permissions || !this.permissions) {
        return true;
      } else {
        let arrayPermissions;

        if (Array.isArray(permissions)) {
          arrayPermissions = permissions;
        } else if (typeof permissions === 'function') {
          return permissions(this.permissions);
        } else {
          arrayPermissions = [permissions];
        }

        if (Array.isArray(this.permissions)) {
          return arrayPermissions.some(p => this.permissions.includes(p));
        } else {
          return this.permissions(arrayPermissions);
        }
      }
    },

    buildCollapsedList() {
      const collapsed = [];

      for (const menu of this.menu) {
        if (this.collapsable && menu.closed === true) {
          collapsed.push(true);
        } else {
          collapsed.push(false);
        }
      }

      this.collapsed = collapsed;
    },

    collapse(index) {
      this.$set(this.collapsed, index, !this.collapsed[index]);
    }

  }
};

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-navigation-drawer', _vm._b({
    staticClass: "main-navigation-component",
    class: {
      isMobile: _vm.isMobile
    },
    attrs: {
      "value": _vm.drawer,
      "mini-variant": _vm.mini,
      "mobile-breakpoint": "0"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:drawer', $event);
      }
    },
    scopedSlots: _vm._u([_vm.title ? {
      key: "prepend",
      fn: function () {
        return [_c('v-list', {
          staticClass: "py-0"
        }, [_c('v-list-item', {
          staticClass: "title-item",
          attrs: {
            "to": _vm.home,
            "nuxt": _vm.home && _vm.nuxt,
            "exact": ""
          }
        }, [_vm.img || _vm.mini || _vm.$slots.logo ? _c('v-list-item-avatar', {
          staticClass: "rounded-0"
        }, [_vm.$slots.logo ? _vm._t("logo") : _vm.img ? _c('v-img', {
          attrs: {
            "src": _vm.img
          }
        }) : _c('span', {
          staticClass: "font-weight-medium"
        }, [_vm._v("\n            " + _vm._s(_vm.initials(_vm.title)) + "\n          ")])], 2) : _vm._e(), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-medium"
        }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('Notification', {
          key: "notification",
          attrs: {
            "notifications": _vm.notifications,
            "notification-text": _vm.notificationText
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (ref) {
              var close = ref.close;
              return [_vm._t("notifications", null, {
                "close": close
              })];
            }
          }, {
            key: "notification",
            fn: function () {
              return [_vm._t("notification")];
            },
            proxy: true
          }], null, true)
        })], 1)];
      },
      proxy: true
    } : null, _vm.user ? {
      key: "append",
      fn: function () {
        return [_c('UserMenu', {
          attrs: {
            "nuxt": _vm.nuxt,
            "user": _vm.user,
            "exact": _vm.exact,
            "mini": _vm.mini
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }, 'v-navigation-drawer', _vm.$attrs, false), [_vm._v(" "), _c('v-list', {
    class: {
      'with-notifications': _vm.notifications > 0
    }
  }, [_vm._l(_vm.menuPermissions, function (item, index) {
    return [item.title ? _c('v-subheader', {
      key: index,
      staticClass: "justify-space-between"
    }, [_c('span', [_vm._v("\n          " + _vm._s(item.title) + "\n        ")]), _vm._v(" "), _vm.collapsable ? _c('v-btn', {
      staticClass: "zapan-buttoncollapsable",
      class: {
        collapsed: _vm.collapsed[index]
      },
      attrs: {
        "icon": "",
        "x-small": ""
      },
      on: {
        "click": function ($event) {
          return _vm.collapse(index);
        }
      }
    }, [_c('v-icon', [_vm._v("\n            mdi-chevron-up\n          ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), item.title || index === 0 ? _c('v-divider', {
      key: index + 'divider',
      class: 'divider-' + index
    }) : _vm._e(), _vm._v(" "), !item.title ? _c('MenuItem', {
      key: index,
      attrs: {
        "item": item,
        "exact": _vm.exact,
        "mini": _vm.mini,
        "nuxt": _vm.nuxt,
        "collapsable": _vm.collapsable,
        "collapse": _vm.collapsed[index]
      },
      on: {
        "collapse": function ($event) {
          return _vm.collapse(index);
        }
      }
    }) : _vm._e(), _vm._v(" "), item.childs ? _c('div', {
      key: index + 'childdiv',
      staticClass: "childs",
      class: {
        collapsed: _vm.collapsed[index]
      },
      style: {
        height: 48 * item.childs.length + "px"
      }
    }, _vm._l(item.childs, function (child, indexChild) {
      return _c('MenuItem', {
        key: index + '_' + indexChild,
        attrs: {
          "item": child,
          "exact": _vm.exact,
          "mini": _vm.mini,
          "nuxt": _vm.nuxt
        }
      });
    }), 1) : _vm._e()];
  })], 2), _vm._v(" "), _vm.versionURL ? _c('a', {
    staticClass: "version-ref",
    attrs: {
      "href": _vm.versionURL,
      "target": "_blank"
    }
  }, [_vm.enviroment || _vm.version ? _c('div', {
    staticClass: "version-data"
  }, [_vm.enviroment ? _c('span', [_c('span', {
    staticClass: "hidemini"
  }, [_vm._v("Env: ")]), _c('span', [_vm._v("\n          " + _vm._s(_vm.enviroment) + "\n        ")])]) : _vm._e(), _vm._v(" "), _vm.versionURL ? _c('span') : _vm._e(), _vm._v(" "), _vm.version ? _c('span', [_c('span', {
    staticClass: "hidemini"
  }, [_vm._v(" Version:")]), _vm._v(" " + _vm._s(_vm.version) + "\n      ")]) : _vm._e()]) : _vm._e()]) : _c('v-dialog', {
    attrs: {
      "width": "500",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_vm.enviroment || _vm.version ? _c('div', _vm._g(_vm._b({
          staticClass: "version-data"
        }, 'div', attrs, false), on), [_vm.enviroment ? _c('span', [_c('span', {
          staticClass: "hidemini"
        }, [_vm._v("Env: ")]), _c('span', [_vm._v("\n            " + _vm._s(_vm.enviroment) + "\n          ")])]) : _vm._e(), _vm._v(" "), _vm.version ? _c('span', [_c('span', {
          staticClass: "hidemini"
        }, [_vm._v(" Version:")]), _vm._v(" " + _vm._s(_vm.version) + "\n        ")]) : _vm._e()]) : _vm._e()];
      }
    }]),
    model: {
      value: _vm.versiondialog,
      callback: function ($$v) {
        _vm.versiondialog = $$v;
      },
      expression: "versiondialog"
    }
  }, [_vm._v(" "), _c('ChangelogDialog', {
    attrs: {
      "app-name": _vm.appName
    },
    on: {
      "close": function ($event) {
        _vm.versiondialog = false;
      }
    }
  }, [_vm._t("about")], 2)], 1)], 1);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$U = function (inject) {
  if (!inject) return;
  inject("data-v-068e0b3f_0", {
    source: ".zapan-markdown-styles *{padding:revert;margin:revert}.zapan-buttoncollapsable{transition:transform .3s ease;color:rgba(255,255,255,.7)}.zapan-buttoncollapsable.collapsed{transform:rotate(180deg)}",
    map: undefined,
    media: undefined
  }), inject("data-v-068e0b3f_1", {
    source: ".title-item[data-v-068e0b3f]{height:64px}.title-item[data-v-068e0b3f]::before{opacity:0}.with-notifications[data-v-068e0b3f]{padding-top:0;margin-top:-6px}.main-navigation-component.isMobile[data-v-068e0b3f] .v-navigation-drawer__prepend .title-item{height:55px}.main-navigation-component[data-v-068e0b3f]  .v-navigation-drawer__append .v-avatar{justify-content:center!important}.main-navigation-component[data-v-068e0b3f] .v-subheader{transition:all ease .2s;overflow:hidden}.main-navigation-component[data-v-068e0b3f] .v-avatar{transition:margin-left ease .2s}.main-navigation-component[data-v-068e0b3f] .txticon{transition:opacity ease .2s}.main-navigation-component[data-v-068e0b3f] .v-list-item__icon .v-badge{transition:transform ease .2s}.main-navigation-component[data-v-068e0b3f] .theme--dark.v-badge .v-badge__badge::after{border-color:#363636}.main-navigation-component[data-v-068e0b3f] .v-list-item--active .theme--dark.v-badge .v-badge__badge::after{border-color:#666}.main-navigation-component[data-v-068e0b3f] .v-list-item:hover .theme--dark.v-badge .v-badge__badge::after{border-color:#464646}.main-navigation-component[data-v-068e0b3f] .v-navigation-drawer__content>.v-list:not(.with-notifications) hr.v-divider.divider-0{display:none}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .v-subheader+.v-divider{display:none}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .noicon{margin-right:0}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .noicon .txticon{opacity:0}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .v-list-item__icon .v-badge{transform:scale(0)}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .user-avatar{pointer-events:none}.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .notification-badge,.main-navigation-component[data-v-068e0b3f]:not(.v-navigation-drawer--mini-variant) .notification-icon{display:none}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .v-navigation-drawer__content{min-width:71px}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .with-notifications{padding-top:1px;margin-top:-1px}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .v-subheader{height:0}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .v-list-item__icon .v-badge{transform:scale(1)}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .v-avatar{margin-left:-10px}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .user-avatar{cursor:pointer}.main-navigation-component[data-v-068e0b3f].v-navigation-drawer--mini-variant .notification-btn{display:none}.main-navigation-component[data-v-068e0b3f] .v-navigation-drawer__content{display:flex;flex-direction:column;justify-content:space-between}.version-data[data-v-068e0b3f]{color:#fffFFF60;font-size:12px;display:flex;justify-content:space-evenly;cursor:pointer}.main-navigation-component.v-navigation-drawer--mini-variant[data-v-068e0b3f] .version-data{flex-direction:column;width:56px}.main-navigation-component.v-navigation-drawer--mini-variant[data-v-068e0b3f] .version-data span{text-overflow:ellipsis;overflow:hidden}.main-navigation-component.v-navigation-drawer--mini-variant[data-v-068e0b3f] .version-data .hidemini{display:none}.childs[data-v-068e0b3f]{overflow:hidden;transition:height .3s ease}.childs.collapsed[data-v-068e0b3f]{height:0!important}.version-ref[data-v-068e0b3f]{text-decoration:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$U = "data-v-068e0b3f";
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, createInjector, undefined, undefined);

var __vue_component__$18 = __vue_component__$17;

const isoDateValidator = function (value) {
  if (value) {
    return dateISOStringRegex.test(value);
  } else {
    return true;
  }
};

var CommonMixin = {
  props: {
    /**
     * text-field class
     */
    fieldClass: {
      type: String,
      default: null
    },

    /**
     * Datetime value. It has to be a UTC date.
     * If the date is not in the ISO format of UTC (ending in Z),
     * the conversion is forced and the value is updated.
     */
    value: {
      type: [String, Array],
      default: ''
    },

    /**
     * Display time zone.
     * Value is always UTC,
     * Using the time zone will change the way data is displayed.
     * This value can only be specified when starting the component.
     * Changing timezone does not affect the value, only how you interact with the data.
     */
    timezone: {
      type: String,
      default: 'UTC'
    },

    /**
     * You can use any [v-date-picker](https://vuetifyjs.com/en/api/v-date-picker/)
     * or [v-time-picker](https://vuetifyjs.com/en/api/v-time-picker/) props to custom
     * picker for datepicker or timepicker respectively.
     */
    pickerProps: {
      type: Object,
      default: () => ({})
    },

    /**
     * An UTC ISO string to set a max date value.
     */
    max: {
      type: String,
      default: null,
      validator: isoDateValidator
    },

    /**
     * An UTC ISO string to set a min date value.
     */
    min: {
      type: String,
      default: null,
      validator: isoDateValidator
    },

    /**
     * If true avoid write into text field and click icon to launch calendar/clock.
     */
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      menu: false,
      dateObj: null,
      dateObjRange: null,
      error: null
    };
  },

  computed: {
    maxValue() {
      if (this.max) {
        return new Date(this.max).getTime();
      } else {
        return null;
      }
    },

    minValue() {
      if (this.min) {
        return new Date(this.min).getTime();
      } else {
        return null;
      }
    },

    errorMessages() {
      if (this.error) {
        return [this.error];
      }

      return [];
    }

  },
  watch: {
    value(val) {
      if (!this.alone) {
        if (Array.isArray(val)) {
          this.dateObj = this.checkAndSetValueToDateObj(this.dateObj, val[0]);
          this.dateObjRange = this.checkAndSetValueToDateObj(this.dateObjRange, val[1]);
        } else {
          this.dateObj = this.checkAndSetValueToDateObj(this.dateObj, val);
        }
      }
    },

    timezone() {
      if (!this.alone) this.createDateObj();
    },

    'dateObjRange.utcDate'() {
      // Try to sort dates. From lower to higher
      try {
        const dateObjNix = new Date(this.dateObj.toString()).getTime();
        const dateObjRangeNix = new Date(this.dateObjRange.toString()).getTime();

        if (dateObjNix > dateObjRangeNix) {
          const dateObjRangeTmp = this.dateObjRange;
          this.dateObjRange = this.dateObj;
          this.dateObj = dateObjRangeTmp;
        }
      } catch (ex) {// Ignore
      }

      if (this.completeDay && this.dateObjRange.format('HH:mm:ss') !== '23:59:59') {
        this.dateObjRange.setZonedTime('23:59:59', 'HH:mm:ss');
      }

      this.emit();
    },

    'dateObj.utcDate'() {
      this.isMaxMinError();
      this.emit();
    },

    max() {
      this.isMaxMinError();
    },

    min() {
      this.isMaxMinError();
    }

  },

  created() {
    if (!this.alone) {
      this.createDateObj();
    }
  },

  methods: {
    isMaxMinError() {
      if (this.alone) {
        return false;
      }

      let error = false;
      const time = new Date(this.dateObj.toString()).getTime();

      if (this.maxValue) {
        if (time > this.maxValue) {
          error = true;
          this.error = 'The selected date is greater than the maximum allowed';
        }
      }

      if (this.minValue) {
        if (time < this.minValue) {
          error = true;
          this.error = 'The selected date is less than the minimum allowed';
        }
      }

      if (!error) this.error = null;
      return error;
    },

    checkAndSetValueToDateObj(dateObj, val) {
      if (dateObj === null) {
        dateObj = this.getTimeZonedDateTime(val);
      }

      if (dateObj.toString() !== val) {
        const forcedUtcVal = utcVal(val);

        try {
          dateObj.setUTC(forcedUtcVal);
        } catch (ex) {
          dateObj.setUTC(null);
        }
      }

      return dateObj;
    },

    createDateObj() {
      if (this.isRange) {
        this.dateObj = this.getTimeZonedDateTime(Array.isArray(this.value) ? this.value[0] : this.value);
        this.dateObjRange = this.getTimeZonedDateTime(Array.isArray(this.value) ? this.value[1] : this.value);
      } else {
        let value = this.value;
        if (Array.isArray(value)) value = value[0];
        this.dateObj = this.getTimeZonedDateTime(value);
      }
    },

    getTimeZonedDateTime(value, format) {
      const forcedUtcVal = utcVal(value);
      return new TimezonedDateTime(format || this.timezone, forcedUtcVal);
    },

    emit() {
      let emitValue;

      if (this.isRange) {
        emitValue = [this.dateObj.toString(), this.dateObjRange.toString()];
        emitValue = emitValue.filter(e => e);
      } else {
        emitValue = this.dateObj.toString();
      }
      /**
      * Emit date in UTC format.
      * @property {string} value
      */


      this.$emit('input', emitValue);
      /**
       * Emit formatted data as shown in the field
       * @property {string} value
       */

      this.$emit('update:formatted', this.displayValue);
    }

  }
};

const vuetifyFormat = 'yyyy-MM-dd';
/**
 * DatePicker selector with timezone.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/date-time-picker)
 * @displayName DatePicker
 * @author dcrespo
 * @since 0.5.3
 */

var script$T = {
  components: {
    VTextField: VTextField,
    VDatePicker: VDatePicker,
    VMenu: VMenu
  },
  directives: {
    mask
  },
  mixins: [CommonMixin],
  props: {
    /**
     * Display format
     */
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },

    /**
     * right icon. Clicking on the icon makes the selector appear.
     */
    appendIcon: {
      type: String,
      default: 'mdi-calendar'
    },

    /**
     * Allow select range.
     * Returns an array like [vuetify range prop](https://vuetifyjs.com/en/api/v-date-picker/#props-range)
     * but with values in UTC format
     */
    range: {
      type: Boolean,
      default: false
    },

    /**
     * When `:range='true'` returns the second date
     * in the range with the time at 23:59:59 timezoned <br>
     * If `:range='false'` returns the time at 23:59:59 timezoned (since 0.7.37)
     */
    completeDay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isRange() {
      return !!(this.range || this.pickerProps && this.pickerProps.range);
    },

    pickervalue: {
      get() {
        if (this.isRange) {
          if (this.dateObjRange.format(vuetifyFormat)) {
            return [this.dateObj.format(vuetifyFormat), this.dateObjRange.format(vuetifyFormat)];
          } else if (this.dateObj.format(vuetifyFormat)) {
            return [this.dateObj.format(vuetifyFormat)];
          } else {
            return null;
          }
        } else {
          return this.dateObj.format(vuetifyFormat);
        }
      },

      set(val) {
        if (this.isRange && Array.isArray(val)) {
          if (val[0]) this.dateObj.setZonedDate(val[0], vuetifyFormat);
          if (val[1]) this.dateObjRange.setZonedDate(val[1], vuetifyFormat);else this.dateObjRange.setUTC(null);
        } else {
          this.dateObj.setZonedDate(val, vuetifyFormat);

          if (this.completeDay) {
            this.dateObj.setZonedTime('23:59:59', 'HH:mm:ss');
          }
        }

        this.$nextTick(() => this.checkErrors());
      }

    },
    displayValue: {
      get() {
        try {
          const dateObjFormatted = this.dateObj.format(this.format);
          if (!dateObjFormatted) return '';

          if (this.isRange) {
            let dateObjRangeFormatted = '';

            if (this.dateObjRange) {
              dateObjRangeFormatted = this.dateObjRange.format(this.format);
            }

            return `${dateObjFormatted} ~ ${dateObjRangeFormatted}`;
          } else {
            this.$emit('error', false);
            return dateObjFormatted;
          }
        } catch (ex) {
          // eslint-disable-next-line no-console
          console.error('Wrong format at DatePicker component', ex);
          this.$emit('error', true);
          return null;
        }
      },

      set(val) {
        if (this.isRange) {
          const splited = val ? val.split(' ~ ') : [];

          if (this.isValidDate(splited[0])) {
            this.dateObj.setZonedDate(splited[0], this.format);
          } else if (isNullUndefinedOrEmptyString(splited[0])) {
            this.dateObj.setUTC(null);
          }

          if (this.isValidDate(splited[1])) {
            this.dateObjRange.setZonedDate(splited[1], this.format);
          } else if (isNullUndefinedOrEmptyString(splited[1])) {
            this.dateObjRange.setUTC(null);
          }
        } else {
          if (this.isValidDate(val)) {
            this.dateObj.setZonedDate(val, this.format);

            if (this.completeDay) {
              this.dateObj.setZonedTime('23:59:59', 'HH:mm:ss');
            }
          } else if (isNullUndefinedOrEmptyString(val)) {
            this.dateObj.setUTC(null);
          }
        }
      }

    },

    mask() {
      const mask = this.format.replace(/[a-z]/ig, '#');

      if (this.isRange) {
        return `${mask} ~ ${mask}`;
      } else {
        return mask;
      }
    }

  },
  watch: {
    isRange() {
      this.createDateObj();
      this.emit();
    },

    menu(val) {
      this.$emit('pickerOpened', val);
    }

  },
  methods: {
    isValidDate(val) {
      try {
        const parsedDate = parse(val, this.format, new Date());
        return isValid(parsedDate) && val.length === this.format.length;
      } catch (ex) {
        return false;
      }
    },

    closePicker(event) {
      if (this.isRange && event[0] && event[1]) {
        this.menu = false;
      } else if (!this.isRange) {
        this.menu = false;
      }
    },

    checkErrors() {
      const value = this.$refs.input.internalValue;
      let validDate = false;

      if (value) {
        if (this.isRange) {
          const dates = value.split(' ~ ');
          validDate = this.isValidDate(dates[0]) && this.isValidDate(dates[1]);
        } else {
          validDate = this.isValidDate(value);
        }
      }

      if (value && !validDate) {
        this.error = 'Invalid date, required format ' + this.format;
        /**
         * Emit true when there are an error and false when not
         * @property {boolean} value
         */

        this.$emit('error', true);
      } else if (this.isMaxMinError()) {
        this.$emit('error', true);
      } else {
        this.error = null;
        this.$emit('error', false);
      }
    }

  }
};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        return [_c('v-text-field', _vm._b({
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: _vm.mask,
            expression: "mask"
          }],
          ref: "input",
          class: _vm.fieldClass,
          attrs: {
            "readonly": _vm.readonly,
            "append-icon": _vm.appendIcon,
            "error-messages": _vm.errorMessages
          },
          on: {
            "blur": _vm.checkErrors,
            "focus": function ($event) {
              _vm.error = null;
            },
            "click:append": function ($event) {
              _vm.readonly ? undefined : _vm.menu = true;
            }
          },
          model: {
            value: _vm.displayValue,
            callback: function ($$v) {
              _vm.displayValue = $$v;
            },
            expression: "displayValue"
          }
        }, 'v-text-field', Object.assign({}, attrs, _vm.$attrs), false))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', _vm._b({
    attrs: {
      "range": _vm.isRange
    },
    on: {
      "input": _vm.closePicker,
      "click": function ($event) {
        _vm.error = null;
      }
    },
    model: {
      value: _vm.pickervalue,
      callback: function ($$v) {
        _vm.pickervalue = $$v;
      },
      expression: "pickervalue"
    }
  }, 'v-date-picker', _vm.pickerProps, false))], 1);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = "data-v-35468c53";
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

/**
 * TimePicker selector with timezone.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/date-time-picker)
 * @displayName TimePicker
 * @author dcrespo
 * @since 0.5.3
 */

var script$S = {
  components: {
    VTextField: VTextField,
    VTimePicker: VTimePicker,
    VMenu: VMenu
  },
  props: {
    /**
     * Allows you to use this component without TimePicker.
     * Will always return a string in HH:mm or HH:mm:ss format if seconds: true
     */
    alone: {
      type: Boolean,
      default: false
    },

    /**
     * Allow set seconds
     */
    seconds: {
      type: Boolean,
      default: false
    },

    /**
     * Picker format.
     * @values 24hr, ampm
     */
    format: {
      type: String,
      default: '24hr',

      validator(value) {
        return ['24hr', 'ampm'].indexOf(value) !== -1;
      }

    },

    /**
     * right icon. Clicking on the icon makes the selector appear.
     */
    appendIcon: {
      type: String,
      default: 'mdi-clock-time-four-outline'
    },

    /**
     * Prevent time from filling with 00:00 when date is set in datepicker
     *
     * @since 0.7.81
     */
    preventAutoFill: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      preventDisplay: false
    };
  },

  directives: {
    mask
  },
  mixins: [CommonMixin],
  computed: {
    displayValue: {
      get() {
        if (this.alone) {
          return this.value;
        } else if (!this.preventDisplay) {
          let format;

          if (this.seconds) {
            format = 'HH:mm:ss';
          } else {
            format = 'HH:mm';
          }

          return this.dateObj.format(format);
        } else {
          return '';
        }
      },

      set(val) {
        if (this.isValidTime(val)) {
          if (this.alone) {
            /**
             * Emit date in UTC format.
             * If alone: true emit same as `@update:formatted`
             * @property {string} value
             */
            this.$emit('input', val);
          } else {
            this.dateObj.setZonedTime(val);
          }

          this.$nextTick(() => this.checkErrors());
        }
      }

    },

    disabled() {
      if (this.alone) return false;else return !this.value;
    },

    mask() {
      if (this.seconds) {
        return '##:##:##';
      } else {
        return '##:##';
      }
    }

  },
  methods: {
    isValidTime(val) {
      return this.seconds && HHMMSSRegex.test(val) || !this.seconds && HHMMRegex.test(val);
    },

    clickMinute() {
      if (!this.seconds) {
        this.menu = false;
      }
    },

    clickSecond() {
      this.menu = false;
    },

    checkErrors() {
      const value = this.$refs.input.internalValue;

      if (!this.isValidTime(value)) {
        this.error = 'Invalid time';
        /**
         * Emit true when there are an error and false when not
         * @property {boolean} value
         */

        this.$emit('error', true);
      } else if (this.isMaxMinError()) {
        this.$emit('error', true);
      } else {
        this.error = null;
        this.$emit('error', false);
      }
    }

  },

  created() {
    if (this.preventAutoFill) {
      this.preventDisplay = true;
      this.$watch('value', (current, old) => {
        this.preventDisplay = isNullUndefinedEmptyStringOrEmptyArray(old);
      });
    }
  }

};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": _vm.seconds ? '320px' : '290px',
      "min-width": _vm.seconds ? '320px' : '290px'
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        return [_c('v-text-field', _vm._b({
          directives: [{
            name: "mask",
            rawName: "v-mask",
            value: _vm.mask,
            expression: "mask"
          }],
          ref: "input",
          class: _vm.fieldClass,
          attrs: {
            "append-icon": _vm.appendIcon,
            "disabled": _vm.disabled || _vm.$attrs.disabled,
            "readonly": _vm.readonly,
            "error-messages": _vm.errorMessages
          },
          on: {
            "click:append": function ($event) {
              _vm.readonly ? undefined : _vm.menu = true;
            },
            "blur": _vm.checkErrors,
            "focus": function ($event) {
              _vm.error = null;
            }
          },
          model: {
            value: _vm.displayValue,
            callback: function ($$v) {
              _vm.displayValue = $$v;
            },
            expression: "displayValue"
          }
        }, 'v-text-field', Object.assign({}, attrs, _vm.$attrs), false))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _vm.menu ? _c('v-time-picker', _vm._b({
    attrs: {
      "full-width": "",
      "use-seconds": _vm.seconds,
      "format": _vm.format
    },
    on: {
      "click:minute": _vm.clickMinute,
      "click:second": _vm.clickSecond,
      "click": function ($event) {
        _vm.error = null;
      }
    },
    model: {
      value: _vm.displayValue,
      callback: function ($$v) {
        _vm.displayValue = $$v;
      },
      expression: "displayValue"
    }
  }, 'v-time-picker', _vm.pickerProps, false)) : _vm._e()], 1);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$S = undefined;
/* scoped */

const __vue_scope_id__$S = "data-v-76795f86";
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

var script$R = {
  components: {
    VBtn: VBtn,
    VIcon: VIcon,
    VCardTitle: VCardTitle,
    VCol: VCol,
    VRow: VRow,
    VCardText: VCardText,
    VCard: VCard,
    VDialog: VDialog
  },
  mixins: [i18n('DataTable')],
  props: {
    value: {
      type: Array,
      required: true
    },
    header: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      dialog: false
    };
  },

  computed: {
    cropValue() {
      const crop = this.header.limit || 3;
      return this.value.slice(0, crop);
    },

    itemsLeft() {
      return this.value.length - this.cropValue.length;
    }

  }
};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_vm._l(_vm.cropValue, function (item, index) {
    return _c('span', {
      key: index
    }, [_vm._t("default", function () {
      return [_vm._v("\n      " + _vm._s(item) + "\n    ")];
    }, {
      "item": item
    })], 2);
  }), _vm._v(" "), _vm.itemsLeft > 0 ? _c('v-btn', {
    staticClass: "mb-1",
    attrs: {
      "x-small": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = true;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.t('seeMore', {
    msg: _vm.itemsLeft
  })) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm._t("modal", function () {
    return [_c('v-card', [_c('v-card-title', {
      staticClass: "d-flex justify-space-between"
    }, [_vm._v("\n          " + _vm._s(_vm.header.text) + "\n          "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function ($event) {
          _vm.dialog = false;
        }
      }
    }, [_c('v-icon', [_vm._v("\n              mdi-close\n            ")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', _vm._l(_vm.value, function (item, index) {
      return _c('v-col', {
        key: index,
        attrs: {
          "cols": _vm.header.modalCol || 12
        }
      }, [_vm._t("default", function () {
        return [_vm._v("\n                " + _vm._s(item) + "\n              ")];
      }, {
        "item": item
      })], 2);
    }), 1)], 1)], 1)];
  }, {
    "close": function () {
      return _vm.dialog = false;
    },
    "items": _vm.value
  })], 2)], 2);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = "data-v-0079b547";
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

//
const extraComponents = {
  VTextField
} ;
var script$Q = {
  mixins: [i18n('DataTable')],
  // Need only in prod
  components: { ...extraComponents,
    CellArrayValue: __vue_component__$14,
    VIcon: VIcon,
    VBtn: VBtn,
    VProgressCircular: VProgressCircular
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    editableCell: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      editableField: null,
      loading: false,
      transformedValue: null,
      enableEdit: false,
      // shows edit
      disableEdit: false // set edit to disabled

    };
  },

  computed: {
    headerEditable() {
      if (typeof this.header.editable === 'function') {
        return this.header.editable(this.value, this.data.item);
      } else {
        return this.header.editable;
      }
    },

    editFieldEnabled() {
      if (this.editable && this.headerEditable) {
        return true;
      } else if (this.editableCell && this.enableEdit) {
        return true;
      } else {
        return false;
      }
    },

    wrap() {
      if (this.header.wrap === undefined) {
        return true;
      } else {
        return !!this.header.wrap;
      }
    },

    value() {
      let path = this.header.dataProp;
      if (isNullOrUndefined(path)) path = this.header.value;
      return getObjectValueByPath(this.data.item, path);
    },

    enabledNoData() {
      return this.header.nodata && isNullUndefinedEmptyStringOrEmptyArray(this.transformedValue);
    }

  },
  watch: {
    value() {
      this.getValue();
    },

    editable: {
      handler(val) {
        if (val) {
          this.captureFieldBlur();
        }
      },

      immediate: true
    },

    enableEdit(value) {
      this.$emit('editing', value);
    }

  },

  async created() {
    this.editableField = this.value;
    this.getValue();
    this.warningEditableComponent();
  },

  methods: {
    switchEnableEdit() {
      if (this.enableEdit) {
        this.editableField = this.value;
      }

      this.enableEdit = !this.enableEdit;
    },

    setDisabledConfirm(value) {
      this.disableEdit = value;
    },

    cancelEnableEdit() {
      if (this.enableEdit) {
        this.switchEnableEdit();
      }
    },

    captureFieldBlur() {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (this.$refs.editComponent) {
            const el = this.$refs.editComponent.$el;
            let input;
            const elements = el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

            if (elements) {
              input = elements[elements.length - 1];
            } else {
              input = el;
            }

            input.addEventListener('blur', event => {
              this.emitUpdate();
            });
          }
        });
      });
    },

    update(value) {
      this.editableField = value;
    },

    emitUpdate(force) {
      this.enableEdit = false;
      const isEq = this.value === this.editableField || this.transformed === this.editableField;
      if (!isEq || force) this.$emit('update', this.editableField);
    },

    async getValue() {
      if (typeof this.header.transform === 'function') {
        this.loading = true;
        this.transformedValue = await this.header.transform(this.value, this.data.item);
        this.loading = false;
      } else if (this.header.transform) {
        this.loading = true;
        this.transformedValue = await this.header.transform;
        this.loading = false;
      } else {
        this.transformedValue = this.value;
      }
    },

    warningEditableComponent() {
      if (this.header && this.header.editable && typeof this.header.editable.component === 'string') {
        console.error('[Zapan warn]: Use editable.component as object instead string because it is bugged only in prod.');
      }
    }

  }
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "cell",
    staticClass: "cell-wrapper",
    class: {
      enableEdit: _vm.enableEdit
    }
  }, [_vm.headerEditable && _vm.editableCell ? _c('v-btn', {
    staticClass: "edit-button edit",
    attrs: {
      "elevation": "2",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": _vm.switchEnableEdit
    }
  }, [_vm.enableEdit ? _c('v-icon', [_vm._v("\n      mdi-close\n    ")]) : _c('v-icon', [_vm._v("\n      mdi-pencil\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm.enableEdit ? _c('v-btn', {
    staticClass: "edit-button save",
    attrs: {
      "disabled": _vm.disableEdit,
      "elevation": "2",
      "fab": "",
      "x-small": ""
    },
    on: {
      "click": _vm.emitUpdate
    }
  }, [_c('v-icon', [_vm._v("\n      mdi-check\n    ")])], 1) : _vm._e(), _vm._v(" "), _vm.editFieldEnabled ? _vm._t('item.field.' + _vm.header.value, function () {
    return [_c(_vm.headerEditable.component || 'v-text-field', _vm._b({
      ref: "editComponent",
      tag: "component",
      staticClass: "in-table-edit shrink",
      attrs: {
        "hide-details": "",
        "outlined": "",
        "dense": ""
      },
      model: {
        value: _vm.editableField,
        callback: function ($$v) {
          _vm.editableField = $$v;
        },
        expression: "editableField"
      }
    }, 'component', _vm.headerEditable.attrs, false))];
  }, null, Object.assign({}, _vm.data, {
    value: _vm.value,
    update: _vm.update,
    cancel: _vm.cancelEnableEdit,
    confirm: _vm.emitUpdate,
    setDisabledConfirm: _vm.setDisabledConfirm,
    cell: _vm.$refs.cell
  })) : _vm.loading ? _c('span', [_c('v-progress-circular', {
    attrs: {
      "size": 16,
      "width": 3,
      "indeterminate": ""
    }
  })], 1) : _vm.enabledNoData ? _c('span', {
    key: _vm.header.slot,
    staticClass: "grey--text",
    class: {
      'text-no-wrap': !_vm.wrap
    }
  }, [_vm._v("\n    " + _vm._s(_vm.t('noData')) + "\n  ")]) : Array.isArray(_vm.transformedValue) ? [_vm._t('item.display.' + _vm.header.value, function () {
    return [_c('CellArrayValue', {
      attrs: {
        "header": _vm.header,
        "value": _vm.transformedValue
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (slotsData) {
          return [_vm._t('item.array.row.' + _vm.header.value, null, null, slotsData)];
        }
      }, {
        key: "modal",
        fn: function (slotsData) {
          return [_vm._t('item.array.modal.' + _vm.header.value, null, null, Object.assign({}, _vm.data, slotsData))];
        }
      }], null, true)
    })];
  }, null, Object.assign({}, _vm.data, {
    value: _vm.transformedValue
  }))] : [_vm._t('item.display.' + _vm.header.value, function () {
    return [_c('span', {
      class: {
        'text-no-wrap': !_vm.wrap
      }
    }, [_vm._v("\n        " + _vm._s(_vm.transformedValue) + "\n      ")])];
  }, null, Object.assign({}, _vm.data, {
    value: _vm.transformedValue
  }))]], 2);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$Q = function (inject) {
  if (!inject) return;
  inject("data-v-2ec47750_0", {
    source: ".cell-wrapper[data-v-2ec47750]{position:relative;height:100%;align-items:center;display:inline-flex}button.wrapper[data-v-2ec47750]{width:100%;text-align:left;margin:-4px;padding:4px;outline:1px dashed #474747}.in-table-edit[data-v-2ec47750]{margin-top:0;margin-left:-12px}.edit-button[data-v-2ec47750]{position:absolute;right:0;right:-6px;height:16px;width:16px;transition:opacity .3s ease;opacity:0;z-index:1}.edit-button[data-v-2ec47750]  .v-icon{font-size:11px}.edit-button.save[data-v-2ec47750]{top:22px}.edit-button.edit[data-v-2ec47750]{top:4px}.cell-wrapper.enableEdit .edit-button[data-v-2ec47750]{opacity:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$Q = "data-v-2ec47750";
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, createInjector, undefined, undefined);

var script$P = {
  props: {
    value: {
      type: [String, Number, Object],
      default: null
    },
    suffix: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: null
    }
  },
  computed: {
    text() {
      if (typeof this.value === 'object') {
        return getObjectValueByPath(this.value, this.valueKey, this.value);
      } else {
        return this.value;
      }
    }

  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('p', {
    staticClass: "text mb-0"
  }, [_vm._v("\n  " + _vm._s(_vm.prefix) + _vm._s(_vm.text) + _vm._s(_vm.suffix) + "\n")]);
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = "data-v-94b2d0a8";
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

/**
   * A combination of property and its name to display
   * a very accurate information.
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/info-chip)
   * @displayName InfoChip
   * @author dcrespo
   * @since 0.5.15
   */

var script$O = {
  components: {
    infochiprow: __vue_component__$12
  },
  props: {
    /**
     * Name of the property.
     */
    label: {
      type: String,
      required: true
    },

    /**
     * Text of the property. If text is an array prints multiline.
     */
    text: {
      type: [String, Number, Array, Object],
      default: null
    },

    /**
     * A string displayed after the text.
     */
    suffix: {
      type: String,
      default: ''
    },

    /**
     * A string displayed before the text.
     */
    prefix: {
      type: String,
      default: ''
    },

    /**
     * The String that will replace the text if it's empty.
     */
    nodataText: {
      type: String,
      default: 'No Data'
    },

    /**
     * Enables or disables the text.
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * If text is an object or an array of objects
     * you can use this prop to print specific value key.
     * It's allow deep key using a syntax like `myprop.item[0].value`
     * @since 0.6.32
     */
    valueKey: {
      type: String,
      default: null
    }
  },
  computed: {
    nodata() {
      if (this.isArray && this.text.length === 0) {
        return true;
      } else {
        return isNullOrUndefined(this.text);
      }
    },

    isArray() {
      return Array.isArray(this.text);
    }

  }
};

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('p', {
    staticClass: "caption mb-1 grey--text text--darken-2"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]), _vm._v(" "), _vm.$slots.default ? _vm._t("default") : _vm.nodata ? _c('p', {
    staticClass: "no-data mb-0"
  }, [_vm._v("\n    " + _vm._s(_vm.nodataText) + "\n  ")]) : _vm.isArray ? _vm._l(_vm.text, function (line, index) {
    return _c('infochiprow', {
      key: index,
      class: {
        'no-data': _vm.disabled
      },
      attrs: {
        "prefix": _vm.prefix,
        "suffix": _vm.suffix,
        "value-key": _vm.valueKey,
        "value": line
      }
    });
  }) : _c('infochiprow', {
    key: _vm.index,
    class: {
      'no-data': _vm.disabled
    },
    attrs: {
      "prefix": _vm.prefix,
      "suffix": _vm.suffix,
      "value-key": _vm.valueKey,
      "value": _vm.text
    }
  })], 2);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = function (inject) {
  if (!inject) return;
  inject("data-v-6fd06c9f_0", {
    source: ".text[data-v-6fd06c9f]{color:rgba(0,0,0,.87);min-height:1rem}.no-data[data-v-6fd06c9f]{color:rgba(0,0,0,.37)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$O = "data-v-6fd06c9f";
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, createInjector, undefined, undefined);

var script$N = {
  mixins: [i18n('DataTable')],
  components: {
    InfoChip: __vue_component__$11,
    VSelect: VSelect,
    VCol: VCol,
    VPagination: VPagination,
    VRow: VRow
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        page: 1,
        itemsPerPage: 10
      })
    },
    items: {
      type: Array,
      default: () => [5, 10, 15]
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changePage(i) {
      const newOptions = { ...this.options
      };
      newOptions.page = i;
      this.$emit('update:options', newOptions);
    },

    changeItemsPerPage(i) {
      const newOptions = { ...this.options
      };
      newOptions.itemsPerPage = parseInt(i, 10);
      this.$emit('update:options', newOptions);
    }

  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "value": _vm.options.itemsPerPage,
      "label": _vm.t('itemsPerPage'),
      "items": _vm.items,
      "hide-details": ""
    },
    on: {
      "input": _vm.changeItemsPerPage
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "col-pagination"
  }, [_c('div', [_c('v-pagination', {
    staticClass: "pagination",
    attrs: {
      "value": _vm.options.page,
      "length": Math.ceil((_vm.total || 0) / _vm.options.itemsPerPage),
      "total-visible": 7,
      "circle": "",
      "color": "primary"
    },
    on: {
      "input": _vm.changePage
    }
  })], 1)]), _vm._v(" "), _c('v-col', {
    staticClass: "coltotal",
    attrs: {
      "cols": "auto"
    }
  }, [_c('info-chip', {
    attrs: {
      "label": _vm.t('totalItems'),
      "text": _vm.loading && _vm.total === null ? '--' : _vm.total
    }
  })], 1)], 1);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = function (inject) {
  if (!inject) return;
  inject("data-v-1290843c_0", {
    source: ".pagination[data-v-1290843c]  button{outline:0}.coltotal[data-v-1290843c]{width:124px}.coltotal[data-v-1290843c]  .caption,.coltotal[data-v-1290843c]  .text{text-align:right}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$N = "data-v-1290843c";
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, createInjector, undefined, undefined);

var TableInfiniteScrollMixin = {
  props: {
    /**
      Infinite scroll. Load new items with scroll. <br>
      Disables bottom pagination. <br> since `0.7.44`
    */
    infinite: {
      type: Boolean,
      default: false
    },

    /**
     * Number of pixels before reaching the final scroll
     * to start loading the next page
     */
    infiniteMargin: {
      type: Number,
      default: 250
    }
  },

  data() {
    return {
      loadingScroll: false
    };
  },

  watch: {
    'options.page'(value, oldValue) {
      if (this.infinite && !this.loading && value !== oldValue) {
        if (this.value === 1) {
          this.localItems = [];
        }

        this.refresh();
      }
    },

    filters() {
      this.localItems = [];
    },

    search() {
      this.localItems = [];
    }

  },

  mounted() {
    if (this.infinite) {
      const el = this.$refs.table.$el.querySelector('.v-data-table__wrapper');
      el.addEventListener('scroll', this.infiniteScrollEvent);
      this.resizeObserver = new ResizeObserver(debounce(() => {
        this.infiniteScrollEvent();
      }, 250)).observe(this.$refs.table.$el.children[0]);
    }
  },

  methods: {
    infiniteScrollEvent() {
      if (this.$refs.table && this.$refs.table.$el && this.$refs.table.$el.children && this.$refs.table.$el.children[0]) {
        const target = this.$refs.table.$el.children[0];

        if (target.clientHeight + this.infiniteMargin === target.scrollHeight || // no scroll or small scroll
        Math.ceil(target.scrollTop) + this.infiniteMargin >= target.scrollHeight - target.offsetHeight // scroll bottom
        ) {
          if (this.localItems.length < this.total && !this.loading) {
            this.$set(this.options, 'page', this.options.page + 1);
          }
        }
      }
    }

  },

  beforeDestroy() {
    if (this.infinite) {
      const el = this.$refs.table.$el.querySelector('.v-data-table__wrapper');
      el.removeEventListener('scroll', this.infiniteScrollEvent);
    }

    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

};

/**
   * Vuetify table with some enhancements.
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/data-table)
   * @displayName Grid
   * @author dcrespo
   * @since 0.5.7
   */

const defaultOptions = {
  page: 1,
  itemsPerPage: 10,
  multiSort: false,
  mustSort: false,
  sortBy: [],
  sortDesc: [],
  groupBy: [],
  groupDesc: []
};

const setHeaderClass = (header, prop, newClass) => {
  if (header[prop] && Array.isArray(header[prop])) {
    header[prop].push(newClass);
  } else if (header[prop]) {
    header[prop] = [header[prop], newClass];
  } else {
    header[prop] = newClass;
  }
};

var script$M = {
  components: {
    Pagination: __vue_component__$10,
    Cell: __vue_component__$13,
    VProgressCircular: VProgressCircular,
    VAlert: VAlert,
    VDataTable: VDataTable
  },
  mixins: [TableInfiniteScrollMixin, i18n('DataTable')],
  props: {
    /**
     * Table settings. Look [table description](#table-props) for more info.
     */
    table: {
      type: Object,
      required: true
    },

    /**
     * A key-value filters.
     */
    filters: {
      type: Object,
      default: null
    },

    /**
     * Filters passed as 4º parameter to list
     */
    tsylfilters: {
      type: Array,
      default: () => []
    },

    /**
     * Search value of table's list function. Any change of this will be fire list funcion.
     */
    search: {
      type: String,
      default: null
    },

    /**
     * (sync) An array of selected items. Acts like data-table vuetify value.
     * Use table.key as key.
     */
    selected: {
      type: Array,
      default: () => []
    },

    /**
     * The array of items to display
     */
    items: {
      type: Array,
      default: null
    },

    /**
     * vuetify `v-data-table` class
     */
    tableClass: {
      type: String,
      default: null
    },

    /**
     * Hide pagination
     */
    noPagination: {
      type: Boolean,
      default: false
    },

    /**
     * Any change of this prop exec doReset() method
     */
    reset: {
      type: [Number, String, Object, Array, Boolean],
      default: null
    },

    /**
     * Any change of this prop exec doReload() method
     */
    reload: {
      type: [Number, String, Object, Array, Boolean],
      default: null
    },

    /**
     * Internal use. Override table.headers. Use to hide columns.
     * @ignore
     */
    selectedColumns: {
      type: Array,
      default: null
    },

    /**
     * Index table into DataTable tabs
     * @ignore
     */
    index: {
      type: Number,
      default: 0
    },

    /**
     * Save settings per grid. If you change page and back
     * your page, items per page and sort will be restored.
     * Use an unique key string.
     * Cache will be saved in localstorage.
     */
    cacheKey: {
      type: String,
      default: null
    },

    /**
     * true to active editable columns
     */
    editable: {
      type: Boolean,
      default: false
    },

    /**
     * true to active editable columns cell by cell
     */
    editableCell: {
      type: Boolean,
      default: false
    },

    /**
     * Default table options. More info [Vuetify v-data-table Options](https://vuetifyjs.com/en/api/v-data-table/#props-options)
     */
    defaultOptions: {
      type: Object,
      default: () => {}
    },

    /**
     * Enables select all toast and `fullSelect` event
     * since `0.7.44`
     */
    selectAll: {
      type: Boolean,
      default: false
    },

    /**
     * call list method on column visibility change
     * since `0.7.79`
     */
    refreshOnChangeColumns: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    'sortable-table': {
      inserted: (el, binding) => {
        Sortable.create(el.querySelector('tr'), binding.value ? { ...binding.value,
          handle: '.z-t-reorderable',
          filter: '.z-t-fixed'
        } : {});
      }
    }
  },

  data() {
    return {
      localItems: [],
      total: null,
      loading: false,
      options: { ...defaultOptions,
        ...this.defaultOptions
      },
      savedParams: null,
      loadReady: false,
      showSelectAllToast: false,
      fullSelect: false,
      editingCount: 0,
      sortedColumns: [],
      refreshSortedColumns: 0
    };
  },

  watch: {
    reset() {
      this.doReset();
    },

    reload() {
      this.doReload();
    },

    options(newval, oldval) {
      if (!isEqual(oldval, newval)) {
        this.refresh();
      }

      if (this.cacheKey && this.loadReady && !this.infinite) {
        const stringfied = JSON.stringify(newval);
        localStorage.setItem(this.cacheKey + '' + this.index, stringfied);
      }
    },

    filters() {
      var _this$defaultOptionsC;

      this.options.page = ((_this$defaultOptionsC = this.defaultOptionsComplete) === null || _this$defaultOptionsC === void 0 ? void 0 : _this$defaultOptionsC.page) || 1;
      this.refresh(true); // Force = true porque se borran todas las filas cuando el filtro está vacío.
      // sin embargo no hay forma de encontrar porqué.
    },

    search() {
      var _this$defaultOptionsC2;

      this.options.page = ((_this$defaultOptionsC2 = this.defaultOptionsComplete) === null || _this$defaultOptionsC2 === void 0 ? void 0 : _this$defaultOptionsC2.page) || 1;
      this.refresh();
    },

    items: {
      handler(val) {
        if (val) {
          this.total = val.length;
          if (this.noPagination) this.options.itemsPerPage = val.length;
          this.localItems = cloneDeep(this.items);
        }
      },

      immediate: true,
      deep: true
    },

    selected(value) {
      if (value.length === this.localItems.length && value.length < this.total) {
        this.showSelectAllToast = true;
      } else if (value.length < this.total) {
        this.showSelectAllToast = false;
      }
    },

    localItems(value) {
      /**
       * Send all items in table
       * @since 0.7.51
       * @property {array} data - All table items
      */
      this.$emit('allItems', value);
      this.$nextTick(() => {
        this.buildHoverEvent();
      });
    },

    selectedColumns() {
      if (this.refreshOnChangeColumns) {
        this.getData(true);
      }
    }

  },
  computed: {
    headers() {
      let headers = cloneDeep(this.table.headers);

      for (let i = 0; i < headers.length; i++) {
        const header = headers[i];

        if (header.fixed) {
          setHeaderClass(header, 'class', 'z-t-fixed');
          setHeaderClass(header, 'cellClass', 'z-t-fixed');
          let positionClass = 'z-t-fixed-left';

          if (i > headers.length / 2) {
            positionClass = 'z-t-fixed-right';
          }

          setHeaderClass(header, 'class', positionClass);
          setHeaderClass(header, 'cellClass', positionClass);
        }

        if (header.reorderable) {
          setHeaderClass(header, 'class', 'z-t-reorderable');
        }

        const headerKey = this.getHeaderUniqueKey(header);
        header.sortIndex = this.sortedColumns.indexOf(headerKey);

        if (header.sortIndex === undefined) {
          header.sortIndex = i;
        }
      }

      if (this.selectedColumns) {
        headers = headers.filter(t => {
          const cachedColumn = this.selectedColumns.find(c => c.value === t.value && c.text === t.text && t.dataProp === c.dataProp);

          if (cachedColumn) {
            return cachedColumn.visible !== false;
          } else {
            return t.visible;
          }
        });
      }

      headers = headers.sort((a, b) => a.sortIndex - b.sortIndex);
      return headers;
    },

    columnsWithModifiers() {
      const columns = [];

      for (const header of this.headers) {
        if (this.$scopedSlots[`item.${header.value}`]) {
          continue;
        }

        if (this.$scopedSlots[`item.display${header.value}`] || header.transform || header.nodata !== false || header.dataProp || header.editable) {
          columns.push({
            nodata: true,
            slot: `item.${header.value}`,
            ...header
          });
        }
      }

      return columns;
    },

    computedListeners() {
      const listeners = this.$listeners;
      delete listeners.input;
      return listeners;
    },

    defaultOptionsComplete() {
      return { ...defaultOptions,
        ...this.defaultOptions
      };
    },

    computedAttrs() {
      const localAttrs = {
        fixedHeader: this.infinite
      };
      return { ...localAttrs,
        ...this.$attrs
      };
    }

  },

  created() {
    // Be carefoul, with multiple components only fires on one
    // https://forum.vuejs.org/t/issues-with-vuejs-component-and-debounce/7224/13
    this.getData = throttle(async function (force) {
      if (force || this.savedParams === null || !isEqual(this.options, this.savedParams.options) || !isEqual(this.filters, this.savedParams.filters) || !isEqual(this.search, this.savedParams.search)) {
        // If change items per page recalc page
        if (this.savedParams && this.savedParams.options && this.savedParams.options.itemsPerPage && this.savedParams.options.itemsPerPage !== this.options.itemsPerPage) {
          const index = 1 + (this.savedParams.options.page - 1) * this.savedParams.options.itemsPerPage;
          this.options.page = Math.ceil(index / this.options.itemsPerPage);

          while ((this.options.page - 1) * this.options.itemsPerPage >= this.total && this.options.page !== 1) {
            this.options.page--;
          }
        }

        const optionsWithOffset = { ...this.options
        };
        let limit = this.options.itemsPerPage ? this.options.itemsPerPage : 10;

        if (limit === -1) {
          limit = 0;
        }

        optionsWithOffset.limit = limit;
        optionsWithOffset.offset = limit * (this.options.page - 1);
        this.loading = true;
        const [localItems, total] = await this.table.list(optionsWithOffset, this.filters || {}, this.search, this.tsylfilters, this.selectedColumns);
        this.total = total;

        if (this.infinite) {
          if (optionsWithOffset.page === 1) {
            this.localItems = [];
            this.$refs.table.$el.children[0].scrollTo(0, 0);
          }

          this.localItems.push(...localItems); // Load next page if needed

          this.$nextTick(() => {
            this.infiniteScrollEvent();
          });
        } else {
          this.localItems = localItems;
        }

        this.savedParams = {
          options: { ...this.options
          },
          filters: { ...this.filters
          },
          search: this.search
        };
        this.loading = false;
        this.loadReady = true; // Only change first time

        this.setEditing(0, true);
      }
    }, 500);
    const that = this;

    const getElementByEvent = event => {
      const tr = event.srcElement;

      if (tr.parentElement && tr.parentElement.children) {
        const arrayOfTr = Array.from(tr.parentElement.children).filter(e => e.tagName === 'TR');
        const index = arrayOfTr.indexOf(tr);
        return this.localItems[index];
      }
    };

    if (this.$listeners.hoverrow) {
      this.hoverEvent = debounce(function (event) {
        const element = getElementByEvent(event);
        /**
         * mouse hover on row.
         * @since 0.7.51
         * @property {object} item - The item
        */

        that.$emit('hoverrow', element);
      }, 50);
    }

    if (this.$listeners.blurrow) {
      this.blurEvent = debounce(function (event) {
        const element = getElementByEvent(event);
        /**
         * mouse blur on row.
         * @since 0.7.51
         * @property {object} item - The item
        */

        that.$emit('blurrow', element);
      }, 50);
    }

    if (this.table.itemsPerPage && !this.noPagination) {
      this.options.itemsPerPage = this.table.itemsPerPage;
    }

    if (this.items) {
      this.localItems = cloneDeep(this.items);
    }

    if (this.noPagination && Array.isArray(this.items)) {
      this.options.itemsPerPage = this.items.length;
    }

    if (this.cacheKey) {
      const cacheOptions = localStorage.getItem(this.cacheKey + '' + this.index);

      if (cacheOptions) {
        this.options = JSON.parse(cacheOptions);
      }
    } else {
      this.resetOptions();
    }

    const cachedHeadersOrder = localStorage.getItem(this.cacheKey + '' + this.index + 'sortedcolumns');

    if (cachedHeadersOrder) {
      this.sortedColumns = JSON.parse(cachedHeadersOrder);
    } else {
      this.table.headers.forEach(header => {
        this.sortedColumns.push(this.getHeaderUniqueKey(header));
      });
    }

    this.refresh();
  },

  mounted() {
    if (this.table.select) {
      this.$refs.table.$el.classList.add('z-t-with-select');
    }

    if (this.headers.some(x => x.fixed)) {
      this.$refs.table.$el.classList.add('z-t-with-fixed-cols');
    }

    if (this.table.fixedSelect) {
      this.$refs.table.$el.classList.add('z-t-with-fixed-select');
    }
  },

  methods: {
    refresh(force) {
      if (!this.items) {
        this.getData(force);
      }
    },

    /**
     * Clear all filters and reset table pagination.
     * @public
     */
    doReset() {
      if (this.infinite) this.localItems = [];
      this.resetOptions();
      this.doReload();
    },

    /**
     * Reload actual table, calling list() method.
     * @public
     */
    doReload() {
      this.refresh(true);
    },

    resetOptions() {
      this.options = { ...this.defaultOptionsComplete
      };

      if (this.table.itemsPerPage) {
        if (this.noPagination && Array.isArray(this.items)) {
          this.options.itemsPerPage = this.items.length;
        } else {
          this.options.itemsPerPage = this.table.itemsPerPage;
        }
      }
    },

    updateCell(value, item, header) {
      const newItem = cloneDeep(item);
      const itemProp = header.dataProp || header.value;
      newItem[itemProp] = value; // Replace item into list

      const index = this.localItems.indexOf(item);
      this.localItems.splice(index, 1, newItem);
      /**
       * Send all rows when a value is updated when a field is editable.
       * @property {array} data - All table data
      */

      this.$emit('update', this.localItems);
      /**
       * Send row edited when a value is updated when a field is editable.
       * @property {object} data - Row data
      */

      this.$emit('update:row', {
        item: newItem,
        index
      });
      /**
       * Send cell edited when a value is updated when a field is editable.
       * @property {object} data - An object with `value`, `index`, `item` (since 0.7.52) and `column` props.
       */

      this.$emit('update:cell', {
        value,
        index,
        column: itemProp,
        item
      });
    },

    toggleSelectAll(items, value) {
      if (value) {
        if (this.total !== this.localItems.length) {
          this.showSelectAllToast = true;
        }
      } else {
        this.setFullSelect(false);
      }
    },

    setFullSelect(value) {
      this.fullSelect = value;
      /**
       * Emits the event to true when the user click "Select All n Items"<br>
       * Emits the event to false when the user click "Clear selection" or deselect some other item after clicking "Select All n Items".<br>
       * Selecting all items does not make it zapan. The sync selected prop will still contain only the page items.<br>
       * since `0.7.44`
       * @property {boolean} value - true/false
      */

      this.$emit('fullSelect', value);
    },

    /**
     * @public
     * Set loading manually
     */
    setLoading(value) {
      this.loading = value;
    },

    buildHoverEvent() {
      const rows = this.$refs.table.$el.querySelectorAll('table > tbody > tr');

      for (const row of rows) {
        if (this.$listeners.hoverrow) {
          row.removeEventListener('mouseenter', this.hoverEvent);
          row.addEventListener('mouseenter', this.hoverEvent);
        }

        if (this.$listeners.blurrow) {
          row.removeEventListener('mouseleave', this.blurEvent);
          row.addEventListener('mouseleave', this.blurEvent);
        }
      }
    },

    setEditing(value, reset = false) {
      if (reset) this.editingCount = 0;else {
        if (value) this.editingCount++;else this.editingCount--;
      }
      /**
       * Number of fields with editing enabled
       * since `0.7.64`
       * @property {number} value
      */

      this.$emit('editingCount', this.editingCount);
    },

    getHeaderUniqueKey(h) {
      return `${h.text}${h.dataProp || h.value}`;
    },

    sortTheHeadersAndUpdateTheKey(evt) {
      const headers = this.headers;
      const newIndex = evt.newIndex - this.table.select;
      const oldIndex = evt.oldIndex - this.table.select;

      if (newIndex > 0) {
        const oldHeader = headers[oldIndex];
        const headerKey = this.getHeaderUniqueKey(oldHeader);
        this.sortedColumns.splice(oldIndex, 1);
        this.sortedColumns.splice(newIndex, 0, headerKey);
        this.refreshSortedColumns++;
        const stringfied = JSON.stringify(this.sortedColumns);
        localStorage.setItem(this.cacheKey + '' + this.index + 'sortedcolumns', stringfied);
      } else {
        this.refreshSortedColumns++;
      }
    }

  }
};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-data-table', _vm._g(_vm._b({
    directives: [{
      name: "sortable-table",
      rawName: "v-sortable-table",
      value: {
        onEnd: _vm.sortTheHeadersAndUpdateTheKey
      },
      expression: "{onEnd:sortTheHeadersAndUpdateTheKey}"
    }],
    key: "ztable" + _vm.refreshSortedColumns,
    ref: "table",
    class: _vm.tableClass,
    attrs: {
      "value": _vm.selected,
      "headers": _vm.headers,
      "loading": _vm.loading,
      "items": _vm.localItems,
      "options": _vm.options,
      "server-items-length": _vm.items ? undefined : _vm.total || 0,
      "hide-default-footer": "",
      "show-select": _vm.table.select,
      "item-key": _vm.table.key,
      "show-expand": !!(_vm.$slots['expanded-item'] || _vm.$scopedSlots['expanded-item'])
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      },
      "input": function ($event) {
        return _vm.$emit('update:selected', $event);
      },
      "toggle-select-all": _vm.toggleSelectAll
    },
    scopedSlots: _vm._u([_vm._l(_vm.columnsWithModifiers, function (header, ii) {
      return {
        key: header.slot,
        fn: function (data) {
          return [_c('Cell', {
            key: ii,
            attrs: {
              "data": data,
              "header": header,
              "editable": _vm.editable,
              "editable-cell": _vm.editableCell
            },
            on: {
              "update": function ($event) {
                return _vm.updateCell($event, data.item, header);
              },
              "editing": _vm.setEditing
            },
            scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
              return {
                key: name,
                fn: function (slotsData) {
                  return [_vm._e(), _vm._v(" "), _vm._e(), _vm._v(" "), _vm._e(), _vm._v(" "), _vm._e(), _vm._v(" "), _vm._t(name, null, null, slotsData)];
                }
              };
            })], null, true)
          })];
        }
      };
    }), _vm._l(_vm.$scopedSlots, function (slotData, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    }), _vm.infinite && _vm.loadReady && _vm.localItems.length < _vm.total ? {
      key: "body.append",
      fn: function () {
        return [_vm._t("body.append"), _vm._v(" "), _c('tr', [_c('td', {
          staticClass: "text-center",
          attrs: {
            "colspan": _vm.headers.length + !!_vm.table.select
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": ""
          }
        })], 1)])];
      },
      proxy: true
    } : null, _vm.localItems.length < _vm.total && _vm.selectAll ? {
      key: "body.prepend",
      fn: function () {
        return [_vm._t("body.prepend"), _vm._v(" "), _c('v-alert', {
          staticClass: "select-all-toast",
          attrs: {
            "type": "info",
            "dismissible": "",
            "dense": "",
            "icon": "mdi-checkbox-multiple-outline"
          },
          model: {
            value: _vm.showSelectAllToast,
            callback: function ($$v) {
              _vm.showSelectAllToast = $$v;
            },
            expression: "showSelectAllToast"
          }
        }, [_vm.fullSelect ? _c('span', [_vm._v("\n          " + _vm._s(_vm.t('allItemsAreSelected', {
          msg: _vm.total
        })) + "\n          "), _c('a', {
          staticClass: "white--text font-weight-bold",
          on: {
            "click": function ($event) {
              _vm.setFullSelect(false);

              _vm.$emit('update:selected', []);
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.t('clearSelection')) + "\n          ")])]) : _c('span', [_vm._v("\n          " + _vm._s(_vm.t('allItemsOnThisPageAreSelected', {
          msg: _vm.localItems.length
        })) + "\n          "), _c('a', {
          staticClass: "white--text font-weight-bold",
          on: {
            "click": function ($event) {
              return _vm.setFullSelect(true);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('selectAll')) + "\n            " + _vm._s(_vm.total) + "\n            " + _vm._s(_vm.t('items')))])])])];
      },
      proxy: true
    } : null], null, true)
  }, 'v-data-table', _vm.computedAttrs, false), _vm.computedListeners)), _vm._v(" "), !_vm.noPagination && !_vm.infinite ? _c('Pagination', {
    attrs: {
      "options": _vm.options,
      "total": _vm.total,
      "loading": _vm.loading,
      "items": _vm.table.itemsPerPageOptions
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      }
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = function (inject) {
  if (!inject) return;
  inject("data-v-0172149c_0", {
    source: "[data-v-0172149c] .v-data-table__expanded__content{box-shadow:none!important;background-color:#fafafa}[data-v-0172149c] .z-t-fixed{position:sticky;left:0;background:#fff;z-index:1}[data-v-0172149c] .z-t-fixed-right{right:0;border-left:thin solid rgba(0,0,0,.12)}[data-v-0172149c] .z-t-fixed-left{left:0;border-right:thin solid rgba(0,0,0,.12)}[data-v-0172149c] .z-t-with-fixed-select thead tr th:first-child,[data-v-0172149c] th.z-t-fixed{z-index:3!important}[data-v-0172149c] tr:hover .text-start{background:#eee!important}[data-v-0172149c] .z-t-with-fixed-select tbody tr td:first-child,[data-v-0172149c] .z-t-with-fixed-select thead tr th:first-child{position:sticky;left:0;background:#fff;z-index:1}[data-v-0172149c] .z-t-with-fixed-select .z-t-fixed-left.z-t-fixed{left:64px}[data-v-0172149c] .v-data-table__wrapper td:hover .edit-button{opacity:1}.select-all-toast[data-v-0172149c]{position:absolute;left:50%;transform:translate(-50%);border-top-left-radius:0;border-top-right-radius:0;z-index:2}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$M = "data-v-0172149c";
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, createInjector, undefined, undefined);

var Table = __vue_component__$$;

/**
   * Column selector menu for use with buttons or presearch slot in [Datatable](#datatable)
   * You can change the default visibility with `visible` prop at `table.headers`
   *
   * @displayName ColumnSelector
   * @author dcrespo
   * @since 0.7.44
   */

var script$L = {
  components: {
    VIcon: VIcon,
    VBtn: VBtn,
    VTooltip: VTooltip,
    VListItemAvatar: VListItemAvatar,
    VListItemTitle: VListItemTitle,
    VListItem: VListItem,
    VList: VList,
    VMenu: VMenu
  },
  mixins: [i18n('DataTable')],
  props: {
    columns: {
      type: Array,
      required: true
    },

    /**
     * @ignore DEPRECATED
     */
    attrs: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      defaultAttrs: {
        fab: true,
        depressed: true,
        dark: true,
        small: true,
        color: 'grey darken-3'
      }
    };
  },

  methods: {
    setVisible(index) {
      const columns = cloneDeep(this.columns);
      const visibility = columns[index].visible !== false;
      columns[index].visible = !visibility;
      this.$emit('update:columns', columns);
    }

  }
};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-y": true,
      "content-class": "columnselectormenu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var onMenu = ref.on;
        var attrsMenu = ref.attrs;
        var valueMenu = ref.value;
        return [_vm._t("default", function () {
          return [_c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (ref) {
                var onTooltip = ref.on;
                return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', Object.assign({}, attrsMenu, _vm.attrs, _vm.defaultAttrs), false), Object.assign({}, onMenu, onTooltip)), [_c('v-icon', [_vm._v("\n              mdi-table-plus\n            ")])], 1)];
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t("chooseColumns")))])])];
        }, {
          "on": onMenu,
          "attrs": attrsMenu,
          "value": valueMenu
        })];
      }
    }], null, true)
  }, [_vm._v(" "), _c('v-list', _vm._l(_vm.columns, function (column, index) {
    return _c('v-list-item', {
      key: index,
      on: {
        "click": function ($event) {
          return _vm.setVisible(index);
        }
      }
    }, [_c('v-list-item-avatar', {
      staticClass: "mr-2"
    }, [column.visible !== false ? _c('v-icon', [_vm._v("\n          mdi-eye\n        ")]) : _c('v-icon', [_vm._v("\n          mdi-eye-off\n        ")])], 1), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(column.text))])], 1);
  }), 1)], 1);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = function (inject) {
  if (!inject) return;
  inject("data-v-75d17eba_0", {
    source: ".columnselectormenu[data-v-75d17eba]{margin-top:6px;max-height:calc(100vh - 241px)}.columnselectormenu[data-v-75d17eba]::-webkit-scrollbar{width:4px;background-color:#e6e6e6}.columnselectormenu[data-v-75d17eba]::-webkit-scrollbar-thumb{background-color:#b1b1b1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$L = "data-v-75d17eba";
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, createInjector, undefined, undefined);

var ColumnSelector = __vue_component__$_;

function checkAndWarnDuplicatesValues(tablesHeaders) {
  for (const headers of tablesHeaders) {
    const uniqueValues = new Set(headers.map(v => v.value));

    if (uniqueValues.size < headers.length) {
      console.error('[Zapan warn]: Datatable headers value must to be unique. Use dataProp instead. Check docs for more info.');
      break;
    }
  }
}
/**
   * Vuetify table with some enhancements like filters, search field, buttons slot, etc.
   * If you need only a table without filters, search field, etc use [Grid](#grid) instead.<br>
   * All [Grid](#grid) props, events and slots works also with DataTable
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/data-table)
   * @displayName DataTable
   * @author dcrespo
   * @since 0.5.6
   */


var script$K = {
  mixins: [i18n('DataTable')],
  components: {
    Table,
    DataTableFilter,
    ColumnSelector,
    VDivider: VDivider,
    VCol: VCol,
    VTextField: VTextField,
    VRow: VRow,
    VTab: VTab,
    VTabs: VTabs,
    VTabItem: VTabItem,
    VTabsItems: VTabsItems
  },
  props: {
    /**
     * Enable search field
     */
    search: {
      type: Boolean,
      default: false
    },

    /**
     * Placeholder for search field
     */
    searchplaceholder: {
      type: String,
      default: 'Search...'
    },

    /**
     * Array of table settings. Look [table description](#table-props) for more info.
     * If tables.length > 1 it will be show in multiple tabs.
     */
    tables: {
      type: Array,
      required: true
    },

    /**
     * An array of filters settings object. Check [filter object description](#filter-props) for more info.
     */
    filters: {
      type: Array,
      default: null
    },

    /**
     * (sync) An array of selected items. Acts like data-table vuetify value.
     * Use table.key as key.
     * If tables.length > 1 it will be an array of arrays.
     */
    selected: {
      type: Array,
      default: null
    },

    /**
     * html class for each table
     */
    tableClass: {
      type: String,
      default: null
    },

    /**
     * (sync) open or close filters
     */
    filtersOpen: {
      type: Boolean,
      default: false
    },

    /**
     * Any change of this prop exec doReset() method
     */
    reset: {
      type: [Number, String, Object, Array, Boolean],
      default: null
    },

    /**
     * Any change of this prop exec doReload() method
     */
    reload: {
      type: [Number, String, Object, Array, Boolean],
      default: null
    },

    /**
     * Shows a dropdown button to select visible columns.
     * You can change the default visibility with `visible` prop at `table.headers`
     * @deprecated use slot buttons or presearch with ColumnSelector component instead
     */
    selectColumns: {
      type: Boolean,
      default: false
    },

    /**
     * Attrs for select column button.
     * You can use any [vuetify btn attrs](https://vuetifyjs.com/en/api/v-btn/)
     * @deprecated use slot buttons or presearch with ColumnSelector component instead
     */
    selectColumnsAttrs: {
      type: Object,
      default: () => ({})
    },

    /**
     * Props for [DataTableFilter components](#datatablefilter)<br>
     *  Default values:<br>
     * `{ icon: 'mdi-filter-variant', title: 'Filters', onDemand: 'textfield' }`
     */
    filterProps: {
      type: Object,
      default: () => ({})
    },

    /**
     * (sync) select a table index.
     * @since 0.6.41
     */
    tab: {
      type: Number,
      default: 0
    },

    /**
     * Props for v-tabs. You can use any [vuetify v-tabs props](https://vuetifyjs.com/en/api/v-tabs/#props-background-color)
     */
    tabsAttrs: {
      type: Object,
      default: () => ({})
    },

    /**
     * Save settings per table. If you change page and back
     * your page, items per page, sort and selected column will be restored.
     * Use an unique key string.
     * Cache will be saved in localstorage.
     */
    cacheKey: {
      type: String,
      default: null
    },

    /**
     * Use cacheKey instead
     * @deprecated
     */
    visibilityKey: {
      type: String,
      default: null
    },

    /**
     * (v-model) values to datatable filter
     */
    value: {
      type: Object,
      default: () => {}
    },

    /**
     * true to active editable columns
     */
    editable: {
      type: Boolean,
      default: false
    },

    /**
     * Default table options. More info [Vuetify v-data-table Options](https://vuetifyjs.com/en/api/v-data-table/#props-options)
     */
    defaultOptions: {
      type: Object,
      default: () => {}
    },

    /**
     * (sync) search input value. <br>
     * Be careful: Update searchValue don't trigger list(). Call doSearch
     * @since 0.7.47
     */
    searchValue: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      defaultDataTableFilterPorps: {
        icon: 'mdi-filter-variant',
        title: 'Filters',
        onDemand: 'textfield'
      },
      localTab: 0,
      searchInput: '',
      searchInputValue: '',
      filtersFields: null,
      localselected: [],
      selectedColumns: [],
      tsylfilters: [],
      forceTableOn: false
    };
  },

  computed: {
    selectedTable() {
      return this.tables[this.localTab];
    },

    tabsAttrsMixed() {
      const defaultAttrs = {
        backgroundColor: 'grey lighten-4'
      };
      return { ...defaultAttrs,
        ...this.tabsAttrs
      };
    },

    selectedColumnsTab: {
      get() {
        return this.selectedColumns[this.localTab];
      },

      set(value) {
        this.$set(this.selectedColumns, this.localTab, value);
      }

    },

    visibleColumns() {
      if (Array.isArray(this.selectedColumns) && Array.isArray(this.selectedColumns[this.localTab])) {
        return this.selectedColumns[this.localTab].filter(f => f.visible !== false);
      } else {
        return [];
      }
    },

    tsylfiltersMixed() {
      const filters = [...this.tsylfilters] || [];

      if (this.searchInputValue) {
        filters.push(JSON.stringify({
          FilterType: 'Search',
          Value: this.searchInputValue
        }));
      }

      return filters;
    },

    tableReady() {
      if (this.forceTableOn) {
        return true;
      } else if (this.filters) {
        return this.filtersFields !== null;
      } else {
        return true;
      }
    },

    cacheSearchKey() {
      if (this.cacheKeyTemporal) {
        return this.cacheKeyTemporal + '_SEARCH';
      } else {
        return null;
      }
    },

    cacheKeyTemporal() {
      return this.cacheKey || this.visibilityKey;
    },

    filtersComp() {
      return this.selectedTable.filters || this.filters;
    }

  },

  created() {
    if (this.visibilityKey) {
      console.error('[Zapan warn]: Datatable visibilityKey is deprecated, use cacheKey instead.');
    }

    const selectedColumnsLocal = [];

    for (const table of this.tables) {
      selectedColumnsLocal.push([...table.headers]);
    }

    checkAndWarnDuplicatesValues(selectedColumnsLocal);

    if (this.cacheKeyTemporal) {
      const cache = localStorage.getItem(this.cacheKeyTemporal);

      if (cache) {
        try {
          const cachedColumns = JSON.parse(cache);

          for (let i = 0; cachedColumns.length > i; i++) {
            for (const column of cachedColumns[i]) {
              const originalCol = selectedColumnsLocal[i].find(c => c.value === column.value);

              if (originalCol && !isNullOrUndefined(column.visible)) {
                originalCol.visible = column.visible;
              }
            }
          }
        } catch (ex) {
          console.error(ex);
        }
      }
    }

    this.selectedColumns = selectedColumnsLocal;

    if (this.cacheSearchKey) {
      const restored = localStorage.getItem(this.cacheSearchKey);
      if (restored) this.searchInputValue = this.searchInput = restored;
    }

    setTimeout(() => {
      this.forceTableOn = true;
    }, 250);
  },

  mounted() {
    if (this.selectColumns) {
      console.error('[Zapan Warn]: selectColumns is deprecated. Use slot buttons or presearch with ColumnSelector component instead. Check docs for more info.');
    }
  },

  watch: {
    reset() {
      this.doReset();
    },

    localselected(newValue) {
      let selected;

      if (this.tables.length === 1) {
        selected = newValue[0];
      } else {
        selected = newValue;
      }
      /**
       * Update selected items
       * @property {array} selected Selected items
       */


      this.$emit('update:selected', selected);
    },

    selected: {
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal) || newVal === null) {
          if (newVal === null) {
            for (let i = 0; i < this.tables.length; i++) {
              this.localselected[i] = [];
            }
          } else if (this.tables.length === 1) {
            this.localselected = [newVal];
          } else {
            this.localselected = newVal;
          }
        }
      },

      immediate: true
    },

    searchInputValue(val) {
      this.$emit('update:searchValue', val);

      if (this.cacheSearchKey) {
        localStorage.setItem(this.cacheSearchKey, val);
      }
    },

    searchInput(val) {
      this.$emit('update:searchValue', val);
    },

    searchValue(val) {
      if (val !== this.searchInput) {
        this.searchInput = val;
      }
    },

    tab(val) {
      this.localTab = val;
    },

    localTab(val) {
      /**
       * for :tab.sync
       * @property {number} tab - 0-index tab selected
       */
      this.$emit('update:tab', val);
    },

    visibleColumns: {
      handler(val) {
        /**
         * Emit a list of visible columns for selected table<br>
         * <i>Since 0.6.53</i>
         * @property {array} visibleColumns
         */
        this.$emit('visibleColumns', val);
      },

      inmediate: true
    },

    selectedColumns(val) {
      if (this.cacheKeyTemporal) {
        localStorage.setItem(this.cacheKeyTemporal, JSON.stringify(val));
      }
    }

  },
  methods: {
    /**
     * Clear all filters and reset table pagination.
     * @public
     */
    doReset() {
      if (this.$refs.filters) this.$refs.filters.clearFilters();
      this.searchInput = '';
      this.searchInputValue = '';

      for (const table of this.$refs.table) {
        table.doReset();
      }
    },

    /**
     * Reload actual table, calling list() method.
     * @public
     */
    doReload() {
      for (const table of this.$refs.table) {
        table.doReload();
      }
    },

    updateColumns(event) {
      this.selectedColumnsTab = event;
    },

    /**
     * Launch search with value
     * @public
     */
    doSearch(value) {
      if (value !== this.searchInput) {
        this.searchInput = value;
      }

      this.searchInputValue = value;
    }

  }
};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.filtersComp ? _c('data-table-filter', _vm._b({
    ref: "filters",
    attrs: {
      "filters": _vm.filtersComp,
      "open": _vm.filtersOpen,
      "cache-key": _vm.cacheKeyTemporal ? _vm.cacheKeyTemporal + '_FILTER' : undefined,
      "value": _vm.value
    },
    on: {
      "fields": function ($event) {
        _vm.filtersFields = $event;
      },
      "clear": function ($event) {
        return _vm.$emit('clearFilters');
      },
      "update:open": function ($event) {
        return _vm.$emit('update:filters-open', $event);
      },
      "tsylfilters": function ($event) {
        _vm.tsylfilters = $event;
      },
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._t(name, null, null, data)];
        }
      };
    })], null, true)
  }, 'data-table-filter', Object.assign({}, _vm.defaultDataTableFilterPorps, _vm.filterProps), false)) : _vm._e(), _vm._v(" "), _vm.filters ? _c('v-divider') : _vm._e(), _vm._v(" "), _vm._t("fullheader", function () {
    return [_c('v-row', {
      staticClass: "justify-space-between"
    }, [_vm.$scopedSlots.presearch ? _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._t("presearch", null, {
      "columns": _vm.selectedColumnsTab,
      "updateColumns": _vm.updateColumns
    })], 2) : _vm._e(), _vm._v(" "), _c('v-col', {
      staticClass: "d-flex align-center",
      attrs: {
        "cols": "auto"
      }
    }, [_vm.search ? _c('v-text-field', {
      attrs: {
        "label": _vm.searchplaceholder,
        "filled": "",
        "rounded": "",
        "dense": "",
        "single-line": "",
        "hide-details": "",
        "append-icon": "mdi-magnify",
        "clearable": ""
      },
      on: {
        "click:clear": function ($event) {
          return _vm.doSearch('');
        },
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return _vm.doSearch(_vm.searchInput);
        },
        "click:append": function ($event) {
          return _vm.doSearch(_vm.searchInput);
        }
      },
      model: {
        value: _vm.searchInput,
        callback: function ($$v) {
          _vm.searchInput = $$v;
        },
        expression: "searchInput"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_vm._t("buttons", null, {
      "columns": _vm.selectedColumnsTab,
      "updateColumns": _vm.updateColumns
    }), _vm._v(" "), _vm.selectColumns ? _c('column-selector', {
      attrs: {
        "columns": _vm.selectedColumnsTab,
        "attrs": _vm.selectColumnsAttrs
      },
      on: {
        "update:columns": function ($event) {
          _vm.selectedColumnsTab = $event;
        }
      }
    }) : _vm._e()], 2)], 1)];
  }, {
    "columns": _vm.selectedColumnsTab,
    "updateColumns": _vm.updateColumns,
    "searchInput": _vm.searchInput,
    "searchInputUpdate": function (v) {
      return _vm.searchInput = v;
    }
  }), _vm._v(" "), _vm.tables && _vm.tables.length > 1 ? _c('v-tabs', _vm._b({
    model: {
      value: _vm.localTab,
      callback: function ($$v) {
        _vm.localTab = $$v;
      },
      expression: "localTab"
    }
  }, 'v-tabs', _vm.tabsAttrsMixed, false), _vm._l(_vm.tables, function (table, index) {
    return _c('v-tab', {
      key: index
    }, [_vm._t("tabs", function () {
      return [_c('span', [_vm._v(" " + _vm._s(table.name) + " ")])];
    }, {
      "table": table
    })], 2);
  }), 1) : _vm._e(), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: _vm.localTab,
      callback: function ($$v) {
        _vm.localTab = $$v;
      },
      expression: "localTab"
    }
  }, _vm._l(_vm.tables, function (table, index) {
    return _c('v-tab-item', {
      key: index
    }, [_vm._e(), _vm._v(" "), _vm.tableReady ? _c('Table', _vm._g(_vm._b({
      ref: "table",
      refInFor: true,
      attrs: {
        "table": table,
        "selected-columns": _vm.selectedColumns[index],
        "filters": _vm.filtersFields,
        "filter-list": _vm.filters,
        "tsylfilters": _vm.tsylfiltersMixed,
        "search": _vm.searchInputValue,
        "selected": _vm.localselected[index],
        "table-class": _vm.tableClass,
        "reset": _vm.reset,
        "reload": _vm.reload,
        "index": index,
        "editable": _vm.editable,
        "cache-key": _vm.cacheKeyTemporal,
        "default-options": _vm.defaultOptions
      },
      on: {
        "update:selected": function ($event) {
          return _vm.$set(_vm.localselected, index, $event);
        }
      },
      scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
        return {
          key: name,
          fn: function (data) {
            return [_vm._t(name, null, null, data)];
          }
        };
      })], null, true)
    }, 'Table', _vm.$attrs, false), _vm.$listeners)) : _vm._e()], 1);
  }), 1)], 2);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = undefined;
/* scoped */

const __vue_scope_id__$K = "data-v-0812d169";
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

var __vue_component__$Z = __vue_component__$Y;

var script$J = {
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    deepValue() {
      return getObjectValueByPath(this.value, this.field.value, '');
    }

  }
};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('p', {
    staticClass: "mb-1"
  }, [_vm._v("\n  " + _vm._s(_vm.field.text) + ":\n  "), _c('span', {
    staticClass: "subtitle-2 primary--text"
  }, [_vm._v("\n    " + _vm._s(_vm.deepValue) + "\n  ")])]);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = undefined;
/* scoped */

const __vue_scope_id__$J = "data-v-84cea6f2";
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

var script$I = {
  components: {
    RowStep2: __vue_component__$X
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    }
  }
};

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 mb-3"
  }, [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")]), _vm._v(" "), _vm._l(_vm.fields, function (field, index) {
    return _c('row-step-2', {
      key: index,
      attrs: {
        "field": field,
        "value": _vm.value
      }
    });
  })], 2);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = "data-v-5fe6b83e";
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

var script$H = {
  components: {
    VRadio: VRadio
  },
  props: {
    fieldValue: {
      type: String,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    }
  },
  computed: {
    value() {
      return getObjectValueByPath(this.selectedItem, this.fieldValue);
    }

  }
};

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-radio', {
    key: _vm.index,
    attrs: {
      "label": (_vm.value || 'No Data') + '',
      "value": _vm.value,
      "disabled": !_vm.value
    }
  });
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = "data-v-6f090f06";
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

//
var script$G = {
  // Need only in prod
  components: {
    VTextField,
    VIcon: VIcon,
    VTooltip: VTooltip
  } ,
  directives: {
    mask: (el, binding) => {
      if (!binding.value) return;
      mask(el, binding);
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types, vue/require-default-prop
    value: {},
    field: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      rules: []
    };
  },

  watch: {
    value() {
      this.checkRules();
    }

  },
  methods: {
    checkRules() {
      this.rules = [];

      if (this.field.rules) {
        for (const rule of this.field.rules) {
          const result = rule(this.value);

          if (result !== true) {
            this.rules.push(result);
          }
        }
      }
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.field.component || 'v-text-field', _vm._b({
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.field.mask,
      expression: "field.mask"
    }],
    tag: "component",
    attrs: {
      "value": _vm.value,
      "rules": _vm.field.rules,
      "placeholder": _vm.field.text,
      "hide-details": "",
      "filled": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      },
      "blur": _vm.checkRules
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (ref) {
              var on = ref.on;
              var attrs = ref.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: _vm.rules.length > 0,
                  expression: "rules.length > 0"
                }],
                staticClass: "error-icon",
                attrs: {
                  "color": "error"
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n          mdi-alert-circle-outline\n        ")])];
            }
          }])
        }, [_vm._v(" "), _vm._l(_vm.rules, function (rule, index) {
          return _c('p', {
            key: index,
            staticClass: "mb-0"
          }, [_vm._v("\n        " + _vm._s(rule) + "\n      ")]);
        })], 2)];
      },
      proxy: true
    }])
  }, 'component', _vm.field.attrs, false));
};

var __vue_staticRenderFns__$G = [];
/* style */

const __vue_inject_styles__$G = function (inject) {
  if (!inject) return;
  inject("data-v-82c1a054_0", {
    source: ".error-icon[data-v-82c1a054]{cursor:pointer}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$G = "data-v-82c1a054";
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, createInjector, undefined, undefined);

var script$F = {
  components: {
    DefaultInput: __vue_component__$U,
    Step1RadioButton: __vue_component__$V,
    VCol: VCol,
    VRow: VRow,
    VRadioGroup: VRadioGroup
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    showSelectors: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    field: {
      type: Object,
      required: true
    }
  },
  methods: {
    updateField(data) {
      this.$emit('input', data);
    }

  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-radio-group', {
    key: _vm.index,
    staticClass: "mt-0 pt-0",
    attrs: {
      "value": _vm.value,
      "hide-details": ""
    },
    on: {
      "change": _vm.updateField
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.showSelectors ? _vm._l(_vm.selected, function (select, selectIndex) {
    return _c('v-col', {
      key: selectIndex,
      staticClass: "d-flex align-center"
    }, [_c('step-1-radio-button', {
      attrs: {
        "field-value": _vm.field.value,
        "selected-item": select
      }
    })], 1);
  }) : _vm._e(), _vm._v(" "), _c('v-col', [_vm._t('field.' + _vm.field.value, function () {
    return [_c('default-input', {
      ref: "input",
      attrs: {
        "value": _vm.value,
        "field": _vm.field
      },
      on: {
        "input": _vm.updateField
      }
    })];
  }, {
    "value": _vm.value,
    "input": function (ev) {
      return _vm.updateField(ev);
    },
    "field": _vm.field
  })], 2)], 2)], 1);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = undefined;
/* scoped */

const __vue_scope_id__$F = "data-v-546a33cd";
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

var script$E = {
  components: {
    Step1Row: __vue_component__$T,
    VForm: VForm
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      merged: {},
      errors: {}
    };
  },

  created() {
    this.merged = this.value;
  },

  methods: {
    checkAllFields() {
      this.$refs.form.validate();

      for (const row of this.$refs.row) {
        var _row$$refs$input;

        (_row$$refs$input = row.$refs.input) === null || _row$$refs$input === void 0 ? void 0 : _row$$refs$input.checkRules();
      }
    }

  },
  watch: {
    merged: {
      handler(value) {
        // Transform properties like 'onekey.otherkey' into a real deep objet
        const objResult = {};

        for (const property in value) {
          setObjectValueByPath(objResult, property, value[property]);
        }

        this.$emit('input', objResult);
      },

      deep: true
    }
  }
};

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-form', {
    ref: "form",
    attrs: {
      "value": _vm.valid
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:valid', $event);
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle-2 mb-3"
  }, [_vm._v("\n    " + _vm._s(_vm.subtitle) + "\n  ")]), _vm._v(" "), _vm._l(_vm.fields, function (field, index) {
    return [_c('hr', {
      key: index + 'hr'
    }), _vm._v(" "), _c('step-1-row', {
      key: index,
      ref: "row",
      refInFor: true,
      attrs: {
        "show-selectors": _vm.selected.length < 4,
        "selected": _vm.selected,
        "field": field
      },
      model: {
        value: _vm.merged[field.value],
        callback: function ($$v) {
          _vm.$set(_vm.merged, field.value, $$v);
        },
        expression: "merged[field.value]"
      }
    })];
  }), _vm._v(" "), _c('hr')], 2);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = "data-v-25eec219";
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

const defaultFields = [{
  text: 'Name',
  value: 'firstname',
  rules: validate('Name', isRequired())
}, {
  text: 'Address',
  value: 'address',
  rules: validate('Address', isRequired())
}, {
  text: 'City',
  value: 'city',
  rules: validate('City', isRequired())
}, {
  text: 'County',
  value: 'county',
  rules: validate('County', isRequired())
}, {
  text: 'Zip',
  value: 'zipCode',
  rules: validate('Zip', isRequired()),
  attrs: {
    type: 'number'
  }
}, {
  text: 'Ownership',
  value: 'ownershipType',
  rules: validate('Ownership', isRequired())
}, {
  text: 'Phone number',
  value: 'phone',
  rules: validate('Phone number', isRequired())
}, {
  text: 'Email',
  value: 'email',
  rules: validate('Email', isRequired(), isValidEmail())
}];
/**
   * Use for merge two object of data, usually persons, selecting each of its fields.<br>
   * It should usually be part of the body of a dialog
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/customer-merge)
   * @displayName CustomerMerge
   * @author dcrespo
   * @since 0.5.24
   */

var script$D = {
  mixins: [i18n('CustomerMerge')],
  components: {
    Step1: __vue_component__$S,
    Step2: __vue_component__$W,
    VSlideXTransition: VSlideXTransition,
    VCardTitle: VCardTitle,
    VCardText: VCardText,
    VSpacer: VSpacer,
    VBtn: VBtn,
    VCardActions: VCardActions,
    VCard: VCard
  },
  props: {
    /**
     * Array of person objects to merge. Keys must be those defined in fields prop.
     */
    selected: {
      type: Array,
      required: true
    },

    /**
     * Array of the fields of person.<br>
     * Default fields are [this](#custom-merge-default-fields) <br>
     * Check [fields properties](#custom-merge-fields-props) for more info
     */
    fields: {
      type: Array,
      default: () => defaultFields
    },

    /**
     * Subtitule for step 1
     */
    step1title: {
      type: String,
      default: 'Merge Customers'
    },

    /**
     * title for step 2
     */
    step2title: {
      type: String,
      default: 'Are you sure you want to merge these customers?'
    },

    /**
     * text for step 1
     */
    step1text: {
      type: String,
      default: 'Select the customer information that will become active for this individual’s Customer ID.'
    },

    /**
     * text for step 2
     */
    step2text: {
      type: String,
      default: ''
    },

    /**
     * subtitule for step 1
     */
    step1subtitle: {
      type: String,
      default: 'Customer information'
    },

    /**
     * subtitle for step 2
     */
    step2subtitle: {
      type: String,
      default: 'Customer information'
    }
  },

  data() {
    return {
      step: 0,
      loading: false,
      mergedData: {},
      valid: false
    };
  },

  methods: {
    setStep2() {
      this.$refs.step1.checkAllFields();

      if (this.valid) {
        this.step = 1;
      }
    },

    confirm() {
      this.loading = true;
      /**
       * Launch when user confirm merge. return merged data.
       * @property {object} mergedData key-value object, with all fields defined in fields array and his merged values.
       */

      this.$emit('merge', this.mergedData);
    }

  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', [_c('v-card-title', {
    staticClass: "background"
  }, [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_vm.step === 0 ? _c('span', {
    key: "0"
  }, [_vm._v("\n        " + _vm._s(_vm.step1title) + "\n      ")]) : _vm.step === 1 ? _c('span', {
    key: "1"
  }, [_vm._v("\n        " + _vm._s(_vm.step2title) + "\n\n      ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-card-text', [_c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_vm.step === 0 ? _c('step-1', {
    key: "0",
    ref: "step1",
    attrs: {
      "valid": _vm.valid,
      "selected": _vm.selected,
      "fields": _vm.fields,
      "text": _vm.step1text,
      "subtitle": _vm.step1subtitle
    },
    on: {
      "update:valid": function ($event) {
        _vm.valid = $event;
      }
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (slotData, name) {
      return {
        key: name,
        fn: function (data) {
          return [_vm._e(), _vm._v(" "), _vm._t(name, null, null, data)];
        }
      };
    })], null, true),
    model: {
      value: _vm.mergedData,
      callback: function ($$v) {
        _vm.mergedData = $$v;
      },
      expression: "mergedData"
    }
  }) : _vm._e(), _vm._v(" "), _vm.step === 1 ? _c('step-2', {
    key: "1",
    attrs: {
      "fields": _vm.fields,
      "value": _vm.mergedData,
      "text": _vm.step2text,
      "subtitle": _vm.step2subtitle
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "background"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_vm.step === 0 ? _c('div', {
    key: "0",
    staticClass: "buttons"
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "depressed": "",
      "width": "120",
      "color": "grey"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('cancel')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "width": "120",
      "color": "primary"
    },
    on: {
      "click": _vm.setStep2
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('merge')) + "\n        ")])], 1) : _vm._e(), _vm._v(" "), _vm.step === 1 ? _c('div', {
    key: "1",
    staticClass: "buttons"
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "outlined": "",
      "depressed": "",
      "width": "120",
      "color": "grey",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        _vm.step = 0;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('back')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "width": "120",
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('confirm')) + "\n        ")])], 1) : _vm._e()])], 1)], 1);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = function (inject) {
  if (!inject) return;
  inject("data-v-5b3eeac0_0", {
    source: ".background[data-v-5b3eeac0]{background-color:#fafafa!important}.buttons[data-v-5b3eeac0]{width:100%;text-align:right}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$D = "data-v-5b3eeac0";
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, createInjector, undefined, undefined);

var __vue_component__$R = __vue_component__$Q;

/**
 * Layer list in a form of a treeview.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/layer-list)
 * @displayName LayerList
 * @author egrande
 * @since 0.6.19
 */

var script$C = {
  components: {
    VIcon: VIcon,
    VBtn: VBtn,
    VTextField: VTextField,
    VToolbar: VToolbar,
    VAvatar: VAvatar,
    VTooltip: VTooltip,
    VProgressCircular: VProgressCircular,
    VBadge: VBadge,
    VSlider: VSlider,
    VCardText: VCardText,
    VCard: VCard,
    VMenu: VMenu,
    VTreeview: VTreeview
  },
  mixins: [i18n('LayerList')],
  props: {
    /**
     * Array of layers to show.
     */
    layers: {
      type: Array,
      default: () => []
    },

    /**
     * Hide default layer actions: selection & opacity control.
     */
    hideActions: {
      type: Boolean,
      default: false
    },

    /**
     * Start with opened tree.
     */
    openAll: {
      type: Boolean,
      default: false
    },

    /**
     * Adds a dragging control for the layers.
     */
    layerDraggable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      search: '',
      openNodes: [],
      foldersToggle: false,
      transparency: 50,
      currentScale: 0,
      dragging: false,
      icons: {
        clientgraphic: 'mdi-vector-polyline',
        wfs: 'mdi-vector-polyline',
        'vector-poi': 'mdi-vector-polyline',
        'vector-cameras': 'mdi-vector-polyline',
        genericpoi: 'mdi-vector-polyline',
        'vector-resources': 'mdi-vector-polyline',
        Sublayer: 'mdi-layers',
        'arcgis-feature': 'mdi-vector-polyline',
        wms: 'mdi-file-image',
        xyz: 'mdi-file-image',
        'arcgis-map': 'mdi-file-image',
        wind: 'mdi-tailwind'
      }
    };
  },

  created() {
    this.getAllIds = () => {
      const res = [];

      const cb = layer => {
        res.push(layer.Id);
        layer.Children && layer.Children.forEach(cb);
      };

      this.layers.forEach(cb);
      return res;
    };
  },

  methods: {
    toggleFolders() {
      this.foldersToggle = !this.foldersToggle;
      if (this.foldersToggle) this.openNodes = this.getAllIds();else this.openNodes = [];
    },

    onDrag(layer, e) {
      this.dragging = true;
      e.dataTransfer.setData('layer', JSON.stringify(layer));
    },

    onDragEnter(target, e) {
      const layer = JSON.parse(e.dataTransfer.getData('layer'));
      if (!layer || layer.Id === target.Id) return;
      e.currentTarget.classList.add('drag-enter');
    },

    onDragLeave(target, e) {
      e.currentTarget.classList.remove('drag-enter');
    },

    onDrop(target, e) {
      const layer = JSON.parse(e.dataTransfer.getData('layer'));
      if (!layer || layer.Id === target.Id) return;
      /**
       * Launch when a layer in dropped. Returns layer object.
       * @property {object} data includes layer, target and event.
       */

      this.$emit('layer-drop', {
        layer,
        target,
        event: e
      });
    }

  }
};

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-toolbar', {
    attrs: {
      "color": "grey lighten-3 sticky-toolbar",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.toggleFolders
    }
  }, [_c('v-icon', [_vm._v("\n        " + _vm._s(_vm.foldersToggle ? 'mdi-folder-open' : 'mdi-folder') + "\n      ")])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "color": "accent",
      "single-line": "",
      "dense": "",
      "solo": "",
      "flat": "",
      "rounded": "",
      "prepend-inner-icon": "mdi-magnify",
      "clearable": "",
      "hide-details": "",
      "label": _vm.t('search')
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-treeview', {
    attrs: {
      "items": _vm.layers,
      "search": _vm.search,
      "item-text": "DisplayName",
      "item-key": "Id",
      "item-children": "Children",
      "open-on-click": "",
      "open": _vm.openNodes,
      "open-all": _vm.openAll
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function (ref) {
        var item = ref.item;
        var open = ref.open;
        return [_vm.layerDraggable ? _c('v-avatar', {
          staticClass: "drop-zone mr-2",
          attrs: {
            "color": _vm.dragging ? 'primary' : '',
            "size": _vm.dragging ? 32 : 24
          },
          on: {
            "dragenter": [function ($event) {
              return _vm.onDragEnter(item, $event);
            }, function ($event) {
              $event.preventDefault();
            }],
            "dragleave": function ($event) {
              return _vm.onDragLeave(item, $event);
            },
            "dragover": function ($event) {
              $event.preventDefault();
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "draggable": "",
            "color": _vm.dragging ? 'white' : ''
          },
          on: {
            "dragstart": function ($event) {
              return _vm.onDrag(item, $event);
            },
            "drop": function ($event) {
              return _vm.onDrop(item, $event);
            },
            "dragend": function ($event) {
              _vm.dragging = false;
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.dragging ? 'mdi-selection-ellipse-arrow-inside' : 'mdi-drag') + "\n          ")])], 1) : _vm._e(), _vm._v(" "), item.Type === 'Category' ? _c('v-icon', [_vm._v("\n          " + _vm._s(open ? 'mdi-folder-open' : 'mdi-folder') + "\n        ")]) : _c('v-icon', {
          class: {
            'grey--text text--lighten-1': !item.Available && item.Type !== 'Category'
          }
        }, [_vm._v("\n          " + _vm._s(_vm.icons[item.Type]) + "\n        ")])];
      }
    }, {
      key: "label",
      fn: function (ref) {
        var item = ref.item;
        return [_c('span', {
          class: {
            'grey--text text--lighten-1': !item.Available && item.Type !== 'Category',
            'accent--text': item.Accent
          }
        }, [_vm._v("\n          " + _vm._s(item.DisplayName) + "\n        ")]), _vm._v(" "), item.Error ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (ref) {
              var on = ref.on;
              var attrs = ref.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "color": "red",
                  "small": ""
                }
              }, 'v-icon', attrs, false), on), [_vm._v("\n              mdi-alert-circle\n            ")])];
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.t('couldntLoadLayer')))])]) : _vm._e(), _vm._v(" "), item.Loading ? _c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "size": "10",
            "width": "1"
          }
        }) : _vm._e()];
      }
    }, {
      key: "append",
      fn: function (ref) {
        var item = ref.item;
        return [item.Type !== 'Category' && item.Type !== 'Sublayer' && !_vm.hideActions ? _c('v-menu', {
          attrs: {
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (ref) {
              var on = ref.on;
              var attrs = ref.attrs;
              return [_c('span', [item.Type === 'arcgis-feature' ? _c('span', [item.Query ? _c('v-badge', {
                staticClass: "apply-badge",
                attrs: {
                  "dot": "",
                  "overlap": "",
                  "color": "accent"
                }
              }, [_c('v-btn', {
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.$emit('change-filter', {
                      layer: item
                    });
                  }
                }
              }, [_c('v-icon', [_vm._v("\n                      mdi-filter\n                    ")])], 1)], 1) : _c('v-btn', {
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.$emit('change-filter', {
                      layer: item
                    });
                  }
                }
              }, [_c('v-icon', [_vm._v("\n                    mdi-filter\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), item.Opacity !== 100 ? _c('v-badge', {
                staticClass: "apply-badge",
                attrs: {
                  "dot": "",
                  "overlap": "",
                  "color": "accent"
                }
              }, [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": "",
                  "disabled": !item.Available && item.Type !== 'Category'
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("\n                    mdi-opacity\n                  ")])], 1)], 1) : _c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "icon": "",
                  "disabled": !item.Available && item.Type !== 'Category'
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("\n                  mdi-opacity\n                ")])], 1), _vm._v(" "), _c('v-btn', {
                attrs: {
                  "icon": "",
                  "disabled": !item.Available && item.Type !== 'Category'
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.$emit('change-visibility', {
                      layer: item
                    });
                  }
                }
              }, [_c('v-icon', [_vm._v("\n                  " + _vm._s(item.Enabled ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline') + "\n                ")])], 1)], 1)];
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          attrs: {
            "width": "300px"
          }
        }, [_c('v-card-text', {
          staticClass: "pa-4"
        }, [_c('p', [_vm._v(" " + _vm._s(_vm.t('opacityOf', {
          msg: item.DisplayName
        })) + " ")]), _vm._v(" "), _c('v-slider', {
          attrs: {
            "value": item.Opacity,
            "color": "accent",
            "hide-details": "",
            "thumb-label": ""
          },
          on: {
            "input": function ($event) {
              return _vm.$emit('change-opacity', {
                layer: item,
                value: $event
              });
            }
          }
        })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), item.Type === 'Sublayer' && !_vm.hideActions ? _c('span', [_c('v-btn', {
          attrs: {
            "icon": "",
            "disabled": !item.Available
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('change-visibility', {
                layer: item
              });
            }
          }
        }, [_c('v-icon', [_vm._v("\n              " + _vm._s(item.Enabled ? 'mdi-check-box-outline' : 'mdi-checkbox-blank-outline') + "\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("custom-actions", null, {
          "item": item
        })];
      }
    }], null, true)
  })], 1)], 1);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = function (inject) {
  if (!inject) return;
  inject("data-v-e7623082_0", {
    source: ".v-badge.apply-badge[data-v-e7623082] .v-badge__badge{bottom:calc(100% - 11px)!important;left:calc(100% - 11px)!important}header.v-toolbar.sticky-toolbar[data-v-e7623082]{position:sticky;top:0;z-index:1}.drop-zone[data-v-e7623082].drag-enter{background-color:#444!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$C = "data-v-e7623082";
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, createInjector, undefined, undefined);

var __vue_component__$P = __vue_component__$O;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

class ArcGISService {
  constructor(url, token, username, password, isPortal = false, customTokenUrl) {
    _defineProperty(this, "type", 'ArcGIS');

    if (!url.toLowerCase().includes('/arcgis/rest/services')) throw new Error();
    this.originalUrl = url;
    this.url = url.toLowerCase();
    this.token = token;
    this.username = username;
    this.password = password;

    if (customTokenUrl) {
      this.tokenRequestUrl = customTokenUrl;
    } else if (isPortal) {
      this.tokenRequestUrl = this.url.split('arcgis/rest/services')[0] + 'sharing/generateToken';
    } else {
      this.tokenRequestUrl = this.url.split('rest/services')[0] + 'tokens/generateToken';
    } // Accept featureserver & mapserver urls too


    const parts = url.split('rest/services');

    if (url.includes('FeatureServer')) {
      this.innerService = {
        type: 'FeatureServer',
        name: parts[1].split('/FeatureServer')[0]
      };
    }

    if (url.includes('MapServer')) {
      this.innerService = {
        type: 'MapServer',
        name: parts[1].split('/MapServer')[0]
      };
    }

    this.url = parts[0] + 'rest/services';
  }

  async check() {
    if (this.username && this.password) this.token = await this.generateArcGISToken();
    if (this.layersUrl) await this.getLayers;else await this.getServices();
    return true;
  }

  async generateArcGISToken() {
    const params = new URLSearchParams();
    params.append('username', this.username);
    params.append('password', this.password);
    params.append('client', 'referer');
    params.append('expiration', 3600); // 1 hour token

    params.append('f', 'json');
    params.append('referer', window.location.origin);
    const res = await fetch(this.tokenRequestUrl, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: params.toString()
    });
    const json = await res.json();
    return json.token;
  }

  async getServices(folder) {
    const res = await fetch(`${folder || this.originalUrl}?f=json${this.token ? `&token=${this.token}` : ''}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    const data = await res.json();
    let services = data.services;

    if (data.folders && data.folders.length) {
      for (const folder of data.folders) {
        services = services.concat(await this.getServices(`${this.originalUrl}/${folder}`));
      }
    }

    return services;
  }

  async getLayers(innerService) {
    this.innerService = innerService;
    const res = await fetch(`${this.url}/${innerService.name}/${innerService.type}/layers?f=json${this.token ? `&token=${this.token}` : ''}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    const layers = (await res.json()).layers;
    return layers;
  }

}

class OGCService {
  constructor(url, username, password) {
    _defineProperty(this, "type", 'OGC');

    this.url = new window.URL(url);
    this.username = username;
    this.password = password;
    if (this.url.pathname.endsWith('wms')) this.service = 'wms';else if (this.url.pathname.endsWith('wfs')) this.service = 'wfs';
    this.service = this.url.searchParams.get('service') || this.service || 'wms';
    this.version = this.url.searchParams.get('version') || '1.3.0';
  }

  async check() {
    const res = await fetch(`${this.url.origin}${this.url.pathname}?version=${this.version}&service=${this.service}&request=GetCapabilities`);
    const text = await res.text();
    this.capabilities = new window.DOMParser().parseFromString(text, 'text/xml');
    return true;
  }

  async getLayers() {
    if (!this.capabilities) await this.check();
    return Array.from(this.capabilities.querySelectorAll('Layer[queryable="1"]'));
  }

}

const serviceTypes = ['ArcGIS', 'OGC'];
async function getService(type, url, username, password, isPortal) {
  let service;

  switch (type) {
    case 'ArcGIS':
      service = new ArcGISService(url, null, username, password, isPortal);
      await service.check();
      return service;

    case 'OGC':
      service = new OGCService(url, username, password);
      await service.check();
      return service;

    default:
      return false;
  }
}

var script$B = {
  components: {
    VSelect: VSelect,
    VTextField: VTextField,
    VCheckbox: VCheckbox,
    VProgressLinear: VProgressLinear,
    VAlert: VAlert,
    VForm: VForm
  },
  mixins: [i18n('LayerFinder')],

  data() {
    return {
      options: serviceTypes,
      serviceType: null,
      url: '',
      authenticated: false,
      serviceOk: false,
      valid: false,
      isPortal: false,
      auth: {
        username: '',
        password: ''
      },
      rules: {
        serviceType: validate('field', isRequired()),
        serviceUrl: validate('field', isRequired(), isValidUrl())
      },
      checking: false
    };
  },

  methods: {
    checkService: debounce(async function () {
      this.checking = true;
      this.serviceOk = false;

      if (!this.valid) {
        this.checking = false;
        return;
      }

      try {
        const service = await getService(this.serviceType, this.url, this.auth.username, this.auth.password, this.isPortal);

        if (service) {
          this.$emit('finish-step', service);
          this.serviceOk = true;
        }
      } catch (error) {
        this.$emit('error-step');
        console.warn('bad service');
      }

      this.checking = false;
    }, 1000)
  }
};

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-form', {
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('h4', {
    staticClass: "mb-4 text-h4"
  }, [_vm._v("\n    " + _vm._s(_vm.t('addMapService')) + "\n  ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "outlined": "",
      "items": _vm.options,
      "rules": _vm.rules.serviceType,
      "label": _vm.t('serviceType')
    },
    on: {
      "input": _vm.checkService
    },
    model: {
      value: _vm.serviceType,
      callback: function ($$v) {
        _vm.serviceType = $$v;
      },
      expression: "serviceType"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.t('serviceUrl'),
      "rules": _vm.rules.serviceUrl,
      "placeholder": "https://services3.arcgis.com/T4QMspbfLg3qTGWY/arcgis/rest/services"
    },
    on: {
      "input": _vm.checkService
    },
    model: {
      value: _vm.url,
      callback: function ($$v) {
        _vm.url = $$v;
      },
      expression: "url"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.t('authenticated')
    },
    model: {
      value: _vm.authenticated,
      callback: function ($$v) {
        _vm.authenticated = $$v;
      },
      expression: "authenticated"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.authenticated,
      expression: "authenticated"
    }],
    staticClass: "mt-0",
    attrs: {
      "label": _vm.t('arcGisPortal')
    },
    model: {
      value: _vm.isPortal,
      callback: function ($$v) {
        _vm.isPortal = $$v;
      },
      expression: "isPortal"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.authenticated,
      expression: "authenticated"
    }],
    attrs: {
      "outlined": "",
      "label": _vm.t('username')
    },
    on: {
      "input": _vm.checkService
    },
    model: {
      value: _vm.auth.username,
      callback: function ($$v) {
        _vm.$set(_vm.auth, "username", $$v);
      },
      expression: "auth.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.authenticated,
      expression: "authenticated"
    }],
    attrs: {
      "outlined": "",
      "label": _vm.t('password'),
      "type": "Password"
    },
    on: {
      "input": _vm.checkService
    },
    model: {
      value: _vm.auth.password,
      callback: function ($$v) {
        _vm.$set(_vm.auth, "password", $$v);
      },
      expression: "auth.password"
    }
  }), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.checking,
      expression: "checking"
    }],
    attrs: {
      "indeterminate": ""
    }
  }), _vm._v(" "), _c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.serviceOk,
      expression: "serviceOk"
    }],
    attrs: {
      "type": "success"
    }
  }, [_vm._v("\n    Looks like a valid map service\n  ")])], 1);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = undefined;
/* scoped */

const __vue_scope_id__$B = undefined;
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

var script$A = {
  components: {
    VTextField: VTextField,
    VDivider: VDivider,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem,
    VList: VList,
    VForm: VForm
  },
  mixins: [i18n('LayerFinder')],
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      search: '',
      selectedOption: null
    };
  },

  methods: {
    select(option) {
      this.selectedOption = option.name;
      this.$emit('finish-step', option);
    }

  },
  computed: {
    filteredOptions() {
      if (!this.search) return this.options;
      return this.options.filter(o => o.name.toLowerCase().includes(this.search.toLowerCase()));
    }

  }
};

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-form', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden",
      "height": "100%"
    }
  }, [_c('h4', {
    staticClass: "mb-4 text-h4"
  }, [_vm._v("\n    " + _vm._s(_vm.t('serviceSelection')) + "\n  ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "flex-grow-0",
    attrs: {
      "label": _vm.t('search'),
      "outlined": ""
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "overflow-y": "auto",
      "border": "1px solid grey"
    }
  }, _vm._l(_vm.filteredOptions, function (option) {
    return _c('div', {
      key: option.url
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-item', {
      class: {
        'v-list-item--active': _vm.selectedOption === option.name
      },
      on: {
        "click": function ($event) {
          return _vm.select(option);
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(option.name) + " (" + _vm._s(option.type) + ")")])], 1)], 1)], 1);
  }), 0)], 1);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = undefined;
/* scoped */

const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

var script$z = {
  components: {
    VTextField: VTextField,
    VDivider: VDivider,
    VCheckbox: VCheckbox,
    VListItemAction: VListItemAction,
    VListItemTitle: VListItemTitle,
    VListItemContent: VListItemContent,
    VListItem: VListItem,
    VList: VList,
    VForm: VForm
  },
  mixins: [i18n('LayerFinder')],
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      search: ''
    };
  },

  methods: {
    finish() {
      this.$emit('finish-step', this.options.filter(l => l.selected));
    }

  },
  computed: {
    filteredOptions() {
      if (!this.search) return this.options;
      return this.options.filter(o => o.name.toLowerCase().includes(this.search.toLowerCase()));
    }

  }
};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-form', {
    staticClass: "d-flex flex-column",
    staticStyle: {
      "overflow": "hidden",
      "height": "100%"
    }
  }, [_c('h4', {
    staticClass: "mb-4 text-h4"
  }, [_vm._v("\n    " + _vm._s(_vm.t('layerSelection')) + "\n  ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "flex-grow-0",
    attrs: {
      "label": _vm.t('search'),
      "outlined": ""
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "flex-grow-1",
    staticStyle: {
      "overflow-y": "auto",
      "border": "1px solid grey"
    }
  }, _vm._l(_vm.filteredOptions, function (option) {
    return _c('div', {
      key: option.id
    }, [_c('v-divider'), _vm._v(" "), _c('v-list-item', [_c('v-list-item-action', [_c('v-checkbox', {
      on: {
        "change": _vm.finish
      },
      model: {
        value: option.selected,
        callback: function ($$v) {
          _vm.$set(option, "selected", $$v);
        },
        expression: "option.selected"
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(option.name))])], 1)], 1)], 1);
  }), 0)], 1);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = undefined;
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

/**
 * Layer finder wizard. Allows the user to retrieve layers from a map service.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/layer-finder)
 * @displayName LayerFinder
 * @author egrande
 * @since 0.7.0
 */

var script$y = {
  mixins: [i18n('LayerFinder')],
  components: {
    ServiceForm: __vue_component__$N,
    InnerServiceForm: __vue_component__$M,
    LayerForm: __vue_component__$L,
    VToolbarTitle: VToolbarTitle,
    VSpacer: VSpacer,
    VToolbar: VToolbar,
    VCardText: VCardText,
    VBtn: VBtn,
    VCardActions: VCardActions,
    VCard: VCard
  },
  props: {
    /**
     * Top toolbar title
     */
    title: {
      type: String,
      default: 'Layer Finder'
    },

    /**
     * Validates a map service URL only.
     */
    mapServiceOnly: {
      type: Boolean,
      default: false
    },

    /**
     * A predefined map service for finding layers. This skips map service validation.
     */
    fromService: {
      type: Object,
      default: null
    },
    hideToolbar: {
      type: Boolean,
      default: false
    },
    finishButtonText: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      /**
       * Steps:1
       *  - 0: select service type: ArcGIS / OGC / Internal
       *  - 1: select inner service from list
       *  - 2: select layers
       */
      step: 0,
      currentFormValid: false,
      innerServices: [],
      selectedInnerService: null,
      layers: [],
      selectedLayers: []
    };
  },

  async created() {
    if (this.fromService) {
      await this.onServiceFormFinished(this.fromService);
      return this.next();
    }
  },

  computed: {
    nextDisabled() {
      return !this.currentFormValid || this.step === 2;
    },

    finishDisabled() {
      if (this.mapServiceOnly) {
        return !this.currentFormValid;
      }

      return this.step !== 2 || !this.currentFormValid;
    }

  },
  watch: {
    async fromService() {
      this.cancel();
      await this.onServiceFormFinished(this.fromService);
      return this.next();
    }

  },
  methods: {
    cancel() {
      this.step = 0;
      this.mapService = null;
      this.innerServices.length = 0;
      this.selectedInnerService = null;
      this.layers.length = 0;
      this.selectedLayers.length = 0;
      /**
       * Launch when the component is resetted.
       */

      this.$emit('cancel');
    },

    next() {
      if (this.step === 0 && this.layers.length) this.step += 2; // go directly to step 2
      else this.step += 1;
      this.currentFormValid = false;
    },

    finish() {
      let payload;
      if (this.mapServiceOnly) payload = this.mapService;else payload = this.selectedLayers.slice();
      /**
       * Launch when a the form is finished.
       * @property {object} payload this can be a mapService object (when mapServiceOnly is used) or a list of selected layers.
       */

      this.$emit('finish', payload);
    },

    async onServiceFormFinished(service) {
      this.mapService = service;

      if (this.mapService.type === 'ArcGIS') {
        if (this.mapService.innerService) {
          // already has an inner service, so we have direct access to layers
          this.layers = await this.listLayers(this.mapService.innerService);
        } else {
          // list map services first
          this.innerServices = await this.mapService.getServices();
        }
      } else if (this.mapService.type === 'OGC') {
        this.layers = await this.listLayers();
      }

      this.currentFormValid = true;
    },

    onServiceFormError() {
      this.mapService = null;
      this.currentFormValid = false;
    },

    async onInnerServiceFormFinished(innerService) {
      this.selectedInnerService = innerService;
      this.layers = await this.listLayers(innerService);
      this.currentFormValid = true;
    },

    onLayerFormFinished(layers) {
      this.selectedLayers = layers;
      if (this.selectedLayers.length) this.currentFormValid = true;else this.currentFormValid = false;
      /**
       * Launch when a the form is finished.
       * @property {Array} selectedLayers layers list
       */

      this.$emit('layers-selected', this.selectedLayers);
    },

    async listLayers(innerService) {
      const layers = await this.mapService.getLayers(innerService);

      if (this.mapService.type === 'ArcGIS') {
        return layers.map(l => {
          return {
            id: l.id,
            name: l.name,
            selected: false
          };
        });
      } else if (this.mapService.type === 'OGC') {
        return layers.map(l => {
          return {
            id: l.querySelector('Name').textContent,
            name: l.querySelector('Title').textContent,
            selected: false
          };
        });
      }
    }

  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', [!_vm.hideToolbar ? _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dense": "",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "height": "500px",
      "overflow-y": "auto"
    }
  }, [_vm.step === 0 && !_vm.fromService ? _c('service-form', {
    on: {
      "finish-step": _vm.onServiceFormFinished,
      "error-step": _vm.onServiceFormError
    }
  }) : _vm._e(), _vm._v(" "), _vm.step === 1 ? _c('inner-service-form', {
    attrs: {
      "options": _vm.innerServices
    },
    on: {
      "finish-step": _vm.onInnerServiceFormFinished
    }
  }) : _vm._e(), _vm._v(" "), _vm.step === 2 ? _c('layer-form', {
    attrs: {
      "options": _vm.layers,
      "multiple": _vm.multiple
    },
    on: {
      "finish-step": _vm.onLayerFormFinished
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.mapServiceOnly && !_vm.fromService,
      expression: "!mapServiceOnly && !fromService"
    }],
    attrs: {
      "outlined": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n      " + _vm._s(_vm.t('cancel')) + "\n    ")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.mapServiceOnly,
      expression: "!mapServiceOnly"
    }],
    attrs: {
      "color": "primary",
      "disabled": _vm.nextDisabled
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n      " + _vm._s(_vm.t('next')) + "\n    ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.finishDisabled
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("\n      " + _vm._s(_vm.finishButtonText ? _vm.finishButtonText : _vm.t('finish')) + "\n    ")])], 1)], 1);
};

var __vue_staticRenderFns__$y = [];
/* style */

const __vue_inject_styles__$y = undefined;
/* scoped */

const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

var __vue_component__$K = __vue_component__$J;

//
/**
 * Simple wrapper to allow download blob files.
 * You have to use `:file` or `:file-async` prop.
 *
 * Alternatively you can use
 * [donwloadBlob](https://sandbox.technosylva.com/radon/modules/lib_files.html#downloadblob)
 * from Radon directly
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/download-file)
 * @displayName DownloadFile
 * @author dcrespo
 * @since 0.6.37
 */

var script$x = {
  props: {
    /**
     * You can use any component to render.
     * DownloadFile inherit all props and events.<br>
     * Be careful, you cannot use a string, you must pass the Vue Component function.
     * More info [here](#download-file-custom-component)
     */
    tag: {
      type: Function,
      default: null
    },

    /**
     * Blob file to download. This or `fileAsync` are required.
     */
    file: {
      type: Blob,
      default: null
    },

    /**
     * Async function that returns a Blob file
     */
    fileAsync: {
      type: Function,
      default: null
    },

    /**
     * The name with which the file is downloaded
     */
    filename: {
      type: String,
      required: true
    },

    /**
     * The file extension. USe only if `filename` has no extension
     */
    extension: {
      type: String,
      default: null
    }
  },
  components: {
    VBtn
  } ,

  data() {
    return {
      loading: false
    };
  },

  methods: {
    /**
     * Manually launch download
     * @public
      */
    async download() {
      let file;

      if (this.file) {
        file = this.file;
      } else {
        this.loading = true;
        /**
         * Returns true when `fileasync` is loading and false when it finish.<br>
         * moreover the component has the `:loading` prop, therefore if you use
         * a component like v-btn will change state automatically
         * @event loading
         * @property {boolean} loading
         */

        this.$emit('loading', true);
        file = await this.fileAsync();
        this.loading = false;
        this.$emit('loading', false);
      }

      downloadBlob(file, this.filename, this.extension);
    }

  }
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c(_vm.tag || 'v-btn', _vm._g(_vm._b({
    tag: "component",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.download
    }
  }, 'component', _vm.$attrs, false), _vm.$listeners), [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = "data-v-c84de026";
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

var __vue_component__$I = __vue_component__$H;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$w = {
  components: {
    VCol: VCol,
    VRow: VRow,
    VAlert: VAlert
  },
  props: {
    comment: {
      type: Object,
      required: true
    },
    datefn: {
      type: Function,
      required: true
    }
  },
  computed: {
    timestamp() {
      return this.comment.CommentTimespan || this.comment.commentTimespan;
    }

  }
};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-alert', {
    staticClass: "mb-3 comment-item",
    attrs: {
      "outlined": "",
      "dense": "",
      "color": "grey"
    }
  }, [_c('v-row', {
    staticClass: "flex-nowrap",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pb-0 title-col"
  }, [_c('p', {
    staticClass: "grey--text mb-0"
  }, [_c('span', {
    staticClass: "span-author d-inline-block text-truncate"
  }, [_vm._v("\n          " + _vm._s(_vm.comment.UserName || _vm.comment.userName) + "\n        ")])])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "flex-nowrap",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pb-0 pt-0 date-col"
  }, [_c('p', {
    staticClass: "grey--text mb-0"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.datefn(_vm.timestamp)) + "\n        ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('p', {
    staticClass: "mb-0 comment-text"
  }, [_vm._v("\n        " + _vm._s(_vm.comment.Comment || _vm.comment.comment) + "\n      ")])])], 1)], 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = function (inject) {
  if (!inject) return;
  inject("data-v-336e85d5_0", {
    source: ".comment-text[data-v-336e85d5]{color:rgba(0,0,0,.87)!important}.date-col[data-v-336e85d5]{font-size:.85rem;margin-top:-8px}.comment-item[data-v-336e85d5]  .v-alert__content{width:0}.span-author[data-v-336e85d5]{width:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$w = "data-v-336e85d5";
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, createInjector, undefined, undefined);

/**
   * Container for comments and a button to add comment. For use with tsyl-core comments.
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/side-comments)
   * @displayName SectionComments
   * @author dcrespo
   * @since 0.6.41
   */

var script$v = {
  mixins: [i18n('SectionComments')],
  components: {
    CommentItem: __vue_component__$G,
    VSubheader: VSubheader,
    VProgressCircular: VProgressCircular,
    VIcon: VIcon,
    VSlideXReverseTransition: VSlideXReverseTransition,
    VBtn: VBtn,
    VCol: VCol,
    VRow: VRow,
    VTextarea: VTextarea
  },
  props: {
    /**
     * Shows add comment button
     */
    canAdd: {
      type: Boolean,
      default: false
    },

    /**
     * Selected section. Must be an object with `Id` and `Description`.
     * If it's null show a loading animaion
     * <code>{ Id: 'guid', Description: 'section name'}</code>
     */
    section: {
      type: Object,
      default: null
    },

    /**
     * Use this to set the [v-textarea props](https://vuetifyjs.com/en/components/textareas/)
     */
    textareaAttrs: {
      type: Object,
      default: () => ({})
    },

    /**
     * save function, this will be called when user write a comment and click save<br>
     * Parameters: `comment` and `idSection`
     */
    save: {
      type: Function,
      default: null
    },

    /**
     * get comment function. This will be called when section change or after save new comment<br>
     * Parameters: `idSection`<br>
     * Must be return an array with object with data: <br>
     * <code>
     * {IdComment: 'guid', UserName: 'User', CommentTimespan: 'UTCTimespan', Comment: 'text'}
     * </code><br>
     * Keys can start with lowercase for compatibility reasons
     */
    getComments: {
      type: Function,
      required: true
    },

    /**
     * date filter to show the comment's date formatted
     */
    datefn: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      commentsList: [],
      form: false,
      loading: false,
      comment: ''
    };
  },

  watch: {
    section: {
      handler(val) {
        if (val) this.myGetComments();
      },

      immediate: true
    },

    form(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.textarea.$el.querySelector('textarea').focus();
        }, 500); // wait transition
      }

      this.comment = '';
    }

  },
  methods: {
    listScroll() {
      setTimeout(() => {
        const objDiv = this.$refs.list;
        if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
      }, 500);
    },

    async myGetComments() {
      this.loading = true;
      this.commentsList = await this.getComments(this.section.Id);
      this.listScroll();
      this.loading = false;
    },

    async localSave() {
      const comment = this.comment.trim();

      if (comment && this.save) {
        this.loading = true;
        await this.save(comment, this.section.Id);
        await this.myGetComments();
        this.form = false;
        this.loading = false;
      }
    }

  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "review-comments-container"
  }, [_c('v-slide-x-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [!_vm.form ? _c('div', {
    key: "show",
    staticClass: "comments-container container pb-0  pr-0"
  }, [_c('v-subheader', {
    staticClass: "mb-3 mt-4"
  }, [_vm._v("\n        " + _vm._s(_vm.t('comments', {
    section: _vm.section ? _vm.section.Description : undefined
  })) + "\n      ")]), _vm._v(" "), _c('v-slide-x-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_vm.section && _vm.commentsList.length ? _c('div', {
    key: 2,
    ref: "list",
    staticClass: "d-flex flex-column flex-grow-1 overflow-y-auto pr-3"
  }, _vm._l(_vm.commentsList, function (cm) {
    return _c('CommentItem', {
      key: cm.idComment,
      attrs: {
        "comment": cm,
        "datefn": _vm.datefn
      }
    });
  }), 1) : !_vm.section || _vm.loading ? _c('div', {
    key: 0,
    staticClass: "d-flex flex-column flex-grow-1 align-center justify-center pa-6"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "info"
    }
  })], 1) : _c('div', {
    key: 1,
    staticClass: "d-flex flex-column flex-grow-1 align-center justify-center pa-6"
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "info"
    }
  }, [_vm._v("\n            mdi-comment-plus-outline\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-6 text-center grey--text text--darken-2 "
  }, [_vm._v("\n            " + _vm._s(_vm.t('noCommentsAdded')) + "\n          ")])], 1)]), _vm._v(" "), _vm.canAdd && _vm.section ? _c('v-row', {
    staticClass: "flex-grow-0 bg-colorized  pr-3"
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "outlined": "",
      "block": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.form = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("\n              mdi-message-plus\n            ")]), _vm._v("\n            " + _vm._s(_vm.t('addCommentBtn')) + "\n          ")], 1)], 1)], 1) : _vm._e()], 1) : _c('div', {
    key: "form",
    staticClass: "comments-container container pb-0 "
  }, [_c('h6', {
    staticClass: "text-h6 mb-6"
  }, [_vm._v("\n        " + _vm._s(_vm.t('addCommentTitle')) + "\n      ")]), _vm._v(" "), _c('v-textarea', _vm._b({
    ref: "textarea",
    staticClass: "textarea-full-height",
    model: {
      value: _vm.comment,
      callback: function ($$v) {
        _vm.comment = $$v;
      },
      expression: "comment"
    }
  }, 'v-textarea', Object.assign({}, {
    outlined: true
  }, _vm.textareaAttrs), false)), _vm._v(" "), _c('v-row', {
    staticClass: "flex-grow-0 bg-colorized"
  }, [_c('v-col', [_c('v-btn', {
    attrs: {
      "outlined": "",
      "block": "",
      "color": "gray"
    },
    on: {
      "click": function ($event) {
        _vm.form = false;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t('discard')) + "\n          ")])], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.localSave
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t('save')) + "\n          ")])], 1)], 1)], 1)])], 1);
};

var __vue_staticRenderFns__$v = [];
/* style */

const __vue_inject_styles__$v = function (inject) {
  if (!inject) return;
  inject("data-v-75ff2b7e_0", {
    source: ".review-comments-container[data-v-75ff2b7e]{height:100%}.comments-container[data-v-75ff2b7e]{height:100%;display:flex;flex-direction:column}.textarea-full-height[data-v-75ff2b7e]  .v-input__control{height:100%}.textarea-full-height[data-v-75ff2b7e]  .v-input__slot{height:calc(100% - 32px)}.textarea-full-height[data-v-75ff2b7e] .v-input--hide-details .v-input__slot{height:100%}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$v = "data-v-75ff2b7e";
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, createInjector, undefined, undefined);

var __vue_component__$F = __vue_component__$E;

const types = {
  DD: {
    latmask: settings => ({
      mask: `[-]9[9].${'9'.repeat(settings.decimals)}`
    }),
    lonmask: settings => ({
      mask: `[-]9[9][9].${'9'.repeat(settings.decimals)}`
    })
  },
  DDM: {
    latmask: () => ({
      mask: "[-]9[9]º 99.999' S",
      definitions: {
        S: {
          validator: '[NnSs]',
          casing: 'upper'
        }
      }
    }),
    lonmask: () => ({
      mask: "[-]9[9][9]º 99.999' E",
      definitions: {
        E: {
          validator: '[EeWw]',
          casing: 'upper'
        }
      }
    })
  },
  DMS: {
    latmask: () => ({
      mask: "[-]9[9]º 99' 99'' S",
      definitions: {
        S: {
          validator: '[NnSs]',
          casing: 'upper'
        }
      }
    }),
    lonmask: () => ({
      mask: "[-]9[9][9]º 99' 99'' E",
      definitions: {
        E: {
          validator: '[EeWw]',
          casing: 'upper'
        }
      }
    })
  }
};
var typeManagement = {
  props: {
    /**
     * Default display type
     */
    type: {
      type: String,
      default: 'DD',
      validator: val => {
        return Object.keys(types).indexOf(val) !== -1;
      }
    },

    /**
    * List of display types allowed. Value prop must be an allowed type
    */
    types: {
      type: Array,
      default: () => [{
        name: 'DD',
        value: 'DD'
      }, {
        name: 'DMS',
        value: 'DMS'
      }, {
        name: 'DDM',
        value: 'DDM'
      }],
      validator: val => {
        return val.every(e => e.value && Object.keys(types).indexOf(e.value) !== -1);
      }
    }
  },

  data() {
    return {
      typeLocal: null
    };
  },

  computed: {
    typeValue: {
      get() {
        return this.typeLocal;
      },

      set(value) {
        this.typeLocal = value;
        /**
         * sync type
         * @event update:type
         * @property {string} type
         */

        this.$emit('update:type', value);
      }

    }
  },
  watch: {
    type: {
      handler: function (val) {
        this.typeLocal = val;
      },
      immediate: true
    }
  }
};

var BindingValuesMixin = {
  data() {
    return {
      lonInputValue: '',
      latInputValue: '',
      latitudeComponents: [],
      longitudeComponents: [],
      selectorComponents: []
    };
  },

  watch: {
    latInputValue(val) {
      this.setValueToComponents(this.latitudeComponents, 'txt', val);
    },

    lonInputValue(val) {
      this.setValueToComponents(this.longitudeComponents, 'txt', val);
    },

    settings: {
      handler: function (val) {
        this.setValueToComponents(this.longitudeComponents, 'settings', val);
      },
      deep: true
    },

    typeLocal() {
      this.setTypeToComponents();
    },

    error(val) {
      this.setValueToComponents(this.latitudeComponents, 'error', val);
      this.setValueToComponents(this.longitudeComponents, 'error', val);
    }

  },

  mounted() {
    this.$nextTick(() => {
      const slots = this.$slots.default;
      this.findInDOM(slots);

      for (const component of this.latitudeComponents) {
        component.latlon = 'lat';
        component.settings = this.settings;
        component.$on('input', value => {
          this.latInputValue = value;
        });
      }

      for (const component of this.longitudeComponents) {
        component.latlon = 'lon';
        component.settings = this.settings;
        component.$on('input', value => {
          this.lonInputValue = value;
        });
      }

      for (const component of this.selectorComponents) {
        component.value = this.typeValue;
        component.values = this.types;
        component.$on('input', value => {
          this.typeValue = value;
        });
      }

      this.setData('latitude');
      this.setData('longitude');
      this.setTypeToComponents();
    });
  },

  methods: {
    setTypeToComponents() {
      this.setValueToComponents(this.longitudeComponents, 'type', this.typeLocal);
      this.setValueToComponents(this.latitudeComponents, 'type', this.typeLocal);
      this.setValueToComponents(this.selectorComponents, 'value', this.typeLocal);
    },

    setValueToComponents(listOfComponents, key, value) {
      for (const component of listOfComponents) {
        if (component[key] !== value) {
          component[key] = value;
        }
      }
    },

    findInDOM(elements) {
      if (elements) {
        for (const element of elements) {
          var _element$componentOpt, _element$componentOpt2, _element$componentOpt3;

          if (((_element$componentOpt = element.componentOptions) === null || _element$componentOpt === void 0 ? void 0 : _element$componentOpt.tag) === 'latitude-field') {
            this.latitudeComponents.push(element.child);
          } else if (((_element$componentOpt2 = element.componentOptions) === null || _element$componentOpt2 === void 0 ? void 0 : _element$componentOpt2.tag) === 'longitude-field') {
            this.longitudeComponents.push(element.child);
          } else if (((_element$componentOpt3 = element.componentOptions) === null || _element$componentOpt3 === void 0 ? void 0 : _element$componentOpt3.tag) === 'location-type-selector') {
            this.selectorComponents.push(element.child);
          } else if (element.children) {
            this.findInDOM(element.children);
          }
        }
      }
    }

  }
};

// Used in LocationInputWrapper And LocationField
const defaultSettings = {
  DD: {
    decimals: 8
  }
};
var SettingsMixin = {
  computed: {
    mergedSettings() {
      return merge(cloneDeep(defaultSettings), this.settings);
    },

    typeSettings() {
      const type = this.typeValue || this.type;

      if (this.mergedSettings && this.mergedSettings[type]) {
        return this.mergedSettings[type];
      } else {
        return {};
      }
    }

  }
};

/**
 * Location input wrapper, for use with [LocationField](#locationfield)
 * and [LocationTypeSelector](#locationtypeselector)
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/location-input)
 * @displayName LocationInputWrapper
 * @author dcrespo
 * @since 0.6.35
 */

var script$u = {
  components: {
    Fragment
  },
  mixins: [typeManagement, BindingValuesMixin, SettingsMixin],
  props: {
    /**
     * (sync) Decimal degrees longitude
     */
    longitude: {
      type: Number,
      default: null
    },

    /**
     * (sync) Decimal degrees latitude
     */
    latitude: {
      type: Number,
      default: null
    },

    /**
     * (sync) Web Mercator longitude
     */
    x: {
      type: Number,
      default: null
    },

    /**
     * (sync) Web Mercator latitude
     */
    y: {
      type: Number,
      default: null
    },

    /**
     * Number of decimals returned
     */
    precision: {
      type: Number,
      default: 8
    },

    /**
     * Config for the mask. More info [here](#locationinputsettings)
     */
    settings: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      // lonInputValue: '' from BindingValuesMixin
      // latInputValue: '' from BindingValuesMixin
      lonAvoidUpdate: false,
      latAvoidUpdate: false,
      avoidEmit: false
    };
  },

  created() {
    if ((this.longitude || this.latitude) && (this.x || this.y)) {
      console.error('[Zapan warn]: ' + 'You cannot use longitude/latitude and x/y props at same time');
    }
  },

  computed: {
    lonlat: {
      get() {
        try {
          const position = new Coordinates(`${this.latInputValue} ${this.lonInputValue}`);
          return [position.getLongitude(), position.getLatitude()];
        } catch (ex) {
          return [NaN, NaN];
        }
      },

      set(value) {
        if (this.typeValue === 'DMS') {
          [this.lonInputValue, this.latInputValue] = this.toHDMS(value);
        } else if (this.typeValue === 'DDM') {
          [this.lonInputValue, this.latInputValue] = this.toDDM(value);
        } else if (this.typeValue === 'DD') {
          if (this.typeSettings.decimals) {
            this.lonInputValue = this.toFixed(value[0], this.typeSettings.decimals);
            this.latInputValue = this.toFixed(value[1], this.typeSettings.decimals);
          } else {
            this.lonInputValue = value[0];
            this.latInputValue = value[1];
          }
        }
      }

    },

    error() {
      return isNaN(this.lonlat[0]) || isNaN(this.lonlat[1]);
    }

  },
  watch: {
    lonInputValue() {
      this.lonAvoidUpdate = true;
      this.emitData();
      this.$nextTick(() => {
        this.lonAvoidUpdate = false;
      });
    },

    latInputValue() {
      this.latAvoidUpdate = true;
      this.emitData();
      this.$nextTick(() => {
        this.latAvoidUpdate = false;
      });
    },

    longitude() {
      this.longitudeWatch();
    },

    x() {
      this.longitudeWatch();
    },

    latitude() {
      this.latitudeWatch();
    },

    y() {
      this.latitudeWatch();
    },

    type() {
      this.setData();
    },

    error(val) {
      /**
       * Emit true when component can't parse input value.
       * Input will be in an error state
       * @property {boolean} error
       */
      this.$emit('error', val);
    }

  },
  methods: {
    longitudeWatch() {
      if (!this.lonAvoidUpdate) {
        this.setData();
      }
    },

    latitudeWatch() {
      if (!this.latAvoidUpdate) {
        this.setData();
      }
    },

    setData() {
      this.avoidEmit = true;

      if (this.longitude) {
        this.lonlat = [this.longitude, this.latitude];
      } else if (this.x) {
        this.lonlat = toLonLat([this.x, this.y]);
      }

      this.$nextTick(() => {
        this.avoidEmit = false;
      });
    },

    fixPrecision(val) {
      return parseFloat(this.toFixed(val, this.precision));
    },

    toFixed(val, fix) {
      if (typeof val === 'number' && typeof fix === 'number') {
        return val.toFixed(fix);
      } else {
        return null;
      }
    },

    emitData() {
      if (!this.avoidEmit && !isNaN(this.lonlat[0])) {
        const fixedLong = this.fixPrecision(this.longitude);
        const fixedLat = this.fixPrecision(this.latitude);
        const fixedNewLong = this.fixPrecision(this.lonlat[0]);
        const fixedNewLat = this.fixPrecision(this.lonlat[1]);
        const xy = fromLonLat([fixedNewLong, fixedNewLat]);

        if (fixedLong !== fixedNewLong) {
          if (this.$listeners['update:longitude']) {
            /**
            * sync longitude
            * @property {number} longitude
            */
            this.$emit('update:longitude', fixedNewLong);
          } else if (this.$listeners['update:x']) {
            /**
            * sync x
            * @property {number} x
            */
            this.$emit('update:x', xy[0]);
          }
        }

        if (fixedLat !== fixedNewLat) {
          if (this.$listeners['update:latitude']) {
            /**
            * sync latitude
            * @property {number} latitude
            */
            this.$emit('update:latitude', fixedNewLat);
          } else if (this.$listeners['update:y']) {
            /**
            * sync y
            * @property {number} y
            */
            this.$emit('update:y', xy[1]);
          }
        }
      }
    },

    toHDMS(lonlat) {
      const hdms = toStringHDMS(lonlat);
      return [hdms.split(' ').slice(0, 4).join(' '), hdms.split(' ').slice(4).join(' ')].reverse();
    },

    toDDM(lonlat) {
      return getDDMCoords(lonlat.reverse()).reverse();
    }

  }
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('fragment', [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = "data-v-b371b000";
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

var __vue_component__$D = __vue_component__$C;

const catchMask = '';
/**
 * Exported as ***`LatitudeField`*** and ***`LongitudeField`***<br>
 * Use with
 * [LocationInputWrapper](#locationinputwrapper)<br><br>
 * You can use [any vuetify `v-text-field` props](https://vuetifyjs.com/en/api/v-text-field/)
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/location-input)
 * @displayName LocationField
 * @author dcrespo
 * @since 0.6.35
 */

var script$t = {
  components: {
    Fragment,
    VTextField: VTextField
  },
  mixins: [SettingsMixin],

  data() {
    return {
      txt: '',
      error: false,
      type: '',
      // "DMS", "DD", "DDM"
      latlon: '',
      // "lat" or "lon"
      settings: null
    };
  },

  computed: {
    mask() {
      try {
        return types[this.type][this.latlon + 'mask'](this.typeSettings) || catchMask;
      } catch (ex) {
        return catchMask;
      }
    }

  },
  methods: {
    emit(value) {
      this.error = false;
      const filled = value.replace(/_/g, '0');
      const isMaskValid = Inputmask.isValid(filled, this.mask);

      if (isMaskValid) {
        this.txt = filled;
        this.$emit('input', filled);
      } else {
        this.error = true;
      }
    }

  }
};

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('fragment', [_vm._t("default", function () {
    return [_c('v-text-field', _vm._b({
      directives: [{
        name: "input-mask",
        rawName: "v-input-mask",
        value: _vm.mask,
        expression: "mask"
      }],
      attrs: {
        "error": _vm.error
      },
      on: {
        "blur": function ($event) {
          return _vm.emit(_vm.txt);
        }
      },
      model: {
        value: _vm.txt,
        callback: function ($$v) {
          _vm.txt = $$v;
        },
        expression: "txt"
      }
    }, 'v-text-field', _vm.$attrs, false))];
  }, {
    "text": _vm.txt,
    "type": _vm.type,
    "error": _vm.error,
    "emit": _vm.emit,
    "mask": _vm.mask
  })], 2);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = undefined;
/* scoped */

const __vue_scope_id__$t = "data-v-7e56f52f";
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

var __vue_component__$B = __vue_component__$A;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Use with
 * [LocationInputWrapper](#locationinputwrapper)<br><br>
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/location-input)
 * @displayName LocationTypeSelector
 * @author dcrespo
 * @since 0.6.35
 */

var script$s = {
  components: {
    VIcon: VIcon,
    VBtn: VBtn,
    VListItemTitle: VListItemTitle,
    VListItem: VListItem,
    VList: VList,
    VMenu: VMenu
  },

  data() {
    return {
      value: '',
      values: []
    };
  }

};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', [_vm._v("\n  " + _vm._s(_vm.value) + "\n  "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        var attrs = ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "x-small": ""
          }
        }, 'v-btn', attrs, false), Object.assign({}, on, _vm.$listeners)), [_c('v-icon', [_vm._v("\n          mdi-menu-down\n        ")])], 1)];
      }
    }])
  }, [_vm._v(" "), _c('v-list', _vm._l(_vm.values, function (type) {
    return _c('v-list-item', {
      key: type.value,
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          _vm.value = type.value;

          _vm.$emit('input', type.value);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(type.name))])], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = undefined;
/* scoped */

const __vue_scope_id__$s = "data-v-b85203ec";
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

var __vue_component__$z = __vue_component__$y;

var script$r = {
  name: 'TreeContainer',
  props: {
    tree: {
      type: Object,
      required: true
    },
    deep: {
      type: Number,
      required: true
    },
    defaultDeep: {
      type: Number,
      default: null
    }
  },
  inject: ['childKey'],

  data() {
    return {
      hide: false
    };
  },

  created() {
    if (!isNullOrUndefined(this.defaultDeep) && this.defaultDeep <= this.deep) {
      this.hide = true;
    }
  },

  methods: {
    updateHide() {
      this.hide = !this.hide;
      this.$emit('update');
    }

  }
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "z-tree-container",
    class: ['deep-' + _vm.deep, {
      hide: _vm.hide
    }]
  }, [_c('div', {
    staticClass: "z-tree-content",
    class: 'deep-' + _vm.deep
  }, [_vm._t("default", null, {
    "data": _vm.tree,
    "hide": _vm.updateHide,
    "isHidden": _vm.hide
  })], 2), _vm._v(" "), _vm.tree[_vm.childKey] && !_vm.hide ? _c('div', {
    staticClass: "z-tree-childrens",
    class: 'deep-' + _vm.deep
  }, _vm._l(_vm.tree[_vm.childKey], function (d, index) {
    return _c('TreeContainer', {
      key: index,
      attrs: {
        "tree": d,
        "deep": _vm.deep + 1,
        "default-deep": _vm.defaultDeep
      },
      on: {
        "update": function ($event) {
          return _vm.$emit('update');
        }
      },
      scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
        return {
          key: name,
          fn: function (data) {
            return [_vm._t(name, null, null, data)];
          }
        };
      })], null, true)
    });
  }), 1) : _vm._e()]);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = function (inject) {
  if (!inject) return;
  inject("data-v-fe417c76_0", {
    source: ".z-tree-container[data-v-fe417c76]{flex:1 1 0px;width:auto;padding:0;margin:30px 15px;z-index:0}.z-tree-childrens[data-v-fe417c76],.z-tree-content[data-v-fe417c76]{display:flex;flex-direction:row;justify-content:center}.z-tree-childrens>.z-tree-container[data-v-fe417c76]:first-child{margin-left:0}.z-tree-childrens>.z-tree-container[data-v-fe417c76]:last-child{margin-right:0}.hide>.z-tree-childrens[data-v-fe417c76]{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$r = "data-v-fe417c76";
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, createInjector, undefined, undefined);

function signum(x) {
  return x < 0 ? -1 : 1;
}
/**
   * Build a tree graph
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/tree-graph)
   * @displayName TreeGraph
   * @author dcrespo
   * @since 0.7.11
   */


var script$q = {
  components: {
    TreeContainer: __vue_component__$x
  },
  props: {
    /**
     * An array of trees. Use the prop children[] (can be change with `childKey`)
     * to create a relation between objects.
     */
    tree: {
      type: Array,
      required: true
    },

    /**
     * Line color
     */
    color: {
      type: String,
      default: 'primary'
    },

    /**
     * Line width
     */
    strokeWidth: {
      type: String,
      default: '4px'
    },

    /**
     * Default deep. If it's 0 only shows the first element.
     */
    defaultDeep: {
      type: Number,
      default: null
    },

    /**
     * Use to change the key where it cointains the childrens of an object.
     */
    childKey: {
      type: String,
      default: 'children'
    }
  },
  computed: {
    compColor() {
      if (this.color.startsWith('#')) {
        return this.color;
      } else {
        return this.$vuetify.theme.defaults.light[this.color];
      }
    },

    pathStyleProp() {
      return {
        stroke: this.compColor,
        fill: 'none',
        strokeWidth: this.strokeWidth
      };
    }

  },
  watch: {
    tree() {
      this.build();
    }

  },

  provide() {
    return {
      childKey: this.childKey
    };
  },

  created() {
    this.rebuild = debounce(() => {
      this.build();
    }, 250);
    window.addEventListener('resize', this.rebuild);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.rebuild);
  },

  mounted() {
    this.build();
  },

  methods: {
    build() {
      this.$nextTick(() => {
        let deep = 0;
        const svg = this.$refs.svg;
        svg.removeAttribute('height');
        svg.removeAttribute('width');
        this.$refs.ztg.style.width = '100%';
        svg.replaceChildren(); // Remove all content

        this.calculateWidth();

        while (this.$refs.zTreeWrapper.querySelectorAll('.z-tree-container.deep-' + (deep + 1)).length > 0) {
          this.buildDeepLines(deep++);
        }

        const lastElement = this.$refs.zTreeWrapper.querySelector('.z-tree-content.deep-' + deep);
        this.$refs.ztg.style.height = lastElement.offsetHeight + lastElement.offsetTop + 'px';
      });
    },

    calculateWidth() {
      const elements = this.$refs.zTreeWrapper.querySelectorAll('.z-tree-content');
      let maxLeft = 0;
      let minLeft = 0;
      let minWidth = 0;
      let maxWidth = 0;

      for (const element of elements) {
        const offset = element.offsetLeft;

        if (offset > maxLeft) {
          maxLeft = offset;
          maxWidth = element.offsetWidth;
        }

        if (offset < minLeft) {
          minLeft = offset;
          minWidth = element.offsetWidth;
        }
      }

      minLeft -= minWidth;
      maxLeft += maxWidth;
      this.$refs.ztg.style.width = maxLeft - minLeft + 'px';
    },

    buildDeepLines(deep) {
      const parents = this.$refs.zTreeWrapper.querySelectorAll('.z-tree-container.deep-' + deep);

      for (const parent of parents) {
        const parentElement = parent.querySelector('.z-tree-content.deep-' + deep);
        const startXPoint = parentElement.offsetWidth / 2 + parentElement.offsetLeft;
        const startYPoint = parentElement.offsetHeight + parentElement.offsetTop;
        const childs = parent.querySelectorAll('.z-tree-container.deep-' + (deep + 1) + ' > .z-tree-content');

        for (const child of childs) {
          const endXPoint = child.offsetWidth / 2 + child.offsetLeft;
          const endYPoint = child.offsetTop;
          this.buildPath(startXPoint, startYPoint, endXPoint, endYPoint);
        }
      }
    },

    buildPath(startXPoint, startYPoint, endXPoint, endYPoint) {
      const svg = this.$refs.svg; // Resize svg if need it

      const stroke = parseInt(this.strokeWidth);

      if (svg.getAttribute('height') < endYPoint) {
        svg.setAttribute('height', endYPoint);
      }

      if (svg.getAttribute('width') < startXPoint + stroke) {
        svg.setAttribute('width', startXPoint + stroke);
      }

      if (svg.getAttribute('width') < endXPoint + stroke) {
        svg.setAttribute('width', endXPoint + stroke);
      }

      const deltaX = (endXPoint - startXPoint) * 0.15;
      const delta = deltaX === 0 ? 0 : 4.5; // deltaY < Math.abs(deltaX) ? deltaY : Math.abs(deltaX)
      // set sweep-flag (counter/clock-wise)
      // if start element is closer to the left edge,
      // draw the first arc counter-clockwise, and the second one clock-wise

      let arc1 = 0;
      let arc2 = 1;

      if (startXPoint > endXPoint) {
        arc1 = 1;
        arc2 = 0;
      }

      const d = `
        M ${startXPoint} ${startYPoint}
        V ${startYPoint + delta}
        A ${delta} ${delta} 0 0 ${arc1} ${startXPoint + delta * signum(deltaX)} ${startYPoint + 2 * delta}
        H ${endXPoint - delta * signum(deltaX)}
        A ${delta} ${delta} 0 0 ${arc2} ${endXPoint} ${startYPoint + 3 * delta}
        V ${endYPoint}
      `;
      const newElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      newElement.setAttribute('d', d);

      for (const key in this.pathStyleProp) {
        newElement.style[key] = this.pathStyleProp[key];
      } // DEBUG

      svg.appendChild(newElement);
    }

  }
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "zTreeWrapper",
    staticClass: "z-tree-wrapper"
  }, [_c('div', {
    ref: "ztg",
    staticClass: "z-tree-graph"
  }, [_c('div', {
    staticClass: "z-tree-svg-wrapper"
  }, [_c('svg', {
    ref: "svg",
    staticClass: "z-tree-svg"
  })]), _vm._v(" "), _vm._l(_vm.tree, function (d, index) {
    return _c('TreeContainer', {
      key: index,
      attrs: {
        "tree": d,
        "deep": 0,
        "default-deep": _vm.defaultDeep
      },
      on: {
        "update": _vm.build
      },
      scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
        return {
          key: name,
          fn: function (data) {
            return [_vm._t(name, null, null, data)];
          }
        };
      })], null, true)
    });
  })], 2)]);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = function (inject) {
  if (!inject) return;
  inject("data-v-b700246c_0", {
    source: ".z-tree-graph[data-v-b700246c]{width:100%;display:flex;justify-content:center;position:relative;z-index:1;overflow:hidden}.z-tree-svg-wrapper[data-v-b700246c]{position:absolute;width:100%}.z-tree-wrapper[data-v-b700246c]{width:100%;overflow-x:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$q = "data-v-b700246c";
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);

var __vue_component__$w = __vue_component__$v;

const booleanFalse = {
  type: Boolean,
  default: false
};
var AttrsBindingMixin = {
  props: {
    /** @ignore */
    dark: booleanFalse,

    /** @ignore */
    dense: booleanFalse,

    /** @ignore */
    filled: booleanFalse,

    /** @ignore */
    flat: booleanFalse,

    /** @ignore */
    light: booleanFalse,

    /** @ignore */
    outlined: booleanFalse,

    /** @ignore */
    rounded: booleanFalse,

    /** @ignore */
    shaped: booleanFalse,

    /** @ignore */
    solo: booleanFalse,

    /** @ignore */
    soloInverted: booleanFalse,

    /**
     * Timezone for datepicker inputs
     */
    timezone: {
      type: String,
      default: 'UTC'
    },

    /**
     * Dateformat for datepicker inputs
     */
    dateformat: {
      type: String,
      default: null
    },

    /**
    * Fields with "unique" options enabled. Unique option query all values from arcgis server
    */
    fieldsUnique: {
      type: Array,
      default: () => []
    },

    /**
     * Values loader. It must return a promise of a request
     * map url with the get parameters that are passed to the function
     * Only required if fieldsUnique prop is filled<br>
     * First parameter: endpoint. Second parameter: get parameters
     */
    valuesLoader: {
      type: Function,
      default: null
    },

    /**
     * Used to save Unique values into localStorage.
     * Usually it is the url of the layer
     */
    cacheKey: {
      type: String,
      default: null
    }
  },
  computed: {
    uniqueFieldsDataBinding() {
      return {
        fieldsUnique: this.fieldsUnique,
        valuesLoader: this.valuesLoader,
        cacheKey: this.cacheKey
      };
    },

    styleBinding() {
      return {
        dark: this.dark,
        dense: this.dense,
        filled: this.filled,
        flat: this.flat,
        light: this.light,
        outlined: this.outlined,
        rounded: this.rounded,
        shaped: this.shaped,
        solo: this.solo,
        soloInverted: this.soloInverted
      };
    },

    timepickerBinding() {
      return { ...this.styleBinding,
        timezone: this.timezone
      };
    },

    datepickerBinding() {
      return { ...this.styleBinding,
        timezone: this.timezone,
        dateformat: this.dateformat
      };
    },

    inputPropsBinding() {
      return { ...this.styleBinding,
        timezone: this.timezone,
        dateformat: this.dateformat
      };
    }

  }
};

var ComputedValueMixin = ((field, customname) => ({
  computed: {
    [customname || field]: {
      get() {
        return this.value[field];
      },

      set(val) {
        const value = { ...this.value,
          [field]: val
        };
        this.$emit('input', value);
      }

    }
  }
}));

const numericSorter = (a, b) => {
  return parseFloat(a) - parseFloat(b);
};

var script$p = {
  components: {
    VSelect: VSelect,
    VCol: VCol,
    VIcon: VIcon,
    VBtn: VBtn,
    VRow: VRow
  },
  mixins: [AttrsBindingMixin, i18n('FeaturesFilter')],
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    selectedField: {
      type: Object,
      default: null
    }
  },
  computed: {
    localStorageKey() {
      if (this.cacheKey) {
        return `${this.cacheKey}_${this.selectedField.name}`;
      } else {
        return null;
      }
    }

  },

  data() {
    return {
      uniqueValueItems: [],
      loading: true,
      canRefresh: true
    };
  },

  created() {
    if (!this.getFromLocalStorage()) {
      this.refresh();
    }
  },

  methods: {
    getFromLocalStorage() {
      if (this.localStorageKey) {
        const data = localStorage.getItem(this.localStorageKey);

        if (data) {
          try {
            const array = JSON.parse(data);
            this.uniqueValueItems = array;
            this.loading = false;
            return true;
          } catch (ex) {
            return false;
          }
        }
      }

      return false;
    },

    async refresh() {
      this.loading = true;
      const params = {
        f: 'json',
        returnGeometry: false,
        spatialRel: 'esriSpatialRelIntersects',
        outFields: '*',
        groupByFieldsForStatistics: this.selectedField.name,
        outStatistics: `[{"statisticType":"count","onStatisticField":"${this.selectedField.name}","outStatisticFieldName":"count"}]`
      };

      try {
        const result = await this.valuesLoader('query', params);

        if (Array.isArray(result.features)) {
          this.uniqueValueItems = result.features.map(f => f.attributes[this.selectedField.name]); // Alternative method
        } else if (result.error) {
          const params = {
            f: 'json',
            classificationDef: `{"type":"uniqueValueDef","uniqueValueFields":["${this.selectedField.name}"]}`
          };
          const resultAlt = await this.valuesLoader('generateRenderer', params);

          if (Array.isArray(resultAlt.uniqueValueInfos)) {
            this.uniqueValueItems = resultAlt.uniqueValueInfos.map(v => v.value);
          } else {
            console.error('[Zapan warn]: Bad response for unique values in alternative query', result);
            return;
          }
        } else {
          console.error('[Zapan warn]: Bad response for unique values', result);
          return;
        }

        if (this.selectedField.type === 'esriFieldTypeDouble' || this.selectedField.type === 'esriFieldTypeInteger') {
          this.uniqueValueItems.sort(numericSorter);
        } else {
          this.uniqueValueItems.sort();
        }

        if (this.localStorageKey) {
          localStorage.setItem(this.localStorageKey, JSON.stringify(this.uniqueValueItems));
        }
      } catch (ex) {
        console.error(ex);
      } finally {
        this.loading = false;
      }
    }

  }
};

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-row', {
    class: {
      canRefresh: _vm.canRefresh
    }
  }, [_c('v-col', {
    staticClass: "py-0 inputcol"
  }, [_c('v-select', _vm._b({
    attrs: {
      "value": _vm.value,
      "items": _vm.uniqueValueItems,
      "loading": _vm.loading,
      "label": _vm.t('uniqueValue'),
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-select', _vm.styleBinding, false))], 1), _vm._v(" "), _vm.canRefresh ? _c('v-col', {
    staticClass: "py-0 pl-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "refreshButton",
    on: {
      "click": _vm.refresh
    }
  }, [_c('v-icon', [_vm._v("\n        mdi-refresh\n      ")])], 1)], 1) : _vm._e()], 1);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = function (inject) {
  if (!inject) return;
  inject("data-v-13f07266_0", {
    source: ".canRefresh .inputcol[data-v-13f07266]{padding-right:0}.canRefresh .inputcol[data-v-13f07266]  .v-text-field--outlined,.canRefresh .inputcol[data-v-13f07266]  .v-text-field--solo{border-top-right-radius:0;border-bottom-right-radius:0}.canRefresh .refreshButton[data-v-13f07266]{border-top-left-radius:0;border-bottom-left-radius:0;height:calc(100% - 1px);padding:0 0;min-width:32px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$p = "data-v-13f07266";
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, createInjector, undefined, undefined);

const defaultExpression = {
  field: '',
  condition: '= {0}',
  valueType: 'value',
  value: '',
  valueExtra: ''
};
const defaultSet = {
  condition: 'AND',
  childrens: [defaultExpression]
};
const timeSelectorItems = [{
  name: 'minutes(s)',
  value: 1 / 24 / 60
}, {
  name: 'hours(s)',
  value: 1 / 24
}, {
  name: 'day(s)',
  value: 1
}, {
  name: 'weeks(s)',
  value: 7
}, {
  name: 'month(s)',
  value: 30
}, {
  name: 'year(s)',
  value: 365
}];
const is = [{
  text: 'is',
  value: '= {0}'
}, {
  text: 'is not',
  value: '<> {0}'
}];
const numberComparative = [{
  text: 'is at least',
  value: '>= {0}'
}, {
  text: 'is less than',
  value: '< {0}'
}, {
  text: 'is at most',
  value: '<= {0}'
}, {
  text: 'is greater than',
  value: '> {0}'
}];
const contains = [{
  text: 'starts with',
  value: "LIKE '{0}%'"
}, {
  text: 'ends with',
  value: "LIKE '%{0}'"
}, {
  text: 'contains',
  value: "LIKE '%{0}%'"
}, {
  text: 'not contains',
  value: "NOT LIKE '%{0}%'"
}];
const between = [{
  text: 'is between',
  value: 'BETWEEN {0} AND {1}'
}, {
  text: 'is not between',
  value: 'NOT BETWEEN {0} AND {1}'
}];
const isdate = [{
  text: 'is on',
  value: "BETWEEN timestamp '{0}' AND timestamp '{24H}'"
}, {
  text: 'is not on',
  value: "NOT BETWEEN timestamp '{0}' AND timestamp '{24H}'"
}];
const comparedate = [{
  text: 'is before',
  value: '< timestamp \'{0}\''
}, {
  text: 'is after',
  value: '> timestamp \'{0}\''
}, {
  text: 'in the last',
  value: 'BETWEEN CURRENT_TIMESTAMP - {0} AND CURRENT_TIMESTAMP'
}, // 0 time in days
{
  text: 'not in the last',
  value: 'NOT BETWEEN CURRENT_TIMESTAMP - {0} AND CURRENT_TIMESTAMP'
} // 0 time in days
];
const betweendate = [{
  text: 'is between',
  value: 'BETWEEN timestamp \'{0}\' AND timestamp \'{1}\''
}, {
  text: 'is not between',
  value: 'NOT BETWEEN timestamp \'{0}\' AND timestamp \'{1}\''
}];
const blank = [{
  text: 'is blank',
  value: 'IS NULL'
}, {
  text: 'is not blank',
  value: 'IS NOT NULL'
}];
function conditions(filter) {
  if (!filter) {
    return [];
  } // If domain only is and blank, With selectable.


  if (filter.domain !== null) {
    return [...is, ...blank];
  }

  if (filter.type === 'esriFieldTypeDate') {
    return [...isdate, ...comparedate, ...betweendate, ...blank];
  }

  if (filter.type === 'esriFieldTypeString') {
    return [...is, ...contains, ...blank];
  }

  if (filter.type === 'esriFieldTypeDouble' || filter.type === 'esriFieldTypeInteger') {
    return [...is, ...numberComparative, ...between, ...blank];
  } // DEFAULT


  return [...is, ...blank];
}

const compatibleFields = (a, b) => {
  if (a.type === b.type) return true;

  if (a.type === 'esriFieldTypeDouble' && b.type === 'esriFieldTypeInteger' || b.type === 'esriFieldTypeDouble' && a.type === 'esriFieldTypeInteger') {
    return true;
  }

  return false;
};

var script$o = {
  components: {
    UniqueInput: __vue_component__$u,
    VSelect: VSelect,
    VTextField: VTextField,
    VCol: VCol,
    VRow: VRow,
    VRadio: VRadio,
    VRadioGroup: VRadioGroup
  },
  mixins: [AttrsBindingMixin, i18n('FeaturesFilter')],
  props: {
    valueType: {
      type: String,
      required: true
    },
    condition: {
      type: String,
      required: true
    },
    expresionValue: {
      type: [String, Number],
      required: true
    },
    valueExtra: {
      type: [String, Number],
      required: true
    },
    selectedField: {
      type: Object,
      default: null
    }
  },
  computed: {
    uniqueEnabled() {
      if (this.selectedField) {
        return this.fieldsUnique.includes(this.selectedField.name);
      } else {
        return false;
      }
    },

    domainValuesItems() {
      if (this.selectedField && this.selectedField.domain && this.selectedField.domain.codedValues) {
        return this.selectedField.domain.codedValues;
      } else {
        return [];
      }
    },

    fieldsValueItems() {
      return this.fieldsItems.filter(f => f.name !== this.selectedField.name && compatibleFields(f, this.selectedField));
    },

    hasDomain() {
      if (this.selectedField) {
        return !!this.selectedField.domain;
      } else {
        return false;
      }
    },

    fieldIsNumber() {
      if (this.selectedField) {
        return this.selectedField.type === 'esriFieldTypeInteger' || this.selectedField.type === 'esriFieldTypeDouble';
      } else {
        return false;
      }
    },

    fieldIsDate() {
      if (this.selectedField) {
        return this.selectedField.type === 'esriFieldTypeDate';
      } else {
        return false;
      }
    },

    conditionIsRelativeTime() {
      return this.condition && this.condition.includes('CURRENT_TIMESTAMP');
    },

    conditionIsBlank() {
      return this.condition && this.condition.includes('NULL');
    },

    onlyValue() {
      if (this.conditionIsRelativeTime || this.condition.includes('{1}') || this.conditionIsBlank) {
        return true;
      }

      return false;
    },

    timeSelectorItems() {
      return timeSelectorItems;
    }

  },
  watch: {
    onlyValue(v) {
      if (v) {
        this.$emit('resetValues');
      }
    },

    selectedField() {
      this.$emit('resetValues');
    }

  }
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-col', [_c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_vm.valueType === 'field' ? _c('v-select', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "items": _vm.fieldsValueItems,
      "disabled": _vm.conditionIsBlank,
      "item-text": "alias",
      "item-value": "name",
      "label": _vm.t('fieldValue'),
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'v-select', _vm.styleBinding, false)) : _vm.hasDomain ? _c('v-select', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "items": _vm.domainValuesItems,
      "disabled": _vm.conditionIsBlank,
      "label": _vm.t('value'),
      "hide-details": "",
      "item-value": "code",
      "item-text": "name"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'v-select', _vm.styleBinding, false)) : _vm.fieldIsDate && _vm.conditionIsRelativeTime ? _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "label": _vm.t('value'),
      "type": "number",
      "min": "0",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'v-text-field', _vm.styleBinding, false))], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-select', _vm._b({
    attrs: {
      "value": _vm.valueExtra,
      "items": _vm.timeSelectorItems,
      "hide-details": "",
      "item-value": "value",
      "item-text": "name"
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:valueExtra', $event);
      }
    }
  }, 'v-select', _vm.styleBinding, false))], 1)], 1) : _vm.fieldIsDate ? _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('date-picker', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "disabled": _vm.conditionIsBlank,
      "label": _vm.t('date'),
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'date-picker', _vm.datepickerBinding, false))], 1), _vm._v(" "), _vm.condition.includes('{1}') ? [_c('v-col', {
    staticClass: "pa-0 d-flex align-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t('and')) + "\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-0"
  }, [_c('date-picker', _vm._b({
    attrs: {
      "value": _vm.valueExtra,
      "label": _vm.t('date'),
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:valueExtra', $event);
      }
    }
  }, 'date-picker', _vm.datepickerBinding, false))], 1)] : _vm._e()], 2) : _vm.valueType === 'unique' ? _c('UniqueInput', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "values-loader": _vm.valuesLoader,
      "selected-field": _vm.selectedField,
      "cache-key": _vm.cacheKey
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'UniqueInput', _vm.styleBinding, false)) : _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "value": _vm.expresionValue,
      "disabled": _vm.conditionIsBlank,
      "label": _vm.t('value'),
      "type": _vm.fieldIsNumber ? 'number' : 'text',
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:expresionValue', $event);
      }
    }
  }, 'v-text-field', _vm.styleBinding, false))], 1), _vm._v(" "), _vm.condition.includes('{1}') ? [_c('v-col', {
    staticClass: "pa-0 d-flex align-center",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.t('and')) + "\n          ")]), _vm._v(" "), _c('v-col', {
    staticClass: "py-0"
  }, [_vm.valueType == 'value' ? _c('v-text-field', _vm._b({
    attrs: {
      "type": _vm.fieldIsNumber ? 'number' : 'text',
      "value": _vm.valueExtra,
      "label": _vm.t('value'),
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('update:valueExtra', $event);
      }
    }
  }, 'v-text-field', _vm.styleBinding, false)) : _vm._e()], 1)] : _vm._e()], 2)], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "value": _vm.valueType,
      "disabled": _vm.onlyValue,
      "hide-details": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('update:valueType', $event);
      }
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.t('value'),
      "value": "value"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": _vm.t('field'),
      "value": "field"
    }
  }), _vm._v(" "), _vm.uniqueEnabled ? _c('v-radio', {
    attrs: {
      "label": _vm.t('unique'),
      "value": "unique"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = undefined;
/* scoped */

const __vue_scope_id__$o = "data-v-42d74bb4";
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

class QueryBuilder {
  // esri date format
  constructor(layerData, timezone) {
    _defineProperty(this, "DATE_FORMAT", 'yyyy-MM-dd HH:mm:ss');

    _defineProperty(this, "layerData", void 0);

    _defineProperty(this, "timezone", void 0);

    this.layerData = layerData;
    this.timezone = timezone || 'UTC';
  }

  queryBuilder(param) {
    if (Object.prototype.hasOwnProperty.call(param, 'childrens')) {
      const expressions = param.childrens.map(c => this.queryBuilder(c, this.layerData)).filter(c => !!c && c !== '()');
      return `(${expressions.join(` ${param.condition} `)})`;
    } else {
      if (QueryBuilder.isValidExpression(param)) {
        return this.buildExpression(param);
      }
    }
  }

  buildExpression(param) {
    const fieldInfo = this.layerData.fields.find(f => f.name === param.field);

    if (param.valueType === 'field') {
      return this.buildExpressionField(param);
    } else if (fieldInfo.type === 'esriFieldTypeDate') {
      if (param.condition.includes('CURRENT_TIMESTAMP')) {
        return this.buildExpressionDateRelative(param);
      } else {
        return this.buildExpressionDate(param);
      }
    } else if (fieldInfo.type === 'esriFieldTypeString') {
      return this.buildExpressionString(param);
    } else if (fieldInfo.type === 'esriFieldTypeDouble') {
      return this.buildExpressionDouble(param);
    } else if (fieldInfo.type === 'esriFieldTypeInteger') {
      return this.buildExpressionInteger(param);
    } // TODO
    // esriFieldTypeGlobalID
    // esriFieldTypeOID

  }

  buildExpressionField(param) {
    return `(${param.field} ${formatString(param.condition, param.value, param.extra)})`;
  }

  buildExpressionDateRelative(param) {
    let value = param.value;
    const extra = param.valueExtra;
    const condition = param.condition;
    value = value * extra;
    return `(${param.field} ${formatString(condition, value, extra)})`;
  }

  buildExpressionDate(param) {
    let value = param.value;
    let extra = param.valueExtra;
    let condition = param.condition;
    const valueObject = new TimezonedDateTime(this.timezone);
    valueObject.setUTC(value);
    value = valueObject.format(this.DATE_FORMAT);

    if (extra) {
      const extraObject = new TimezonedDateTime(this.timezone);
      extraObject.setUTC(extra);
      extra = extraObject.format(this.DATE_FORMAT);
    }

    if (condition.includes('{24H}')) {
      const next24h = add(new Date(valueObject.toString()), {
        hours: 23,
        minutes: 59,
        seconds: 59
      }).toISOString();
      const next24hObj = new TimezonedDateTime(this.timezone);
      next24hObj.setUTC(next24h);
      const formatted24h = next24hObj.format(this.DATE_FORMAT);
      condition = condition.replace('{24H}', formatted24h);
    }

    return `(${param.field} ${formatString(condition, value, extra)})`;
  }

  buildExpressionString(param) {
    let value = param.value;
    let extra = param.valueExtra;
    const condition = param.condition; // Avoid Like because condition string includes ''

    if (!condition.includes('LIKE')) {
      value = `'${value}'`;
      extra = `'${extra}'`;
    }

    return `(${param.field} ${formatString(condition, value, extra)})`;
  }

  buildExpressionDouble(param) {
    let value = param.value;
    let extra = param.valueExtra;
    const condition = param.condition;
    value = parseFloat(value);
    extra = parseFloat(extra);
    return `(${param.field} ${formatString(condition, value, extra)})`;
  }

  buildExpressionInteger(param) {
    let value = param.value;
    let extra = param.valueExtra;
    const condition = param.condition;
    value = parseInt(value);
    extra = parseInt(extra);
    return `(${param.field} ${formatString(condition, value, extra)})`;
  }

}

_defineProperty(QueryBuilder, "isValidExpression", param => {
  const extraRequiredIncludes = ['{1}', 'CURRENT_TIMESTAMP'];
  const basicValid = param.field && param.condition;
  let valueValid = false;

  if (param.condition.includes('NULL')) {
    valueValid = true;
  } else if (param.value) {
    valueValid = true;
  }

  let extraValid = true;

  if (param.condition && extraRequiredIncludes.some(v => param.condition.includes(v))) {
    extraValid = !!param.valueExtra;
  }

  return !!(basicValid && valueValid && extraValid);
});

_defineProperty(QueryBuilder, "isValidTree", elem => {
  if (Object.prototype.hasOwnProperty.call(elem, 'childrens')) {
    return elem.childrens.map(c => QueryBuilder.isValidTree(c)).every(v => v);
  } else {
    return QueryBuilder.isValidExpression(elem);
  }
});

var script$n = {
  directives: {
    ClickOutside: ClickOutside
  },
  components: {
    ExpressionInput: __vue_component__$t,
    VSelect: VSelect,
    VCol: VCol,
    VIcon: VIcon,
    VBtn: VBtn,
    VRow: VRow
  },
  mixins: [AttrsBindingMixin, ComputedValueMixin('field'), ComputedValueMixin('condition'), ComputedValueMixin('valueType'), ComputedValueMixin('value', 'expresionValue'), ComputedValueMixin('valueExtra'), i18n('FeaturesFilter')],
  props: {
    value: {
      type: Object,
      required: true
    },
    fieldsItems: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      checkErrorValue: false,
      changeErrorTime: 0
    };
  },

  computed: {
    checkError: {
      get() {
        return this.checkErrorValue;
      },

      set(val) {
        const time = new Date().getTime();

        if (this.changeErrorTime + 500 < time) {
          this.checkErrorValue = val;
        }
      }

    },

    selectedField() {
      if (this.value.field) {
        return this.fieldsItems.find(f => f.name === this.value.field);
      } else {
        return null;
      }
    },

    conditions() {
      return conditions(this.selectedField);
    },

    isValid() {
      return QueryBuilder.isValidExpression(this.value);
    }

  },
  watch: {
    valueType() {
      this.expresionValue = '';
      this.valueExtra = '';
    },

    value() {
      this.checkError = false;
      this.changeErrorTime = new Date().getTime();
    }

  },
  methods: {
    setCheckErrorTrue() {
      this.checkError = true;
    }

  }
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-row', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.setCheckErrorTrue,
      expression: "setCheckErrorTrue"
    }]
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "label": _vm.t('field'),
      "items": _vm.fieldsItems,
      "autofocus": "",
      "item-text": "alias",
      "item-value": "name"
    },
    on: {
      "focus": function ($event) {
        _vm.checkError = false;
      }
    },
    model: {
      value: _vm.field,
      callback: function ($$v) {
        _vm.field = $$v;
      },
      expression: "field"
    }
  }, 'v-select', _vm.styleBinding, false))], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-select', _vm._b({
    staticClass: "condition-select",
    attrs: {
      "items": _vm.conditions,
      "label": _vm.t('condition'),
      "item-value": "value",
      "item-text": "text"
    },
    on: {
      "focus": function ($event) {
        _vm.checkError = false;
      }
    },
    model: {
      value: _vm.condition,
      callback: function ($$v) {
        _vm.condition = $$v;
      },
      expression: "condition"
    }
  }, 'v-select', _vm.styleBinding, false))], 1), _vm._v(" "), _c('ExpressionInput', _vm._b({
    attrs: {
      "value-type": _vm.valueType,
      "expresion-value": _vm.expresionValue,
      "value-extra": _vm.valueExtra,
      "condition": _vm.condition,
      "selected-field": _vm.selectedField,
      "fields-items": _vm.fieldsItems
    },
    on: {
      "update:valueType": function ($event) {
        _vm.valueType = $event;
      },
      "update:value-type": function ($event) {
        _vm.valueType = $event;
      },
      "update:expresionValue": function ($event) {
        _vm.expresionValue = $event;
      },
      "update:expresion-value": function ($event) {
        _vm.expresionValue = $event;
      },
      "update:valueExtra": function ($event) {
        _vm.valueExtra = $event;
      },
      "update:value-extra": function ($event) {
        _vm.valueExtra = $event;
      },
      "resetValues": function ($event) {
        return _vm.$emit('resetValues');
      },
      "focus": function ($event) {
        _vm.checkError = false;
      }
    }
  }, 'ExpressionInput', Object.assign({}, _vm.uniqueFieldsDataBinding, _vm.inputPropsBinding), false)), _vm._v(" "), _vm.checkError && !_vm.isValid ? _c('v-col', {
    staticClass: "px-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-icon', {
    staticClass: "mt-4",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("\n      mdi-alert\n    ")])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('remove');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-112f791a_0", {
    source: ".condition-select[data-v-112f791a]{width:168px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$n = "data-v-112f791a";
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

var script$m = {
  name: 'FilterSet',
  components: {
    FilterExpressionBuilder: __vue_component__$s,
    VSelect: VSelect,
    VCol: VCol,
    VBtn: VBtn,
    VRow: VRow,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [AttrsBindingMixin, ComputedValueMixin('condition'), i18n('FeaturesFilter')],
  props: {
    value: {
      type: Object,
      required: true
    },
    fieldsItems: {
      type: Array,
      required: true
    },
    first: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    conditionValues() {
      return [{
        value: 'AND',
        text: 'and'
      }, {
        value: 'OR',
        text: 'or'
      }];
    }

  },
  methods: {
    updateChildrens(valueChildrens) {
      this.$emit('input', { ...this.value,
        childrens: valueChildrens
      });
    },

    addExpression() {
      const valueChildrens = [...this.value.childrens];
      valueChildrens.push(cloneDeep(defaultExpression));
      this.updateChildrens(valueChildrens);
    },

    addSet() {
      const valueChildrens = [...this.value.childrens];
      valueChildrens.push(cloneDeep(defaultSet));
      this.updateChildrens(valueChildrens);
    },

    updateItem(item, index) {
      const valueChildrens = [...this.value.childrens];

      if (item.childrens && item.childrens.length === 0) {
        return;
      }

      valueChildrens[index] = item;
      this.updateChildrens(valueChildrens);
    },

    resetValuesItem(index) {
      const valueChildrens = [...this.value.childrens];
      const expresion = { ...defaultExpression
      };

      if (valueChildrens[index]) {
        expresion.field = valueChildrens[index].field;
        expresion.condition = valueChildrens[index].condition;
      }

      valueChildrens[index] = expresion;
      this.updateChildrens(valueChildrens);
    },

    removeIndex(index) {
      const valueChildrens = [...this.value.childrens];
      valueChildrens.splice(index, 1);

      if (valueChildrens.length === 0) {
        this.$emit('remove');
      }

      this.updateChildrens(valueChildrens);
    }

  }
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "filterset",
    class: {
      first: _vm.first
    },
    attrs: {
      "width": "100%",
      "elevation": "0"
    }
  }, [_c('v-card-text', {
    staticClass: "filterset-text"
  }, [_c('v-row', {
    staticClass: "d-flex justify-space-between"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.conditionValues,
      "item-value": "value",
      "item-text": "text",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.condition,
      callback: function ($$v) {
        _vm.condition = $$v;
      },
      expression: "condition"
    }
  }, 'v-select', _vm.inputPropsBinding, false))], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.addExpression
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('addExpression')) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.addSet
    }
  }, [_vm._v("\n          " + _vm._s(_vm.t('addASet')) + "\n        ")])], 1)], 1), _vm._v(" "), _vm._l(_vm.value.childrens, function (item, index) {
    return [item.field !== undefined ? _c('FilterExpressionBuilder', _vm._b({
      key: 'exp' + index,
      attrs: {
        "value": item,
        "fields-items": _vm.fieldsItems
      },
      on: {
        "input": function ($event) {
          return _vm.updateItem($event, index);
        },
        "resetValues": function ($event) {
          return _vm.resetValuesItem(index);
        },
        "remove": function ($event) {
          return _vm.removeIndex(index);
        }
      }
    }, 'FilterExpressionBuilder', Object.assign({}, _vm.inputPropsBinding, _vm.uniqueFieldsDataBinding), false)) : _vm._e(), _vm._v(" "), item.childrens !== undefined ? _c('FilterSet', _vm._b({
      key: 'set' + index,
      attrs: {
        "value": item,
        "fields-items": _vm.fieldsItems
      },
      on: {
        "input": function ($event) {
          return _vm.updateItem($event, index);
        },
        "remove": function ($event) {
          return _vm.removeIndex(index);
        }
      }
    }, 'FilterSet', Object.assign({}, _vm.inputPropsBinding, _vm.uniqueFieldsDataBinding), false)) : _vm._e()];
  })], 2)], 1);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = function (inject) {
  if (!inject) return;
  inject("data-v-57b9a57d_0", {
    source: ".filterset[data-v-57b9a57d]:not(.first){margin-left:8px;border-left:1px solid #999;border-radius:0}.filterset-text[data-v-57b9a57d]{padding-bottom:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$m = "data-v-57b9a57d";
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

/**
   * Features query builder for maps.
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/features-filter)
   * @displayName FeaturesFilter
   * @author dcrespo
   * @since 0.7.1
   */

var script$l = {
  components: {
    FilterSet: __vue_component__$r,
    VProgressCircular: VProgressCircular,
    VCardText: VCardText,
    VCard: VCard
  },
  mixins: [AttrsBindingMixin],
  props: {
    /**
     * Filter object tree. [More info](#filterobject)
     */
    value: {
      type: Object,
      default: null
    },

    /**
     * Layer data from geoserver. Is obtained with `?f=pjson`
     */
    layerData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      localValue: null
    };
  },

  created() {
    if (!this.localValueComp || Array.isArray(this.localValueComp) && this.localValueComp.length === 0) {
      this.localValueComp = cloneDeep(defaultSet);
    }

    if (Array.isArray(this.layerData) && this.layerData.length > 0 && !this.valuesLoader) {
      console.warn('[Zapan warn]: valuesLoader is null.');
    }
  },

  computed: {
    localValueComp: {
      get() {
        if (this.value) {
          return this.value;
        } else {
          return this.localValue;
        }
      },

      set(v) {
        this.localValue = v;
        /**
         * (v-model) Return filter tree
         * @property {object} value
         */

        this.$emit('input', v);
        const valid = QueryBuilder.isValidTree(v);
        /**
         * true if all expressions are valid
         * @property {boolean} valid
         */

        this.$emit('valid', valid);
      }

    },

    fieldsItems() {
      const fields = this.layerData ? this.layerData.fields || [] : [];
      return fields.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    },

    result() {
      if (this.localValueComp && this.localValueComp.childrens) {
        let result = this.buildQuery(this.localValueComp);
        result = result.slice(1, -1); // Remove parentesis from parent set

        if (this.localValueComp.childrens.filter(e => QueryBuilder.isValidExpression(e) || e.childrens && e.childrens.length > 0).length === 1) {
          // Remove parentesis if only one expression
          result = result.slice(1, -1);
        }

        return result;
      } else {
        return '';
      }
    }

  },
  watch: {
    result: {
      immediate: true,

      handler(val) {
        /**
         * Return the geoserver where.<br>
         * If you use a FeatureServer use ?where=RESULT<br>
         * If you use a MapServer use ?layerDefs={"0":"RESULT"}
         * @property {string} value
         */
        this.$emit('result', val);
      }

    }
  },
  methods: {
    buildQuery(param) {
      const queryBuilder = new QueryBuilder(this.layerData, this.timezone);
      return queryBuilder.queryBuilder(param);
    }

  }
};

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.localValueComp && _vm.layerData ? _c('FilterSet', _vm._b({
    attrs: {
      "fields-items": _vm.fieldsItems,
      "first": ""
    },
    model: {
      value: _vm.localValueComp,
      callback: function ($$v) {
        _vm.localValueComp = $$v;
      },
      expression: "localValueComp"
    }
  }, 'FilterSet', Object.assign({}, _vm.inputPropsBinding, _vm.uniqueFieldsDataBinding), false)) : _c('v-card', {
    staticStyle: {
      "height": "242px"
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm._t("nodata", function () {
    return [_c('v-progress-circular', {
      attrs: {
        "indeterminate": ""
      }
    })];
  })], 2)], 1)], 1);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = "data-v-2964168e";
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

var __vue_component__$q = __vue_component__$p;

var script$k = {
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  inject: ['timeZone', 'timeFormat'],
  computed: {
    value() {
      if (this.field.DataType === 'DateTime') {
        const timeZonedObj = new TimezonedDateTime(this.timeZone);
        timeZonedObj.setUTC(utcVal(this.field.Value));
        return timeZonedObj.format(this.timeFormat);
      } else if (this.field.DataType === 'bool') {
        return this.field.Value ? 'Yes' : 'No';
      } else if (isNullUndefinedOrEmptyString(this.field.Value)) {
        return null;
      } else {
        return this.field.Value;
      }
    }

  }
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('InfoChip', {
    attrs: {
      "label": _vm.field.DisplayName || _vm.field.Name,
      "text": _vm.value
    }
  });
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = "data-v-c3184684";
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

var script$j = {
  components: {
    EntityValue: __vue_component__$o,
    VCol: VCol,
    VRow: VRow,
    VCardText: VCardText,
    VCard: VCard
  },
  props: {
    selected: {
      type: Boolean,
      required: true
    },
    values: {
      type: Object,
      // values are inside Columns.value
      required: true
    }
  },
  computed: {
    fields() {
      return this.values.Fields;
    }

  }
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-card', {
    staticClass: "card-entity",
    class: {
      selected: _vm.selected
    },
    attrs: {
      "ripple": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('v-card-text', [_c('v-row', _vm._l(_vm.fields, function (field, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6"
      }
    }, [_c('EntityValue', {
      attrs: {
        "field": field
      }
    })], 1);
  }), 1)], 1)], 1);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = function (inject) {
  if (!inject) return;
  inject("data-v-fdbad792_0", {
    source: ".card-entity[data-v-fdbad792]{box-sizing:border-box;border:4px solid transparent;transition:border-color .3s ease}.card-entity.selected[data-v-fdbad792]{border-color:var(--v-primary-base,#1976d2)!important;background-color:#eceff1!important}.card-entity[data-v-fdbad792]:focus:before{opacity:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$j = "data-v-fdbad792";
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var script$i = {
  components: {
    CardEntity: __vue_component__$n,
    VCol: VCol,
    VRow: VRow
  },
  props: {
    values: {
      type: Array,
      required: true
    },
    schema: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      selected: []
    };
  },

  computed: {
    valid() {
      return true; // TODO => this.selected.length > 0
    }

  },
  methods: {
    selectUnselect(id) {
      if (!this.multiple && this.selected.includes(id)) {
        this.selected = [];
      } else if (!this.multiple) {
        this.selected = [id];
      } else if (this.selected.includes(id)) {
        const index = this.selected.indexOf(id);
        if (index > -1) this.selected.splice(index, 1);
      } else {
        this.selected.push(id);
      }

      const allValues = [];

      for (const i of this.selected) {
        const valueSelected = this.values[i];
        allValues.push(valueSelected);
      }

      this.$emit('input', allValues);
    }

  }
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "entity-merge-wrapper"
  }, [_c('div', {
    staticClass: "entity-merge-data"
  }, [_c('v-row', _vm._l(_vm.values, function (value, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6"
      }
    }, [_c('CardEntity', {
      attrs: {
        "selected": _vm.selected.includes(index),
        "values": value
      },
      on: {
        "click": function ($event) {
          return _vm.selectUnselect(index);
        }
      }
    })], 1);
  }), 1)], 1), _vm._v(" "), _vm._t("default", null, {
    "valid": _vm.valid
  })], 2);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = "data-v-07838548";
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

var script$h = {
  components: {
    VCol: VCol,
    VRow: VRow
  },
  mixins: [i18n('PersonMerge')]
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-row', [_c('v-col', [_vm._v("\n      " + _vm._s(_vm.t('confirm')) + "\n    ")])], 1), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = "data-v-0d2f9890";
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

const getTablesByName = (data, schema, table, column) => {
  try {
    const schemeData = data.find(d => d.Name === schema);
    const tablesData = schemeData.Items.filter(t => t.Name === table);
    return tablesData;
  } catch (ex) {
    console.error('Data not found', {
      schema,
      table,
      column
    });
    return undefined;
  }
};

var script$g = {
  mixins: [i18n('PersonMerge')],
  components: {
    EntityMerge: __vue_component__$m,
    ConfirmMerge: __vue_component__$l,
    VStepperStep: VStepperStep,
    VDivider: VDivider,
    VBtn: VBtn,
    VCol: VCol,
    VRow: VRow,
    VStepperContent: VStepperContent,
    VStepperItems: VStepperItems,
    VStepper: VStepper
  },
  props: {
    /**
     * Array of person tablereferences.
     */
    persons: {
      type: Array,
      required: true
    },

    /**
     * Timezone to display datetimes. (Prop not reactive)
     */
    timeZone: {
      type: String,
      default: 'UTC'
    },

    /**
     * Time format to display dates. (Prop not reactive)
     */
    timeFormat: {
      type: String,
      default: 'yyyy-MM-dd hh:mm'
    }
  },

  provide() {
    return {
      timeZone: this.timeZone,
      timeFormat: this.timeFormat
    };
  },

  data() {
    return {
      step: 1,
      selected: {}
    };
  },

  computed: {
    steps() {
      const entities = [];
      const tableFound = [];

      for (const sch of this.persons[0]) {
        const schemaName = sch.Name; // const schemaDisplayName = sch.DisplayName

        for (const table of sch.Items) {
          const tableName = table.Name;

          if (!tableFound.includes(tableName)) {
            tableFound.push(tableName);
            const allTables = [];

            for (const person of this.persons) {
              const tables = getTablesByName(person, schemaName, tableName);
              allTables.push(...tables);
            }

            entities.push({
              DisplayName: table.DisplayName || table.Name,
              Name: table.Name,
              Schema: schemaName,
              Values: allTables
            });
          }
        }
      }

      return entities;
    }

  },
  methods: {
    next() {
      this.step++;
    },

    back() {
      this.step--;
    },

    setSelected(schema, table, selectedEntities) {
      if (!this.selected[schema]) {
        this.selected[schema] = {};
      }

      this.selected[schema][table] = selectedEntities;
    },

    finish() {
      console.log('FINISH');
    }

  }
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-stepper', {
    staticClass: "person-merge-stepper",
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('ScrollableStepHeader', {
    ref: "stepperHeader",
    staticClass: "person-merge-stepper-header",
    attrs: {
      "value": _vm.step
    }
  }, [_vm._l(_vm.steps, function (st, index) {
    return [_c('v-stepper-step', {
      key: index + 'step',
      attrs: {
        "complete": _vm.step > index + 1,
        "step": index + 1
      }
    }, [_vm._v("\n        " + _vm._s(st.DisplayName) + "\n      ")]), _vm._v(" "), _c('v-divider', {
      key: index + 'divider'
    })];
  }), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > _vm.steps.length + 1,
      "step": _vm.steps.length + 1
    }
  }, [_vm._v("\n      " + _vm._s(_vm.t('summary')) + "\n    ")])], 2), _vm._v(" "), _c('v-stepper-items', {
    staticClass: "person-merge-stepper-items"
  }, [_vm._l(_vm.steps, function (st, index) {
    return _c('v-stepper-content', {
      key: index,
      staticClass: "person-merge-stepper-content",
      attrs: {
        "step": index + 1
      }
    }, [_c('EntityMerge', {
      attrs: {
        "values": st.Values,
        "schema": st.Schema,
        "multiple": st.Values.length > 2
      },
      on: {
        "input": function ($event) {
          return _vm.setSelected(st.Schema, st.Name, $event);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (ref) {
          var valid = ref.valid;
          return [_c('v-row', {
            staticClass: "justify-end entity-merge-footer"
          }, [_c('v-col', {
            attrs: {
              "cols": "auto"
            }
          }, [_c('v-btn', {
            on: {
              "click": function ($event) {
                return _vm.$emit('cancel');
              }
            }
          }, [_vm._v("\n                " + _vm._s(_vm.t('cancel')) + "\n              ")])], 1), _vm._v(" "), _vm.step > 1 ? _c('v-col', {
            attrs: {
              "cols": "auto"
            }
          }, [_c('v-btn', {
            attrs: {
              "color": "primary"
            },
            on: {
              "click": _vm.back
            }
          }, [_vm._v("\n                " + _vm._s(_vm.t('back')) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
            attrs: {
              "cols": "auto"
            }
          }, [_c('v-btn', {
            attrs: {
              "disabled": !valid,
              "color": "primary"
            },
            on: {
              "click": _vm.next
            }
          }, [_vm._v("\n                " + _vm._s(_vm.t('next')) + "\n              ")])], 1)], 1)];
        }
      }], null, true)
    })], 1);
  }), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": _vm.steps.length + 1
    }
  }, [_c('ConfirmMerge', [_c('v-row', {
    staticClass: "justify-end entity-merge-footer"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('cancel')) + "\n            ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('back')) + "\n            ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("\n              " + _vm._s(_vm.t('finish')) + "\n            ")])], 1)], 1)], 1)], 1)], 2)], 1);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = function (inject) {
  if (!inject) return;
  inject("data-v-43722672_0", {
    source: ".person-merge-stepper[data-v-43722672]{height:100%;display:flex;flex-direction:column}.entity-merge-footer[data-v-43722672],.person-merge-stepper-header[data-v-43722672]{flex-grow:0;flex-shrink:0}.person-merge-stepper-items[data-v-43722672]{flex-grow:1;flex-shrink:1}.person-merge-stepper-content[data-v-43722672]{height:100%;padding:3px 0 0 0}.person-merge-stepper-content[data-v-43722672]  .v-stepper__wrapper{height:100%}.person-merge-stepper-content[data-v-43722672]  .entity-merge-data{padding:21px 24px 0 24px}.person-merge-stepper-content[data-v-43722672]  .entity-merge-footer{padding:0 24px}.person-merge-stepper-content[data-v-43722672]  .entity-merge-wrapper{display:flex;flex-direction:column;height:100%;overflow:hidden}.person-merge-stepper-content[data-v-43722672]  .entity-merge-data{flex-grow:1;overflow-y:auto;flex-shrink:1;overflow-x:hidden}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$g = "data-v-43722672";
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var __vue_component__$k = __vue_component__$j;

//
//
//
//
//
//
//
//
//

const getPreviousSibling = function (elem, selector) {
  let sibling = elem.previousElementSibling;
  if (!selector) return sibling;

  while (sibling) {
    if (sibling.matches(selector)) return sibling;
    sibling = sibling.previousElementSibling;
  }
};
/**
   * Horizontal [v-stepper-header](https://vuetifyjs.com/en/components/steppers/)
   * that allows many values because it scrolls in a single line
   *
   * [Check in Playground (in Person Merge demo)](https://sandbox.technosylva.com/zapanplayground/person-merge)
   * @displayName ScrollableStepHeader
   * @author dcrespo
   * @since 0.7.8
   */


var script$f = {
  components: {
    VStepperHeader: VStepperHeader
  },
  props: {
    /**
     * The step count, same `v-stepper` value
     */
    value: {
      type: Number,
      required: true
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        this.setStepperHeaderPosition();
      });
    }

  },
  methods: {
    setStepperHeaderPosition() {
      const element = this.$refs.stepperHeader;
      let focusStep;

      for (const slotElement of this.$slots.default) {
        // eslint-disable-next-line eqeqeq
        if (slotElement.componentInstance && slotElement.componentInstance.step == this.value) {
          focusStep = slotElement.elm;
          break;
        }
      }

      if (!focusStep) {
        console.error('[Zapan Warn]: Wrong step value');
      } else {
        const prev = getPreviousSibling(focusStep, '.v-stepper__step');
        let value = 0;

        if (prev) {
          value = prev.offsetLeft;
        }

        const stepperWidth = element.offsetWidth;
        const lastOne = element.querySelector('.v-stepper__step:last-child');
        const lastOnePosition = lastOne.offsetLeft;
        const lastOneWidth = lastOne.offsetWidth;
        const limit = lastOnePosition - stepperWidth + lastOneWidth;

        if (value > limit) {
          value = limit;
        }

        for (const child of element.children) {
          child.style.transform = `translateX(-${value}px)`;
        }
      }
    }

  }
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-stepper-header', {
    ref: "stepperHeader",
    staticClass: "scrollable-stepper"
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = function (inject) {
  if (!inject) return;
  inject("data-v-31deadbf_0", {
    source: ".scrollable-stepper[data-v-31deadbf]{flex-wrap:nowrap;--desplace:0px}.scrollable-stepper[data-v-31deadbf]  .v-divider{min-width:36px}.scrollable-stepper[data-v-31deadbf]  .v-divider,.scrollable-stepper[data-v-31deadbf]  .v-stepper__step{transform:translateX(var(--desplace,0));transition:transform .3s ease}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$f = "data-v-31deadbf";
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

var __vue_component__$i = __vue_component__$h;

var downloadValues = {
  props: {
    downloadValues: {
      type: Function,
      default: () => f => f
    },
    items: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      loading: false,
      itemsDownloaded: []
    };
  },

  computed: {
    myItems() {
      if (this.items === '' && this.url === '') {
        console.error('[Zapan Warn]: No values or valuesUrl defined for field ' + this.field.Name);
        return [];
      }

      if (this.url !== '') {
        return this.itemsDownloaded;
      }

      return this.items.split('|');
    }

  },

  async mounted() {
    if (this.url !== '') {
      this.loading = true;
      this.itemsDownloaded = await this.downloadValues(this.url);
      this.loading = false;
    }
  }

};

var script$e = {
  components: {
    VSelect: VSelect
  },
  mixins: [downloadValues],
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', _vm._b({
    attrs: {
      "value": _vm.value,
      "items": _vm.myItems,
      "item-text": "DisplayName",
      "item-value": "Id",
      "label": _vm.label,
      "clearable": !_vm.isRequired,
      "loading": _vm.loading
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-select', _vm.$attrs, false));
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = "data-v-c714989e";
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

var script$d = {
  components: {
    VSelect: VSelect
  },
  mixins: [downloadValues],
  props: {
    value: {
      type: String,
      default: '[]'
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedValue() {
      try {
        return JSON.parse(this.value);
      } catch (ex) {
        console.error(`[Zapan warn]: Wrong value for input ${this.label}. Value: ${this.value}`);
        return [];
      }
    }

  },
  methods: {
    emit(data) {
      this.$emit('input', JSON.stringify(data));
    }

  }
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', _vm._b({
    attrs: {
      "value": _vm.parsedValue,
      "items": _vm.myItems,
      "item-text": "DisplayName",
      "item-value": "Id",
      "label": _vm.label,
      "multiple": "",
      "clearable": !_vm.isRequired
    },
    on: {
      "input": _vm.emit
    }
  }, 'v-select', _vm.$attrs, false));
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = "data-v-527a1d91";
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//

var script$c = {
  components: {
    VTextarea: VTextarea
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  }
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-textarea', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-textarea', _vm.$attrs, false));
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = "data-v-06002cee";
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
//
//
//
//
//
//

var script$b = {
  components: {
    VCheckbox: VCheckbox
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  }
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-checkbox', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-checkbox', _vm.$attrs, false));
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = "data-v-2c1d4951";
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//

var script$a = {
  components: {
    VTextField: VTextField
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  }
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-text-field', _vm.$attrs, false));
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = "data-v-5c619e04";
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

var script$9 = {
  components: {
    VTextField: VTextField
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  },
  computed: {
    step() {
      if (this.field.DataType === 'double') {
        return 0.1;
      }

      return 1;
    }

  },
  methods: {
    input(event) {
      if (isNullUndefinedOrEmptyString(event)) {
        this.$emit('input', null);
      } else {
        this.$emit('input', parseFloat(event));
      }
    }

  }
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-text-field', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "step": _vm.step,
      "type": "number"
    },
    on: {
      "input": _vm.input
    }
  }, 'v-text-field', _vm.$attrs, false));
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = "data-v-730bb990";
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

var script$8 = {
  components: {
    DatePicker: __vue_component__$16,
    TimePicker: __vue_component__$15,
    VCol: VCol,
    VRow: VRow
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    labelDate() {
      return this.label.trim() + ' Date';
    },

    labelTime() {
      return this.label.trim() + ' Time';
    }

  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-row', [_c('v-col', {
    staticClass: "py-0"
  }, [_c('DatePicker', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.labelDate
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'DatePicker', _vm.$attrs, false))], 1), _vm._v(" "), _c('v-col', {
    staticClass: "py-0"
  }, [_c('TimePicker', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.labelTime
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'TimePicker', _vm.$attrs, false))], 1)], 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = "data-v-4247523a";
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

var script$7 = {
  components: {
    DatePicker: __vue_component__$16
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  }
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('DatePicker', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'DatePicker', _vm.$attrs, false));
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = "data-v-d1dff312";
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//

var script$6 = {
  components: {
    VSelect: VSelect
  },
  props: {
    items: {
      type: String,
      default: () => 'yes|no'
    },
    value: {
      type: Boolean,
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    myItems() {
      const splittedItems = this.items.split('|');
      const items = [];
      let i = 0;

      if (splittedItems.length === 3) {
        items.push({
          text: splittedItems[i++],
          value: null
        });
      }

      items.push({
        text: splittedItems[i++],
        value: true
      }, {
        text: splittedItems[i++],
        value: false
      });
      return items;
    }

  }
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-select', _vm._b({
    attrs: {
      "value": _vm.value,
      "items": _vm.myItems,
      "label": _vm.label,
      "clearable": !_vm.isRequired
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'v-select', _vm.$attrs, false));
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = "data-v-15c83df4";
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var script$5 = {
  components: {
    VCol: VCol,
    VIcon: VIcon,
    VBtn: VBtn,
    VRow: VRow,
    VFileInput: VFileInput
  },
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    downloadFile: {
      type: Function,
      default: f => f
    },
    rules: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      resetIndex: 0,
      fileSelected: this.value != null,
      myValue: null,
      errors: []
    };
  },

  computed: {
    fileUploaded() {
      return this.value != null;
    }

  },
  methods: {
    change(event) {
      this.errors = applyRules({
        rules: this.rules
      }, {
        rules: event
      });

      if (this.errors === true) {
        this.myValue = event;
        this.fileSelected = event != null;
        this.$emit('addCallback', event);
      }
    },

    remove() {
      this.resetIndex++;
      this.fileSelected = false;
      this.$emit('removeCallback');
    },

    upload() {
      this.$refs.fileinput.$refs.input.click();
    },

    download() {
      if (this.value) {
        this.downloadFile(this.value);
      } else {
        const fileArray = this.myValue.name.split('.');
        downloadBlob(this.myValue, fileArray[0], fileArray[1]);
      }
    }

  }
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "component"
  }, [_c('div', {
    staticClass: "input",
    class: {
      'dense': 'dense' in _vm.$attrs,
      'b-error': _vm.errors.length > 0
    },
    on: {
      "click": _vm.upload
    }
  }, [_c('div', {
    staticClass: "custom-label",
    class: {
      'error--text': _vm.errors.length > 0
    }
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('v-row', [_vm.fileSelected ? _c('v-col', [_vm._v("\n        File uploaded\n      ")]) : _c('v-col', [_vm._v("\n        Upload a file\n      ")]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    staticClass: "buttons"
  }, [_c('v-col', {
    staticClass: "button",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.fileSelected ? _c('v-btn', {
    attrs: {
      "icon": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.remove.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("\n                mdi-close\n              ")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-col', {
    staticClass: "button",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.fileSelected ? _c('v-btn', {
    attrs: {
      "icon": "",
      "plain": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.download.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("\n                mdi-download\n              ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-file-input', _vm._b({
    key: _vm.resetIndex,
    ref: "fileinput",
    staticClass: "d-none",
    on: {
      "change": function ($event) {
        return _vm.change($event);
      }
    }
  }, 'v-file-input', _vm.$attrs, false))], 1)], 1)], 1), _vm._v(" "), !('hide-details' in _vm.$attrs) ? _c('div', {
    staticClass: "messages"
  }, [_vm.errors.length > 0 ? _c('div', {
    staticClass: "error--text v-messages"
  }, [_vm._v("\n      " + _vm._s(_vm.errors[0]) + "\n    ")]) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-250a6df4_0", {
    source: ".component[data-v-250a6df4]{display:flex;flex-direction:column;height:auto;flex-grow:1;flex-wrap:wrap;min-width:0;width:100%}.input[data-v-250a6df4]{position:relative;height:56px;padding-inline:12px;margin-bottom:8px;border:solid rgba(0,0,0,.42) 1px;border-radius:4px;cursor:pointer}.input.b-error[data-v-250a6df4]{border:solid #ff5252 2px}.input.dense[data-v-250a6df4]{height:40px;margin-bottom:4px}.components[data-v-250a6df4]{height:48px;padding:8px 0}.custom-label[data-v-250a6df4]{left:12px;right:auto;position:absolute;font-size:12px;color:rgba(0,0,0,.6);top:-7px;background-color:#fff;padding-inline:4px}.button[data-v-250a6df4]{padding:0}.buttons[data-v-250a6df4]{padding-inline:12px}.messages[data-v-250a6df4]{height:14px;margin:0 0 8px;padding:0 12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$5 = "data-v-250a6df4";
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

var script$4 = {
  components: {
    VCol: VCol,
    VRow: VRow
  },
  name: 'AraleTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: null
    },

    /**
     * Function to transform the input data into readonly data <br>
     * params: value, component, field
     */
    transform: {
      type: Function,
      default: v => v
    },

    /**
     * Function to upload the callbacks from AraleFileInput components<br>
     * params: file
     * @since 0.7.51
     */
    uploadCallback: {
      type: Function,
      default: file => {
        console.error('[Zapan Warn]: Couldn\'t upload the file, no upload function implemented');
      }
    },

    /**
     * Function to download the file<br>
     * params: fileId, fieldName
     * @since 0.7.51
     */
    downloadFile: {
      type: Function,
      default: (fileId, fieldName) => {
        console.error('[Zapan Warn]: Couldn\'t download the file: ' + fileId + ' in field: ' + fieldName + ', no download file function implemented');
      }
    },

    /**
     * Function to download the values from an URL<br>
     * params: url
     * @since 0.7.51
     */
    downloadValues: {
      type: Function,
      default: (url, field) => {
        console.error('[Zapan Warn]: Couldn\'t download the values from url: ' + url + ', no download values function implemented');
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    table() {
      const groupedRows = this.groupInRows();
      const groupedRowsArray = Object.entries(groupedRows);
      const orderedRows = groupedRowsArray.map(row => {
        return row[1].sort((a, b) => a.Properties.GroupColumn.localeCompare(b.Properties.GroupColumn));
      });
      return orderedRows;
    },

    titles() {
      return this.getTitles();
    },

    cols() {
      return 12 / this.titles.length;
    }

  },
  methods: {
    groupInRows() {
      return groupBy(this.items, 'Properties.GroupRow');
    },

    getTitles() {
      return [this.table[0][0].Properties.Group, ...this.table[0].map(col => col.Properties.GroupColumn)];
    },

    /**
     * Update data with new value
     */
    updateData(data, field) {
      const dataObj = {
        field,
        data
      };
      /**
      * input data updated with new value
      * @property {object} dataObj new data
      */

      this.$emit('input', dataObj);
    }

  }
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('v-row', _vm._l(_vm.titles, function (col, j) {
    return _c('v-col', {
      key: j,
      attrs: {
        "cols": _vm.cols
      }
    }, [_vm._v("\n      " + _vm._s(col) + "\n    ")]);
  }), 1), _vm._v(" "), _vm._l(_vm.table, function (row, i) {
    return _c('v-row', {
      key: i
    }, [_c('v-col', {
      attrs: {
        "cols": _vm.cols
      }
    }, [_vm._v("\n      " + _vm._s(row[0].Properties.GroupRow) + "\n    ")]), _vm._v(" "), _vm._l(row, function (field) {
      return _c('InputColumn', _vm._b({
        key: field.Name,
        attrs: {
          "value": _vm.value,
          "name": field.Name,
          "field": field,
          "cols": _vm.cols,
          "download-file": function (fileId) {
            return _vm.downloadFile(fileId, field.Name);
          },
          "download-values": function (url, field) {
            return _vm.downloadValues(url, field);
          },
          "transform": _vm.transform,
          "readonly": _vm.readonly
        },
        on: {
          "input": function ($event) {
            return _vm.updateData($event, field.Name);
          },
          "addCallback": function ($event) {
            return _vm.$emit('addCallback', $event);
          },
          "removeCallback": function ($event) {
            return _vm.$emit('removeCallback');
          }
        }
      }, 'InputColumn', _vm.$attrs, false));
    })], 2);
  })], 2);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = "data-v-3e929b18";
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$3 = {
  components: {
    TimePicker: __vue_component__$15
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    field: {
      type: Object,
      required: true
    }
  }
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('TimePicker', _vm._b({
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "alone": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, 'TimePicker', _vm.$attrs, false));
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = "data-v-2c37c8dc";
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

const araleComponents = {
  Select: __vue_component__$g,
  Multiselect: __vue_component__$f,
  Textarea: __vue_component__$e,
  Checkbox: __vue_component__$d,
  Text: __vue_component__$c,
  Number: __vue_component__$b,
  DateTime: __vue_component__$a,
  Date: __vue_component__$9,
  FileInput: __vue_component__$7,
  Time: __vue_component__$5
};
const defaultAraleComponents = {
  string: __vue_component__$c,
  Guid: __vue_component__$g,
  int: __vue_component__$b,
  double: __vue_component__$b,
  bool: __vue_component__$d,
  Date: __vue_component__$9,
  Time: __vue_component__$5,
  File: __vue_component__$7
};
const araleGroups = {
  Table: __vue_component__$6
};
var script$2 = {
  name: 'InputColumn',
  // Need only in prod
  components: {
    InfoChip: __vue_component__$11,
    VCol: VCol
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    field: {
      type: Object,
      required: true
    },
    cols: {
      type: [Object, Number, String, Function],
      required: true
    },
    extraAttrs: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    transform: {
      type: Function,
      default: v => v
    },
    downloadFile: {
      type: Function,
      default: f => f
    },
    downloadValues: {
      type: Function,
      default: f => f
    }
  },
  computed: {
    myValue() {
      if (this.type === __vue_component__$6) return this.value;

      if (this.value && this.value.Fields) {
        const myField = this.value.Fields[this.name];

        if (myField) {
          return myField.Value;
        }
      }

      return null;
    },

    valueReadonly() {
      return this.transform(this.myValue, this.type, this.field);
    },

    col() {
      if (this.type === __vue_component__$6) return {
        cols: 12
      };
      const col = typeof this.cols === 'function' ? this.cols(this.field) : this.cols;
      return typeof col === 'object' ? col : {
        cols: col
      };
    },

    label() {
      return this.extraAttrs.label || this.field.DisplayName || this.name;
    },

    prefix() {
      if (this.field.Properties && this.field.Properties.Prefix) {
        return this.field.Properties.Prefix;
      }

      return '';
    },

    suffix() {
      if (this.field.Properties && this.field.Properties.Suffix) {
        return this.field.Properties.Suffix;
      }

      return '';
    },

    type() {
      const component = araleComponents[this.field.Properties.InputType] || defaultAraleComponents[this.field.DataType] || araleGroups[this.field.Properties.GroupType];

      if (component !== __vue_component__$g) {
        return component;
      }

      return this.field.DataType === 'bool' ? __vue_component__$8 : __vue_component__$g;
    },

    typeAttrs() {
      const attrs = {};

      if (this.field.Properties) {
        if (this.field.Properties.MinValue) {
          attrs.min = this.field.Properties.MinValue;
        }

        if (this.field.Properties.MaxValue) {
          attrs.max = this.field.Properties.MaxValue;
        }
      }

      return attrs;
    },

    items() {
      if (this.field.Properties) {
        if (this.field.Properties.GroupType === 'Table' && this.field.fields) {
          return this.field.fields;
        }

        return this.field.Properties.Values;
      }

      return '';
    },

    fieldIsRequired() {
      return isTrueOrTrueString(this.field.IsRequired);
    },

    rules() {
      const rules = []; // TODO Used until rules included in RADON

      const fileRules = [];

      if (this.fieldIsRequired) {
        rules.push(isRequired());
      }

      if (this.field.MaxLength) {
        rules.push(charMax(this.field.MaxLength));
      }

      if (this.field.Properties) {
        if (this.field.Properties.MinValue) {
          rules.push(isGreatherOrEqualThan(this.field.Properties.MinValue));
        }

        if (this.field.Properties.MaxValue) {
          rules.push(isLessOrEqualThan(this.field.Properties.MaxValue));
        }

        if (this.field.Properties.FileSize) {
          fileRules.push(f => f.size <= this.field.Properties.FileSize || 'File too big');
        }

        if (this.field.Properties.FileFormat) {
          fileRules.push(f => this.field.Properties.FileFormat.split('|').includes(f.type) || 'Wrong file format');
        }
      }

      if (rules.length + fileRules.length > 0) {
        return [...validate(this.label, ...rules), ...fileRules];
      } else {
        return [];
      }
    },

    bind() {
      return { ...this.$attrs,
        ...this.typeAttrs,
        ...this.extraAttrs
      };
    },

    url() {
      return this.field.Properties.ValuesUrl || '';
    }

  },
  methods: {
    input(event) {
      this.$emit('input', event);
    }

  }
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-col', _vm._b({}, 'v-col', _vm.col, false), [_vm._t("default", function () {
    return [!_vm.readonly || _vm.type.name === 'AraleTable' ? _c(_vm.type, _vm._b({
      tag: "component",
      attrs: {
        "value": _vm.myValue,
        "prefix": _vm.prefix,
        "suffix": _vm.suffix,
        "label": _vm.label,
        "items": _vm.items,
        "url": _vm.url,
        "rules": _vm.rules,
        "field": _vm.field,
        "download-file": _vm.downloadFile,
        "download-values": _vm.downloadValues,
        "readonly": _vm.readonly,
        "is-required": _vm.fieldIsRequired,
        "transform": _vm.transform
      },
      on: {
        "input": _vm.input,
        "addCallback": function ($event) {
          return _vm.$emit('addCallback', $event);
        },
        "removeCallback": function ($event) {
          return _vm.$emit('removeCallback');
        }
      }
    }, 'component', _vm.bind, false)) : _c('InfoChip', _vm._b({
      attrs: {
        "label": _vm.label,
        "text": _vm.valueReadonly
      }
    }, 'InfoChip', _vm.bind, false))];
  }, {
    "value": _vm.myValue,
    "label": _vm.label,
    "input": _vm.input,
    "rules": _vm.rules,
    "bind": _vm.bind
  })], 2);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = "data-v-6506a802";
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

/**
   * Form autogenerated using an schema with custom components for each input type.
   *
   * Previously: LiquidModel (deprecated)
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/data-table/arale)
   * @displayName Arale
   * @author dcrespo
   * @author bponga
   * @since 0.7.22
   */

var script$1 = {
  components: {
    InputColumn: __vue_component__$4,
    VRow: VRow,
    VForm: VForm
  },
  props: {
    /**
     * Object with the value of the fields in the form
     */
    value: {
      type: Object,
      default: null
    },

    /**
     * Object with the value of each field in the form
     * @since 0.7.51
     */
    extraValues: {
      type: Object,
      default: () => ({})
    },

    /**
     * Object with all the input fields that can appear in the form with their atributes (name, possibleValues, dependencies with other fields, etc.)
     */
    schema: {
      type: Object,
      required: true
    },

    /**
     * Object with {cols, xs, sm, md, lg, xl} (all optionals).<br>
     * A number or string, as vuetify v-col <br>
     * A funcion with field as parameter and return the object or number.
     */
    cols: {
      type: [Object, Number, String, Function],
      default: 6
    },

    /**
     * Objct with extra attributes for specific fields.
     */
    extraAttrs: {
      type: Object,
      default: null
    },

    /**
     * Boolean to enable readonly version
     */
    readonly: {
      type: Boolean,
      default: false
    },

    /**
     * Function to transform the input data into readonly data <br>
     * params: value, component, field
     */
    transform: {
      type: Function,
      default: v => v
    },

    /**
     * Function to upload the callbacks from AraleFileInput components<br>
     * params: file
     * @since 0.7.51
     */
    uploadCallback: {
      type: Function,
      default: file => {
        console.error('[Zapan Warn]: Couldn\'t upload the file, no upload function implemented');
      }
    },

    /**
     * Function to download the file<br>
     * params: fileId, fieldName
     * @since 0.7.51
     */
    downloadFile: {
      type: Function,
      default: (fileId, fieldName) => {
        console.error('[Zapan Warn]: Couldn\'t download the file: ' + fileId + ' in field: ' + fieldName + ', no download file function implemented');
      }
    },

    /**
     * Function to download the values from an URL<br>
     * params: url
     * @return: array of strings, or array of objects containing 2 fields: "DisplayName" -> the label that will be shown in the component. "Id" -> the value stored when the item is selected.
     * @since 0.7.51
     */
    downloadValues: {
      type: Function,
      default: (url, field) => {
        /*
        //Aply specific transformations to some api results
        if(field.Name === "NameOfSpecificField") {
          const items = getFromApi(url)
          const parsedItems = specificlParseForThisField(items)
          return parsedItems
        }
        //No specific transformations needed if api return items in an standard format
        return getFromApi(url)
        */
        console.error('[Zapan Warn]: Couldn\'t download the values from url: ' + url + ', no download values function implemented');
      }
    }
  },

  data() {
    return {
      valid: false,
      originalValues: null,
      patchValues: null,
      callbacks: []
    };
  },

  watch: {
    valid(v) {
      /**
      * valid return validation of the form
      * @property {boolean} v new validation value
      */
      this.$emit('valid', v);
    }

  },
  computed: {
    visibleFields() {
      if (this.schema.Fields) {
        const missingFields = new Set();
        const fields = pickBy(this.schema.Fields, f => {
          if (f.Properties.Display === 'false') return false;

          if (f.Properties.DisplayIfField) {
            const display = f.Properties.DisplayIfField.split('|').map(ff => {
              let myField = this.extraValues[ff];
              if (!myField && this.value && this.value.Fields) myField = this.value.Fields[ff];

              if (!myField) {
                // exist into schema?
                if (!this.schema.Fields[ff]) {
                  missingFields.add(ff);
                }

                return false;
              }

              return this.hasValue(f.Properties.DisplayIfValues.split('|'), myField.Value);
            });
            if (!display.includes(true)) return false;
          }

          return true;
        });
        const asArray = Object.entries(fields);
        const groups = asArray.filter(([key, value]) => {
          if (!value.Properties) return false;
          return !!value.Properties.Group;
        });
        const nonGroups = asArray.filter(([key, value]) => {
          if (!value.Properties) return true;
          return !value.Properties.Group;
        });
        const groupsObjects = groups.map(field => field[1]);
        const groupedGroups = groupBy(groupsObjects, 'Properties.Group');
        const keys = Object.keys(groupedGroups);
        const formatedGroups = {};

        for (const key of keys) {
          formatedGroups[key] = {
            fields: groupedGroups[key],
            DisplayOrder: groupedGroups[key][0].DisplayOrder,
            Name: groupedGroups[key][0].Name,
            Properties: {
              GroupType: groupedGroups[key][0].Properties.GroupType
            }
          };
        }

        const formatedNonGroups = {};
        nonGroups.forEach(field => {
          formatedNonGroups[field[0]] = field[1];
        });
        const formatedFields = { ...formatedNonGroups,
          ...formatedGroups
        };
        const arrayMissing = Array.from(missingFields).sort();

        for (const field of arrayMissing) {
          console.error('[Zapan warn]: The field: ' + field + ' doesn\'t exist, check that it is included in the schema data!');
        } // Remove data that is not being shown


        if (this.value) {
          const dataKeys = Object.keys(this.value.Fields);
          const actives = Object.values(fields).map(f => f.Name);
          const remove = dataKeys.filter(x => !actives.includes(x));
          remove.forEach(x => {
            this.removeField(x);
          });
        }

        return Object.values(formatedFields).sort((a, b) => {
          return a.DisplayOrder - b.DisplayOrder;
        });
      } else {
        return [];
      }
    },

    colsComputed() {
      let cols = this.cols;

      if (typeof this.cols === 'object') {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            cols = cols.xs;
            break;

          case 'sm':
            cols = cols.sm;
            break;

          case 'md':
            cols = cols.md;
            break;

          case 'lg':
            cols = cols.lg;
            break;

          case 'xl':
            cols = cols.xl;
            break;
        }

        if (cols === undefined) {
          cols = this.cols.cols;
        }
      }

      if (this.visibleFields.length * cols < 12) {
        return Math.trunc(12 / this.visibleFields.length);
      } else {
        return cols;
      }
    }

  },

  created() {
    this.originalValues = this.value ? cloneDeep(this.value) : {
      Fields: {}
    };
    this.setPatchValues(this.originalValues);
  },

  mounted() {
    // Set all checkbox required to false
    const dataObj = this.value ? cloneDeep(this.value) : {
      Fields: {}
    };

    for (const key in this.schema.Fields) {
      const field = this.schema.Fields[key];

      if (field.DataType === 'bool' && isTrueOrTrueString(field.IsRequired)) {
        dataObj.Fields[key] = {
          Value: false
        };
      }
    }
    /**
      * input checkbox data set to false
      * @property {object} dataObj values object
      */


    this.$emit('input', dataObj);
  },

  methods: {
    /**
     * Update data with new value
     */
    updateData(data, field) {
      const dataObj = this.value ? cloneDeep(this.value) : {
        Fields: {}
      };

      if (data && data.field) {
        dataObj.Fields[data.field] = {
          Value: data.data
        };
      } else {
        dataObj.Fields[field] = {
          Value: data
        };
      }
      /**
      * input data updated with new value
      * @property {object} dataObj new data
      */


      this.$emit('input', dataObj);
      this.setPatchValues(dataObj);
    },

    /**
     * Remove field from data
     * @since 0.7.51
     */
    removeField(field) {
      const dataObj = this.value ? cloneDeep(this.value) : {
        Fields: {}
      };
      delete dataObj.Fields[field];
      /**
      * input data updated without the field selected
      * @property {object} dataObj new data
      */

      this.$emit('input', dataObj);
      this.setPatchValues(dataObj);
    },

    /**
     * Patch all data with new values, if new values empty, fill with original values
     */
    setPatchValues(data) {
      const patchFields = {};

      for (const key in data.Fields) {
        const fieldValue = data.Fields[key].Value;

        if (!this.originalValues.Fields[key] || this.originalValues.Fields[key].Value !== fieldValue) {
          patchFields[key] = {
            Value: fieldValue
          };
        }
      }
      /**
      * patch data, if it is empty, use original values
      * @property {object} patchFields fields patched
      */


      this.$emit('patch', {
        Fields: patchFields
      });
    },

    /**
     * Remove the previous callback from the selected field if existed, and then add the new one
     */
    addCallback(file, fieldName) {
      this.removeCallback(fieldName);
      this.callbacks.push({
        file: file,
        fieldName: fieldName
      });
    },

    /**
     * Remove the callback from the selected field
     */
    removeCallback(fieldName) {
      this.callbacks = this.callbacks.filter(c => {
        return c.fieldName !== fieldName;
      });
    },

    /**
     * Uploads all the files before saving the form
     * @public
     * @since 0.7.51
     */
    async preSave() {
      const promises = [];

      for (const callback of this.callbacks) {
        const aux = async () => {
          const id = this.uploadCallback(callback.file);
          this.updateData(id, callback.fieldName);
        };

        promises.push(aux());
      }

      await Promise.all(promises);
    },

    hasValue(values, value) {
      if (Array.isArray(value)) {
        if (!values.some(v => value.includes(v))) {
          return false;
        }
      }

      if (typeof value === 'boolean') {
        if (!values.includes(value.toString())) {
          return false;
        }
      } else if (!values.includes(value)) {
        return false;
      }

      return true;
    }

  }
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-form', {
    ref: "form",
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', _vm._l(_vm.visibleFields, function (field) {
    return _c('InputColumn', _vm._b({
      key: field.Name,
      attrs: {
        "value": _vm.value,
        "name": field.Name,
        "field": field,
        "cols": _vm.colsComputed,
        "extra-attrs": _vm.extraAttrs ? _vm.extraAttrs[field.Name] : undefined,
        "download-file": function (fileId) {
          return _vm.downloadFile(fileId, field.Name);
        },
        "download-values": function (url, field) {
          return _vm.downloadValues(url, field);
        },
        "readonly": _vm.readonly,
        "transform": _vm.transform
      },
      on: {
        "input": function ($event) {
          return _vm.updateData($event, field.Name);
        },
        "addCallback": function ($event) {
          return _vm.addCallback($event, field.Name);
        },
        "removeCallback": function ($event) {
          return _vm.removeCallback(field.Name);
        }
      },
      scopedSlots: _vm._u([!_vm.readonly && _vm.$scopedSlots[field.Name] ? {
        key: "default",
        fn: function (data) {
          return [_vm._e(), _vm._v(" "), _vm._t(field.Name, null, null, data)];
        }
      } : _vm.readonly && _vm.$scopedSlots["readonly." + field.Name] ? {
        key: "default",
        fn: function (data) {
          return [_vm._e(), _vm._v(" "), _vm._t("readonly." + field.Name, null, null, data)];
        }
      } : null], null, true)
    }, 'InputColumn', _vm.$attrs, false));
  }), 1)], 1);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = "data-v-0b72888c";
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

var __vue_component__$3 = __vue_component__$2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
   * Nested menu using Vuetify v-menu
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/nested-menu)
   * @displayName NestedMenu
   * @author dcrespo
   * @since 0.7.46
   */

var script = {
  components: {
    VIcon: VIcon,
    VListItem: VListItem,
    VDivider: VDivider,
    VListItemTitle: VListItemTitle,
    VList: VList,
    VMenu: VMenu
  },
  props: {
    /**
     * @ignore internal use
     */
    item: {
      type: Object,
      default: null
    },

    /**
     * Menu items array. Check the structure [here](#nestedmenuitems)
     */
    menuItems: {
      type: Array,
      required: true
    },

    /**
     * Props for all menus.
     * If you want change an specific menu use menuAttrs property in menuItems object,
     * that override this attrs.
     * @since 0.7.53
     */
    menuAttrs: {
      type: Object,
      default: () => ({})
    },

    /**
     * Opened by default
     * @since 0.7.52
     */
    defaultOpen: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.openMenu = this.defaultOpen;
  },

  computed: {
    attrs() {
      const attrs = this.item ? this.item.menuAttrs : {};
      return { ...this.$attrs,
        ...this.menuAttrs,
        ...attrs
      };
    }

  },
  methods: {
    doAction(item) {
      item.action(item);
      this.close();
    },

    close() {
      this.openMenu = false;
      /**
       * Emits when submenu is closed. Internal usage.
       */

      this.$emit('close');
    }

  },
  data: () => ({
    openMenu: false
  })
};

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('v-menu', _vm._b({
    attrs: {
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var on = ref.on;
        return [_vm._e(), _vm._v(" "), _vm.item ? _vm._t(_vm.item.key || 'submenu', function () {
          return [_c('v-list-item', _vm._g({
            staticClass: "d-flex justify-space-between"
          }, on), [_vm._v("\n        " + _vm._s(_vm.item.text)), _c('div', {
            staticClass: "flex-grow-1"
          }), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)];
        }, {
          "item": _vm.item,
          "close": _vm.close,
          "on": on
        }) : _vm._t("activator", null, {
          "on": on
        })];
      }
    }], null, true),
    model: {
      value: _vm.openMenu,
      callback: function ($$v) {
        _vm.openMenu = $$v;
      },
      expression: "openMenu"
    }
  }, 'v-menu', _vm.attrs, false), [_vm._v(" "), _c('v-list', [_vm._l(_vm.menuItems, function (subitem, index) {
    return [subitem.isDivider ? _c('v-divider', {
      key: index
    }) : subitem.menu ? _c('NestedMenu', {
      key: index,
      attrs: {
        "item": subitem,
        "menu-items": subitem.menu,
        "is-open-on-hover": false,
        "offset-x": true,
        "offset-y": false,
        "menu-attrs": _vm.menuAttrs
      },
      on: {
        "close": _vm.close
      },
      scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (indexSlot, name) {
        return {
          key: name,
          fn: function (data) {
            return [_vm._t(name, null, null, data)];
          }
        };
      })], null, true)
    }) : _vm._e(), _vm._v(" "), _vm._e(), _vm._v(" "), !subitem.menu ? _vm._t(subitem.key || 'item', function () {
      return [_c('v-list-item', {
        key: index,
        on: {
          "click": function ($event) {
            return _vm.doAction(subitem);
          }
        }
      }, [_c('v-list-item-title', [_vm._v(_vm._s(subitem.text))])], 1)];
    }, {
      "item": subitem,
      "close": _vm.close
    }) : _vm._e()];
  })], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = "data-v-092e44c2";
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

var __vue_component__$1 = __vue_component__;

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ColorPicker: __vue_component__$1E,
  ColorIconPicker: __vue_component__$1C,
  ImagePicker: __vue_component__$1A,
  IconPicker: __vue_component__$1y,
  SearchableList: __vue_component__$1v,
  BorderedCard: __vue_component__$1t,
  DataTableFilter: DataTableFilter,
  ContentBox: __vue_component__$1i,
  SectionTitleBar: __vue_component__$1g,
  FileDragAndDrop: __vue_component__$1e,
  MainNavigation: __vue_component__$18,
  DatePicker: __vue_component__$16,
  TimePicker: __vue_component__$15,
  DataTable: __vue_component__$Z,
  Grid: Table,
  ColumnSelector: ColumnSelector,
  InfoChip: __vue_component__$11,
  CustomerMerge: __vue_component__$R,
  LayerList: __vue_component__$P,
  LayerFinder: __vue_component__$K,
  ArcGISService: ArcGISService,
  OGCService: OGCService,
  DownloadFile: __vue_component__$I,
  SectionComments: __vue_component__$F,
  LocationInputWrapper: __vue_component__$D,
  LatitudeField: __vue_component__$B,
  LongitudeField: __vue_component__$B,
  LocationTypeSelector: __vue_component__$z,
  TreeGraph: __vue_component__$w,
  FeaturesFilter: __vue_component__$q,
  PersonMerge: __vue_component__$k,
  ScrollableStepHeader: __vue_component__$i,
  LiquidModel: __vue_component__$3,
  Arale: __vue_component__$3,
  NestedMenu: __vue_component__$1
});

/**
   * Emit when alt-tab is pressed while focus is on the component.<br>
   * Accept the following modifiers<br>
   * `prevent`<br>
   * `stop`<br>
   * `once`<br>
   *
   * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/alt-tab)
   * @displayName v-alt-tab
   * @author dcrespo
   * @since 0.6.39
   */
var AltTab = {
  bind(el, {
    value,
    modifiers
  }) {
    const evt = function (event) {
      if (event.shiftKey && event.key === 'Tab') {
        if (modifiers.prevent) event.preventDefault();
        if (modifiers.stop) event.stopPropagation();
        if (modifiers.once) el.removeEventListener('keydown', evt);
        value();
      }
    };

    el.addEventListener('keydown', evt);
  }

};

/**
 * Set focus to element when value change from falsy to truthy
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/focus-when)
 * @displayName v-focus-when
 * @author dcrespo
 * @since 0.6.39
 */
var FocusWhen = {
  update(el, {
    value,
    oldValue
  }) {
    if (!oldValue && value) {
      if (['BUTTON', 'A', 'INPUT', 'SELECT', 'TEXTAREA'].includes(el.nodeName)) {
        el.focus();
      } else {
        const element = el.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

        if (element) {
          element.focus();
        } else {
          el.focus();
        }
      }
    }
  }

};

// https://www.npmjs.com/package//inputmask
/**
 * Allow use [inputmask](https://www.npmjs.com/package//inputmask)
 * with vue. You can pass a string mask as parameter or
 * a complete inputmask object.
 *
 * [Check in Playground](https://sandbox.technosylva.com/zapanplayground/input-mask)
 * @displayName v-input-mask
 * @author dcrespo
 * @since 0.6.41
 */

var InputMask = {
  update(el, {
    value,
    oldValue,
    expression,
    arg,
    modifiers
  }, vnode) {
    let input;
    if (el.tagName === 'INPUT') input = el;else input = el.querySelector('input');
    if (input.inputmask && isEqual(value, oldValue)) return;

    if (typeof value === 'string') {
      value = {
        mask: value
      };
    }

    const mask = new Inputmask({ ...value
    });
    mask.mask(input); // @maskValid event

    input.addEventListener('input', event => {
      const maskValid = Inputmask.isValid(input.value, value);

      if (el.maskValid !== maskValid) {
        vnode.child.$emit('maskValid', maskValid ? input.value : null);
        el.maskValid = maskValid;
      }
    });
  }

};

var directives = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AltTab: AltTab,
  FocusWhen: FocusWhen,
  InputMask: InputMask
});

// Import vue components

const install = function installZapan(Vue, parameters) {
  if (parameters) {
    if (parameters.locale) {
      window.__ZAPAN_I18N_LOCALE = parameters.locale;
    }
  }

  Vue.component('InputColumn', __vue_component__$4);
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
  Object.entries(directives).forEach(([directiveName, directive]) => {
    Vue.directive(directiveName, directive);
  });
}; // Create module definition for Vue.use()

export { AltTab, __vue_component__$3 as Arale, ArcGISService, __vue_component__$1t as BorderedCard, __vue_component__$1C as ColorIconPicker, __vue_component__$1E as ColorPicker, ColumnSelector, __vue_component__$1i as ContentBox, __vue_component__$R as CustomerMerge, __vue_component__$Z as DataTable, DataTableFilter, __vue_component__$16 as DatePicker, __vue_component__$I as DownloadFile, __vue_component__$q as FeaturesFilter, __vue_component__$1e as FileDragAndDrop, FocusWhen, Table as Grid, __vue_component__$1y as IconPicker, __vue_component__$1A as ImagePicker, __vue_component__$11 as InfoChip, InputMask, __vue_component__$B as LatitudeField, __vue_component__$K as LayerFinder, __vue_component__$P as LayerList, __vue_component__$3 as LiquidModel, __vue_component__$D as LocationInputWrapper, __vue_component__$z as LocationTypeSelector, __vue_component__$B as LongitudeField, __vue_component__$18 as MainNavigation, __vue_component__$1 as NestedMenu, OGCService, __vue_component__$k as PersonMerge, QueryBuilder, __vue_component__$i as ScrollableStepHeader, __vue_component__$1v as SearchableList, __vue_component__$F as SectionComments, __vue_component__$1g as SectionTitleBar, __vue_component__$15 as TimePicker, __vue_component__$w as TreeGraph, install as default };
//# sourceMappingURL=zapan.esm.js.map
